<template>
  <div>
    <ServerError v-if="ServerError" />
    <PageLoader :storage="appLoading" />
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center pa-3>
      <v-flex xs12>
        <v-layout wrap justify-start>
          <v-flex xs12>
            <span class="itemHeading1">Report Daily Rescue Case</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center pt-3>
          <v-flex xs12 lg7 pr-3>
            <v-tabs v-model="activeTab" background-color="transparent" color="primary" grow>
              <v-tab>Basic Details</v-tab>
              <v-tab>Response Team</v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
              <v-tab-item>
                <v-layout wrap justify-center pt-3>
                  <v-flex xs12>
                    <v-text-field outlined append-icon="mdi-magnify" append-outer-icon="mdi-close" label="Location Name"
                      placeholder="Enter Location Name" v-model="locationname" @click:append="plotLocation"
                      @click:append-outer="resetMap" class="itemform" :loading="locationLoading" dense
                      @input="markAsDirty"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4 lg4>
                    <v-autocomplete outlined label="Division Name" :items="divisionList" v-model="divisionname"
                      item-text="divisionName" item-value="divisionName" class="itemform"
                      @change="getRangeData(), markAsDirty()" dense>
                      <template v-slot:append-item>
                        <div v-intersect="onDivisionIntersect" class="text-center"
                          v-if="divisionPage < divisionTotalPages">
                          <v-progress-circular indeterminate size="24" color="primary"
                            class="ma-2"></v-progress-circular>
                        </div>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm4 md4 lg4 pl-lg-2 pl-md-2 pl-sm-2>
                    <v-autocomplete outlined label="Range Name" :items="rangeList" v-model="rangename"
                      item-text="rangeName" item-value="rangeName" class="itemform" @change="markAsDirty()" dense>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm4 md4 lg4 pl-lg-2 pl-md-2 pl-sm-2>
                    <!-- <v-text-field outlined label="Section/Station" v-model="sectionStation" class="itemform"
                  dense @input="markAsDirty()"></v-text-field> -->
                    <v-autocomplete :items="SectionData" label="Section/Station" item-text="name" item-value="name"
                      v-model="sectionStation" outlined dense class="itemform" @change="markAsDirty"></v-autocomplete>
                  </v-flex>
                  <!-- <v-flex xs12 md4 sm4 lg4>
                <v-text-field outlined label="District" v-model="reportdistrict" disabled class="itemform"
                  dense></v-text-field>
              </v-flex> -->
                  <v-flex xs12 md4 sm4 lg4>
                    <v-select :items="districts" label="District" item-text="District Name" item-value="District ID"
                      v-model="selectedDistrict" outlined dense class="itemform"
                      @change="onDistrictChange(), markAsDirty()"></v-select>
                  </v-flex>
                  <v-flex xs12 md4 sm4 lg4 pl-lg-2 pl-md-2 pl-sm-2>
                    <v-text-field outlined label="Latitude" v-model="lattitude" class="itemform"
                      :loading="locationLoading" dense @input="markAsDirty()">
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" small color="primary">mdi-information-outline</v-icon>
                          </template>
                          <span>Format: Degrees, Minutes, Seconds (e.g. 10° 30' 45" N) or Decimal</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm4 lg4 pl-lg-2 pl-md-2 pl-sm-2>
                    <v-text-field outlined label="Longitude" v-model="longitude" class="itemform"
                      :loading="locationLoading" dense @input="markAsDirty()">
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" small color="primary">mdi-information-outline</v-icon>
                          </template>
                          <span>Format: Degrees, Minutes, Seconds (e.g. 76° 15' 30" E) or Decimal</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6 lg6>
                    <!-- <v-text-field outlined label="Village" v-model="village" class="itemform" dense @input="markAsDirty()"></v-text-field> -->
                    <v-autocomplete :items="villageData" label="Village" item-text="village_name"
                      item-value="village_name" v-model="village" outlined dense class="itemform"
                      @change="markAsDirty"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md6 lg6 pl-lg-2 pl-md-2 pl-sm-2>
                    <!-- <v-text-field outlined label="Taluk" v-model="taluk" class="itemform" dense @input="markAsDirty"></v-text-field> -->
                    <v-autocomplete :items="talukaData" label="Taluk" item-text="taluka_name" item-value="taluka_name"
                      v-model="taluk" outlined dense class="itemform" @change="markAsDirty"></v-autocomplete>
                  </v-flex>

                  <v-flex xs12>
                    <v-select :items="['Panchayat', 'Municipality', 'Corporation']" label="Choose Local Body"
                      v-model="localBodyType" outlined dense class="itemform" @change="onLocalBodyTypeChange"
                      :rules="Rules"></v-select>
                  </v-flex>
                  <v-flex xs12 md4 sm4 lg4>
                    <v-autocomplete
                      :items="localBodyType === 'Panchayat' ? filteredPanchayats : (localBodyType === 'Municipality' ? Municipality : (localBodyType === 'Corporation' ? corporation : []))"
                      :label="localBodyType || 'Local Body Name'" item-text="name" item-value="name"
                      v-model="selectedPanchayat" outlined dense class="itemform"
                      :disabled="!localBodyType || (localBodyType === 'Panchayat' && !selectedDistrict)"
                      @change="markAsDirty" :rules="Rules"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md4 sm4 lg4 pl-lg-2 pl-md-2 pl-sm-2>
                    <v-autocomplete :items="filteredAssemblies" label="LA Constituency" item-text="name"
                      item-value="name" v-model="selectedAssembly" outlined dense class="itemform"
                      :disabled="localBodyType === 'Panchayat' && !selectedDistrict"
                      @change="markAsDirty"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md4 sm4 lg4 pl-lg-2 pl-md-2 pl-sm-2>
                    <v-autocomplete :items="filteredConstituencies" label="Parliament Constituency" item-text="name"
                      item-value="name" v-model="selectedConstituency" outlined dense class="itemform"
                      :disabled="localBodyType === 'Panchayat' && !selectedDistrict"
                      @change="markAsDirty"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6 sm6 lg6>
                    <v-menu ref="dateMenu" v-model="dateMenu" :close-on-content-click="false"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="formatDate(incidentDate)" label="Incident Date" append-icon="mdi-calendar"
                          readonly v-bind="attrs" v-on="on" outlined dense class="itemform"
                          @input="markAsDirty"></v-text-field>
                      </template>
                      <v-date-picker v-model="incidentDate" @input="dateMenu = false" :max="today"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md6 sm6 lg6 pl-lg-2 pl-md-2 pl-sm-2>
                    <v-text-field v-model="incidentTime" label="Incident Time" type="time" outlined dense
                      class="itemform" @input="markAsDirty"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm4 lg4>
                    <v-select :items="animalTypes" label="Type Of Animal" item-text="name" item-value="_id" outlined
                      v-model="animaltype" class="itemform" dense @change="markAsDirty"></v-select>
                  </v-flex>
                  <v-flex xs12 md4 sm4 lg4 pl-lg-2 pl-md-2 pl-sm-2>
                    <v-text-field outlined label="Number of animals involved" v-model="animalCount"
                      class="itemform inputPrice" dense type="number" @input="markAsDirty"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm4 lg4 pl-lg-2 pl-md-2 pl-sm-2>
                    <v-select :items="threatLevels" label="Threat Level" outlined v-model="threatlevel" class="itemform"
                      dense @change="markAsDirty"></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select :items="['Yes', 'No', 'Unverified incident']" label="Is there any damage?" outlined
                      v-model="anyDamage" class="itemform" dense @change="markAsDirty"></v-select>
                  </v-flex>
                  <v-flex xs12 v-if="anyDamage === 'Yes' || anyDamage === 'Unverified incident'">
                    <v-select :items="ConflictTypes" label="Type of Conflict" outlined item-text="name" item-value="_id"
                      multiple v-model="ConflictType" class="itemform" dense @change="markAsDirty"></v-select>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12 v-if="isCropDamageSelected">
                    <v-layout wrap justify-start pb-2>
                      <v-flex xs12 align-self-center>
                        <span class="itemform">Crop Details</span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-center>
                      <v-flex xs12 pt-2>
                        <!-- <v-text-field outlined label="Incident Title" placeholder="Enter Incident Title" v-model="cropTitle"
                      class="itemform" dense></v-text-field> -->
                      </v-flex>
                      <v-flex xs12 pt-2>
                        <v-layout wrap justify-center v-for="(step, index) in cropTypedetails" :key="index">
                          <v-flex xs12 sm3 md3 lg4>
                            <v-select :items="Typeofcrops" label="Type of crop" outlined item-text="name"
                              item-value="_id" v-model="step.cropId" class="itemform" dense
                              @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg4 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-text-field outlined label="Extent or number damaged"
                              placeholder="Enter Extent or number damaged" v-model="step.count"
                              class="itemform inputPrice" type="number" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg2 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-select :items="Unitsofcrops" label="Units" outlined v-model="step.unit" class="itemform"
                              dense @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg2 pl-lg-2 pl-md-2 pl-sm-2 pt-1>
                            <span v-if="cropTypedetails.length > 1">
                              <v-btn small plain @click="removeCropDetail(index)" color="error" class="itemform" dense>
                                <span>Remove</span><span><v-icon small>mdi-delete</v-icon></span>
                              </v-btn>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout wrap justify-end>
                          <v-flex xs12 sm3 md3 lg3>
                            <v-btn small plain @click="addCropDetail" color="primary">
                              <span><v-icon small>mdi-plus</v-icon></span><span>ADD More</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-if="isPropertyDamageSelected">
                    <v-layout wrap justify-start pb-2>
                      <v-flex xs12 align-self-center>
                        <span class="itemform">Property Details</span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-center>
                      <v-flex xs12 pt-2>
                        <!-- <v-text-field outlined label="Incident Title" placeholder="Enter Incident Title"
                      v-model="propertyTitle" class="itemform" dense></v-text-field> -->
                      </v-flex>
                      <v-flex xs12 pt-2>
                        <v-layout wrap justify-center v-for="(step, index) in propertyTypedetails" :key="index">
                          <v-flex xs12 sm4 md4 lg3>
                            <v-text-field outlined label="Type of property" placeholder="Enter Type of property"
                              v-model="step.propertyType" class="itemform" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm4 md4 lg7 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-textarea outlined name="input-7-4" label="Details of damage" v-model="step.damageDetail"
                              class="itemform" dense @input="markAsDirty"></v-textarea>
                          </v-flex>
                          <v-flex xs12 sm4 md4 lg2 pl-lg-2 pl-md-2 pl-sm-2 pt-1>
                            <span v-if="propertyTypedetails.length > 1">
                              <v-btn small plain @click="removePropertyDetail(index)" color="error" class="itemform"
                                dense>
                                <span>Remove</span><span><v-icon small>mdi-delete</v-icon></span>
                              </v-btn>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout wrap justify-end>
                          <v-flex xs12 sm3 md3 lg3>
                            <v-btn small plain @click="addPropertyDetail" color="primary">
                              <span><v-icon small>mdi-plus</v-icon></span><span>ADD More</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-if="isHumanInjurySelected">
                    <v-layout wrap justify-center>
                      <v-flex xs12 align-self-center pb-1>
                        <span class="itemform">Injured People Details</span>
                      </v-flex>
                      <v-flex xs12 pt-2>
                        <!-- <v-text-field outlined label="Incident Title" placeholder="Enter Incident Title"
                      v-model="humanInjuryTitle" class="itemform" dense></v-text-field> -->
                      </v-flex>
                      <v-flex xs12 pt-2>
                        <v-text-field outlined label="Number of people Injured"
                          placeholder="Enter Number of people Injured" v-model="nopeopleinjured" type="number"
                          class="inputPrice itemform" dense @input="markAsDirty"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-center>
                      <v-flex xs12>
                        <v-layout wrap justify-center v-for="(person, index) in injuredPeople" :key="index">
                          <v-flex xs12 sm1 md1 lg1 class="text-center" pt-4>
                            <span>{{ index + 1 }}.</span>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg3 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-text-field outlined label="Name of the person" placeholder="Enter Name of the person"
                              v-model="person.name" class="itemform" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm1 md1 lg1 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-text-field outlined label="Age" placeholder="Age" v-model="person.age" type="number"
                              class="inputPrice itemform" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm2 md2 lg2 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-select :items="persongender" label="Gender" outlined v-model="person.gender"
                              class="itemform" dense @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm2 md2 lg2 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-text-field outlined label="Type of injury" placeholder="Enter Type of injury"
                              v-model="person.injuryType" class="itemform" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg3 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-select :items="WhetherHospitalized" label="Whether Hospitalized?" outlined
                              v-model="person.hospitalized" class="itemform" dense @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg3 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-select :items="['Yes', 'No']" label="Whether tribe?" outlined v-model="person.isTribe"
                              class="itemform" dense @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg3 pl-lg-2 pl-md-2 pl-sm-2 v-if="person.isTribe === 'Yes'">
                            <v-text-field outlined label="Community" placeholder="Enter Community"
                              v-model="person.community" class="itemform" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg3 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-select :items="['Inside', 'Outside']" label="Whether inside or outside the forest?"
                              outlined v-model="person.forestLocation" class="itemform" dense
                              @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg3 pl-lg-2 pl-md-2 pl-sm-2 v-if="person.forestLocation === 'Inside'">
                            <v-text-field outlined label="Name of RF" placeholder="Enter Name of RF"
                              v-model="person.rfName" class="itemform" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <!-- <v-flex xs12 sm1 md1 lg1 pl-lg-2 pl-md-2 pl-sm-2 pt-4>
                        <v-btn small plain @click="removeInjuredPerson(index)" color="error" class="itemform" dense>
                          <span>Remove</span><span><v-icon small>mdi-delete</v-icon></span>
                        </v-btn>
                      </v-flex> -->
                        </v-layout>
                      </v-flex>
                      <!-- <v-flex xs12>
                    <v-layout wrap justify-end>
                      <v-flex xs12 sm3 md3 lg3>
                        <v-btn small plain @click="addInjuredPerson" color="primary">
                          <span><v-icon small>mdi-plus</v-icon></span><span>ADD Person</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex> -->
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-if="isHumanDeathSelected">
                    <v-layout wrap justify-center>
                      <v-flex xs12 align-self-center pb-1>
                        <span class="itemform">Details Of People Died</span>
                      </v-flex>
                      <v-flex xs12 pt-2>
                        <!-- <v-text-field outlined label="Incident Title" placeholder="Enter Incident Title"
                      v-model="humanDeathTitle" class="itemform" dense></v-text-field> -->
                      </v-flex>
                      <v-flex xs12 pt-2>
                        <v-text-field outlined label="Number of people Died" placeholder="Enter Number of people Died"
                          v-model="nopeopledied" type="number" class="inputPrice itemform" dense
                          @input="markAsDirty"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-center>
                      <v-flex xs12>
                        <v-layout wrap justify-center v-for="(person, index) in peopleDead" :key="index">
                          <v-flex xs12 sm1 md1 lg1 class="text-center" pt-4>
                            <span>{{ index + 1 }}.</span>
                          </v-flex>
                          <v-flex xs12 sm4 md4 lg4>
                            <v-text-field outlined label="Name of the person" placeholder="Enter Name"
                              v-model="person.name" class="itemform" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm2 md2 lg2 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-text-field outlined label="Age" placeholder="Enter Age" v-model="person.age"
                              type="number" class="inputPrice itemform" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm2 md2 lg2 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-select :items="persongender" label="Gender" outlined v-model="person.gender"
                              class="itemform" dense @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg3 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-select :items="['Yes', 'No']" label="Whether tribe?" outlined v-model="person.isTribe"
                              class="itemform" dense @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg3 pl-lg-2 pl-md-2 pl-sm-2 v-if="person.isTribe === 'Yes'">
                            <v-text-field outlined label="Community" placeholder="Enter Community"
                              v-model="person.community" class="itemform" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg3 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-select :items="['Inside', 'Outside']" label="Whether inside or outside the forest?"
                              outlined v-model="person.forestLocation" class="itemform" dense
                              @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg3 pl-lg-2 pl-md-2 pl-sm-2 v-if="person.forestLocation === 'Inside'">
                            <v-text-field outlined label="Name of RF" placeholder="Enter Name of RF"
                              v-model="person.rfName" class="itemform" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <!-- <v-flex xs12 sm1 md1 lg1 pl-lg-2 pl-md-2 pl-sm-2 pt-4>
                        <v-btn small plain @click="removeDeadPerson(index)" color="error" class="itemform" dense>
                          <span>Remove</span><span><v-icon small>mdi-delete</v-icon></span>
                        </v-btn>
                      </v-flex> -->
                        </v-layout>
                      </v-flex>
                      <!-- <v-flex xs12>
                    <v-layout wrap justify-end>
                      <v-flex xs12 sm3 md3 lg3>
                        <v-btn small plain @click="addDeadPerson" color="primary">
                          <span><v-icon small>mdi-plus</v-icon></span><span>ADD Person</span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex> -->
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-if="isAnimalInjurySelected">
                    <v-layout wrap justify-center>
                      <v-flex xs12 align-self-center pb-1>
                        <span class="itemform">Details Of Animal Injured</span>
                      </v-flex>
                      <v-flex xs12 pt-2>
                        <!-- <v-text-field outlined label="Incident Title" placeholder="Enter Incident Title"
                      v-model="animalInjuryTitle" class="itemform" dense></v-text-field> -->
                      </v-flex>
                      <v-flex xs12 sm6 md6 lg6 pt-2>
                        <v-text-field outlined label="Number of animals injured"
                          placeholder="Enter Number of animals injured" type="number" class="inputPrice itemform" dense
                          v-model="animalInjuryDetails.injuredNumber" @input="markAsDirty"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6 lg6 pl-lg-2 pl-md-2 pl-sm-2 pt-2>
                        <v-text-field outlined label="Type of injury" placeholder="Enter Type of injury"
                          v-model="animalInjuryDetails.typeOfInjury" class="itemform" dense
                          @input="markAsDirty"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-if="isAnimalDeathSelected">
                    <v-layout wrap justify-center>
                      <v-flex xs12 align-self-center pb-1>
                        <span class="itemform">Details Of Animal Died</span>
                      </v-flex>
                      <v-flex xs12 pt-2>
                        <!-- <v-text-field outlined label="Incident Title" placeholder="Enter Incident Title"
                      v-model="animalDeathTitle" class="itemform" dense></v-text-field> -->
                      </v-flex>
                      <!-- <v-flex xs12 pt-2>
                    <v-text-field outlined label="Number of animals died" placeholder="Enter Number of animals died"
                      type="number" class="inputPrice itemform" dense
                      v-model="animalDeathDetails.numberOfDied"></v-text-field>
                  </v-flex> -->
                      <v-flex xs12 pt-2>
                        <v-layout wrap justify-center v-for="(animal, index) in animalDeathDetailsList" :key="index">
                          <v-flex xs12 sm3 md3 lg3>
                            <v-select :items="speciesOptions" label="Species" outlined v-model="animal.species"
                              class="itemform" dense @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg3 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-select :items="persongender" label="Gender" outlined v-model="animal.gender"
                              class="itemform" dense @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg5 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-textarea outlined label="Cause of death" placeholder="Enter Cause of death"
                              v-model="animal.causeOfDeath" class="itemform" dense rows="2"
                              @input="markAsDirty"></v-textarea>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg1 pl-lg-2 pl-md-2 pl-sm-2 pt-1>
                            <span v-if="animalDeathDetailsList.length > 1">
                              <v-btn small plain @click="removeAnimalDeathDetail(index)" color="error" class="itemform"
                                dense>
                                <span>Remove</span><span><v-icon small>mdi-delete</v-icon></span>
                              </v-btn>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout wrap justify-end>
                          <v-flex xs12 sm3 md3 lg3>
                            <v-btn small plain @click="addAnimalDeathDetail" color="primary">
                              <span><v-icon small>mdi-plus</v-icon></span><span>ADD More</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-if="isLivestockDepredationSelected">
                    <v-layout wrap justify-center>
                      <v-flex xs12 align-self-center pb-1>
                        <span class="itemform">Details Of Livestock Depredation</span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-center>
                      <v-flex xs12 pt-2>
                        <!-- <v-text-field outlined label="Incident Title" placeholder="Enter Incident Title"
                      v-model="livestockTitle" class="itemform" dense></v-text-field> -->
                      </v-flex>
                      <v-flex xs12 pt-2>
                        <v-layout wrap justify-center v-for="(item, index) in livestockanimal" :key="index">
                          <v-flex xs12 sm5 md5 lg4>
                            <v-select :items="depredationType" label="Type Of Depredation" outlined
                              v-model="item.injuryOrDeath" class="itemform" dense @change="markAsDirty"></v-select>
                          </v-flex>
                          <v-flex xs12 sm6 md6 lg3 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-text-field outlined label="Type Of Animal" placeholder="Enter Type Of Animal"
                              v-model="item.typeOfAnimal" class="itemform" dense @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm6 md6 lg3 pl-lg-2 pl-md-2 pl-sm-2>
                            <v-text-field outlined label="Nos. of Animals" placeholder="Enter Number Of Animals"
                              v-model="item.numberOfAnimals" class="itemform inputPrice" dense type="number"
                              @input="markAsDirty"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm3 md3 lg2 pl-lg-2 pl-md-2 pl-sm-2 pt-1>
                            <span v-if="livestockanimal.length > 1">
                              <v-btn small plain @click="removeLivestockDetail(index)" color="error" class="itemform"
                                dense>
                                <span>Remove</span><span><v-icon small>mdi-delete</v-icon></span>
                              </v-btn>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout wrap justify-end>
                          <v-flex xs12 sm3 md3 lg3>
                            <v-btn small plain @click="addLivestockDetail" color="primary">
                              <span><v-icon small>mdi-plus</v-icon></span><span>ADD More</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12>
                    <v-textarea outlined name="input-7-4" label="Incident, Name and Designation of Informer"
                      v-model="informerDetails" @input="markAsDirty"></v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12>
                    <v-textarea outlined name="input-7-4" label="Incident summary and follow up action"
                      v-model="remarks" @input="markAsDirty"></v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12>
                    <v-select :items="['Yes', 'No']" label="Were the procedures completed within 24 hours?"
                      v-model="proceduresCompleted24hrs" outlined dense class="itemform"
                      @change="markAsDirty"></v-select>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center v-if="proceduresCompleted24hrs === 'No'">
                  <v-flex xs12>
                    <v-textarea outlined name="input-7-4" label="Reason for not completing the action within 24 hrs"
                      v-model="reason24hrs" @input="markAsDirty"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-tab-item>

              <v-tab-item>
                <v-layout wrap justify-center pt-4>
                  <v-flex xs12>
                    <v-text-field outlined label="RRT" v-model="rrt" class="itemform" dense
                      @input="markAsDirty"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6 lg6>
                    <v-text-field outlined label="Station" v-model="responseStation" class="itemform" dense
                      @input="markAsDirty"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6 lg6 pl-lg-2 pl-md-2 pl-sm-2>
                    <v-text-field outlined label="Section" v-model="responseSection" class="itemform" dense
                      @input="markAsDirty"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field outlined label="Range" v-model="responseRange" class="itemform" dense
                      @input="markAsDirty"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea outlined label="Who responded" v-model="whoResponded" class="itemform" dense
                      @input="markAsDirty"></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea outlined label="Resource Deployed" v-model="resourceDeployed" class="itemform" dense
                      @input="markAsDirty"></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field outlined label="How many staff Deployed" v-model="staffDeployedCount" type="number"
                      class="itemform inputPrice" dense @input="markAsDirty"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs-items>
            <!-- <v-layout wrap justify-center pa-5 style="border: solid 1px">
              <v-flex xs12 text-left>
                <v-layout wrap justify-start>
                  <v-flex
                    xs12
                    sm6
                    md4
                    lg4
                    pa-5
                    v-for="(items, index) in displayImage"
                    :key="index"
                  >
                    <v-img :src="items" fill-height height="100%" width="100%">
                      <v-layout wrap>
                        <v-flex text-right pa-0>
                          <v-avatar color="#FF3434" size="15">
                            <v-icon
                              color="#FFF"
                              small
                              @click="removeImage(index)"
                            >
                              mdi-close
                            </v-icon>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-img>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-end>
                  <v-flex xs12 text-right>
                    <v-btn
                      color="blue-grey"
                      dark
                      small
                      @click="$refs.uploadDoc.click()"
                      class="itemform"
                      ><span> UPLOAD IMAGES </span>
                      <v-icon right dark> mdi-cloud-upload </v-icon></v-btn
                    >
                  </v-flex>
                  <input
                    v-show="false"
                    id="file1"
                    ref="uploadDoc"
                    multiple
                    type="file"
                    accept=".svg, .png, .jpg, .jpeg"
                    @change="uploadDoc"
                  />
                </v-layout>
              </v-flex>
            </v-layout> -->
            <v-layout wrap justify-center pt-3 pb-3>
              <v-flex xs12 class="text-center">
                <v-layout wrap justify-center>

                  <!-- PREVIEW -->
                  <!-- <v-flex xs12 sm6 md4 lg3>
        <v-btn
          block
          tile
          color="grey darken-2"
          dark
          depressed
          @click="openViewPreview"
          class="itemValue mb-2"
        >
          <v-icon left>mdi-eye</v-icon>
          PREVIEW
        </v-btn>
      </v-flex> -->

                  <!-- Main action button – only shown in tab 1 or when needed in tab 2 -->
                  <v-flex xs12 sm6 md4 lg3 v-if="activeTab === 0 || (activeTab === 1 && !isSaved)">
                    <v-btn block tile :color="appColor" light depressed :disabled="appLoading"
                      @click="activeTab === 0 ? activeTab = 1 : openSavePreview()" class="itemValue">
                      <span style="color: #fff">{{ activeTab === 0 ? 'NEXT' : 'SAVE' }}</span>
                    </v-btn>
                  </v-flex>

                  <!-- After first save: show either SAVE CHANGES or SUBMIT -->
                  <v-flex xs12 sm6 md4 lg3 v-if="activeTab === 1 && (isSaved || submitting)">
                    <v-btn v-if="hasChanges && !submitting" block tile color="amber darken-2" dark depressed
                      :disabled="appLoading" @click="openSaveChangesPreview" class="itemValue">
                      <v-icon left>mdi-content-save-edit</v-icon>
                      SAVE CHANGES
                    </v-btn>

                    <v-btn v-else block tile color="success" dark depressed :disabled="appLoading"
                      @click="handleFinalSubmit" class="itemValue">
                      <v-icon left>mdi-check-circle-outline</v-icon>
                      SUBMIT
                    </v-btn>
                  </v-flex>

                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 lg5 pr-3>
            <v-layout wrap justify-center>
              <v-flex xs12>
                <div id="mapp"></div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showPreview" max-width="960" persistent scrollable>
      <v-card>
        <v-card-title class="primary white--text headline">
          Daily Human-Wildlife Conflict Report - Preview
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showPreview = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6 pb-8">

          <!-- ────────────────  1. BASIC INFORMATION  ──────────────── -->
          <div class="mb-6">
            <h2 class="primary--text mb-4">1. Basic Information</h2>

            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <strong>Location Name:</strong><br>
                {{ locationname || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>District:</strong><br>
                {{ selectedDistrictName || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>{{ localBodyType }}:</strong><br>
                {{ selectedPanchayat || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>LA Constituency:</strong><br>
                {{ selectedAssembly || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Parliament Constituency:</strong><br>
                {{ selectedConstituency || '—' }}
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <strong>Division:</strong><br>
                {{ divisionname || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Range:</strong><br>
                {{ rangename || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Section / Station:</strong><br>
                {{ sectionStation || '—' }}
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <strong>Village:</strong><br>{{ village || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Taluk:</strong><br>{{ taluk || '—' }}
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <strong>Coordinates:</strong><br>
                {{ lattitude || '—' }}, {{ longitude || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Incident Date & Time:</strong><br>
                {{ formatDate(incidentDate) }} {{ incidentTime || '—' }} ({{ formatTime(incidentTime) }})
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <strong>Animal Involved:</strong><br>
                {{ selectedAnimalTypeName || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Number of Animals:</strong><br>
                {{ animalCount || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Threat Level:</strong><br>
                {{ threatlevel || '—' }}
              </v-col>

              <v-col cols="12" class="mt-3">
                <strong>Any Damage Reported?</strong><br>
                <span
                  :class="anyDamage === 'Yes' ? 'success--text' : anyDamage === 'No' ? 'grey--text' : 'warning--text'">
                  {{ anyDamage || '—' }}
                </span>
              </v-col>

              <v-col cols="12" v-if="ConflictType && ConflictType.length">
                <strong>Conflict Types:</strong>
                <div class="ml-2 mt-1">
                  <v-chip v-for="id in ConflictType" :key="id" small class="ma-1" color="primary" text-color="white">
                    {{ getConflictTypeName(id) }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- ────────────────  DAMAGE DETAILS  ──────────────── -->
          <div class="mb-6" v-if="anyDamage === 'Yes' || anyDamage === 'Unverified incident'">

            <h2 class="primary--text mb-4">2. Damage / Impact Details</h2>

            <!-- Crop Damage -->
            <div v-if="isCropDamageSelected && cropTypedetails.length">
              <h3 class="mb-3">Crop Damage</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Crop</th>
                      <th>Quantity / Extent</th>
                      <th>Unit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in cropTypedetails" :key="'crop-' + i">
                      <td>{{ getCropName(item.cropId) || '—' }}</td>
                      <td>{{ item.count || '—' }}</td>
                      <td>{{ item.unit || '—' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Property Damage -->
            <div v-if="isPropertyDamageSelected && propertyTypedetails.length" class="mt-6">
              <h3 class="mb-3">Property Damage</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Type of Property</th>
                      <th>Details of Damage</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in propertyTypedetails" :key="'prop-' + i">
                      <td>{{ item.propertyType || '—' }}</td>
                      <td>{{ item.damageDetail || '—' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Human Injury -->
            <div v-if="isHumanInjurySelected && injuredPeople.length" class="mt-6">
              <h3 class="mb-3">Human Injury ({{ nopeopleinjured || injuredPeople.length }})</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Age</th>
                      <th>Gender</th>
                      <th>Injury Type</th>
                      <th>Hospitalized?</th>
                      <th>Tribe?</th>
                      <th>Location</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, i) in injuredPeople" :key="'inj-' + i">
                      <td>{{ i + 1 }}</td>
                      <td>{{ p.name || '—' }}</td>
                      <td>{{ p.age || '—' }}</td>
                      <td>{{ p.gender || '—' }}</td>
                      <td>{{ p.injuryType || '—' }}</td>
                      <td>{{ p.hospitalized || '—' }}</td>
                      <td>{{ p.isTribe || '—' }} {{ p.isTribe === 'Yes' ? `(${p.community || '?'})` : '' }}</td>
                      <td>{{ p.forestLocation || '—' }} {{ p.forestLocation === 'Inside' ? `(${p.rfName || '?'})` : ''
                      }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Human Death -->
            <div v-if="isHumanDeathSelected && peopleDead.length" class="mt-6">
              <h3 class="mb-3 error--text">Human Death ({{ nopeopledied || peopleDead.length }})</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Age</th>
                      <th>Gender</th>
                      <th>Tribe?</th>
                      <th>Location</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, i) in peopleDead" :key="'death-' + i">
                      <td>{{ i + 1 }}</td>
                      <td>{{ p.name || '—' }}</td>
                      <td>{{ p.age || '—' }}</td>
                      <td>{{ p.gender || '—' }}</td>
                      <td>{{ p.isTribe || '—' }} {{ p.isTribe === 'Yes' ? `(${p.community || '?'})` : '' }}</td>
                      <td>{{ p.forestLocation || '—' }} {{ p.forestLocation === 'Inside' ? `(${p.rfName || '?'})` : ''
                      }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Animal Injury -->
            <div v-if="isAnimalInjurySelected" class="mt-6">
              <h3 class="mb-3">Details Of Animal Injured</h3>
              <v-row dense>
                <v-col cols="12" sm="6">
                  <strong>Number of Animals Injured:</strong><br>
                  {{ animalInjuryDetails.injuredNumber || '—' }}
                </v-col>
                <v-col cols="12" sm="6">
                  <strong>Type of Injury:</strong><br>
                  {{ animalInjuryDetails.typeOfInjury || '—' }}
                </v-col>
              </v-row>
            </div>

            <!-- Animal Death -->
            <div v-if="isAnimalDeathSelected && animalDeathDetailsList.length" class="mt-6">
              <h3 class="mb-3 error--text">Details Of Animal Died</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Species</th>
                      <th>Gender</th>
                      <th>Cause of Death</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(animal, i) in animalDeathDetailsList" :key="'adeath-' + i">
                      <td>{{ i + 1 }}</td>
                      <td>{{ animal.species || '—' }}</td>
                      <td>{{ animal.gender || '—' }}</td>
                      <td>{{ animal.causeOfDeath || '—' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Livestock Depredation -->
            <div v-if="isLivestockDepredationSelected && livestockanimal.length" class="mt-6">
              <h3 class="mb-3">Details Of Livestock Depredation</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Type Of Depredation</th>
                      <th>Type Of Animal</th>
                      <th>Number of Animals</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in livestockanimal" :key="'livestock-' + i">
                      <td>{{ i + 1 }}</td>
                      <td>{{ item.injuryOrDeath || '—' }}</td>
                      <td>{{ item.typeOfAnimal || '—' }}</td>
                      <td>{{ item.numberOfAnimals || '—' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

          </div>

          <!-- ────────────────  REMARKS  ──────────────── -->
          <div class="mb-6">
            <h2 class="primary--text mb-4">3. Additional Information</h2>

            <v-row dense>
              <v-col cols="12">
                <strong>Informer Details / Contact:</strong><br>
                <div class="ml-2 mt-1">{{ informerDetails || '—' }}</div>
              </v-col>
              <v-col cols="12" class="mt-3">
                <strong>Incident Summary & Follow-up Action:</strong><br>
                <div class="ml-2 mt-1">{{ remarks || '—' }}</div>
              </v-col>

              <v-col cols="12" sm="6" class="mt-4">
                <strong>Procedures completed within 24 hours?</strong><br>
                {{ proceduresCompleted24hrs || '—' }}
              </v-col>
              <v-col cols="12" v-if="proceduresCompleted24hrs === 'No'">
                <strong>Reason for delay:</strong><br>
                {{ reason24hrs || '—' }}
              </v-col>
            </v-row>
          </div>

          <!-- ────────────────  RESPONSE TEAM  ──────────────── -->
          <div>
            <h2 class="primary--text mb-4">4. Response Team Information</h2>

            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <strong>RRT:</strong><br>{{ rrt || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Response Station:</strong><br>{{ responseStation || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Response Section:</strong><br>{{ responseSection || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Response Range:</strong><br>{{ responseRange || '—' }}
              </v-col>
              <v-col cols="12">
                <strong>Who Responded:</strong><br>
                <div class="ml-2 mt-1">{{ whoResponded || '—' }}</div>
              </v-col>
              <v-col cols="12">
                <strong>Resources Deployed:</strong><br>
                <div class="ml-2 mt-1">{{ resourceDeployed || '—' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <strong>Number of Staff Deployed:</strong><br>
                {{ staffDeployedCount || '—' }}
              </v-col>
            </v-row>
          </div>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center pa-6">
          <v-btn color="grey darken-2" dark large @click="showPreview = false">
            {{ previewSource === 'view' ? 'Close' : 'Edit' }}
          </v-btn>

          <v-btn v-if="previewSource === 'save'" color="success" large class="ml-6" :loading="saving"
            @click="handleSave">
            <v-icon left>mdi-check-circle</v-icon>
            Save
          </v-btn>

          <v-btn v-if="previewSource === 'saveChanges'" color="amber darken-3" large class="ml-6" :loading="saving"
            @click="handleSaveChanges">
            <v-icon left>mdi-content-save-edit</v-icon>
            Save Changes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script
  src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyDPNXCjI6IJbDqwJcJwGuJUfNWxfMLSe-U&libraries=visualization,drawing"></script>
<script>
export default {
  data() {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, '0');
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      panCardImages: [],
      lattitude: "",
      longitude: "",
      locationname: "",
      animaltype: "",
      animalCount: "",
    //   situation: "",
      reportdistrict: "",
      divisionList: [],
      divisionPage: 1,
      divisionTotalPages: 0,
      divisionLoading: false,
      divisionname: "",
      sectionStation: "",
      village: "",
      taluk: "",
      village: "",
      taluk: "",
      cropTitle: "",
      propertyTitle: "",
      humanInjuryTitle: "",
      humanDeathTitle: "",
      animalInjuryTitle: "",
      animalDeathTitle: "",
      livestockTitle: "",
      msg: "",
      timeout: 5000,
      threatlevel: "",
      remarks: "",
      informerDetails: "",
      reason24hrs: "",
      anyDamage: " ",
      activeTab: 0,
      rrt: "",
      responseRange: "",
      responseSection: "",
      showPreview: false,
      previewSource: 'view',
      responseStation: "",
      whoResponded: "",
      resourceDeployed: "",
      staffDeployedCount: "",
      logindivisionid: localStorage.getItem("division"),
      animalTypes: [],
    //   situations: [],
      threatLevels: ["High", "Medium", "Low"],
      map: "",
      mapData: {},
      checkboxItems: [],
      selectedItems: [],
      filterData: [],
      lat: "",
      lon: "",
      onMarker: [],
      map3: "",
      categorylist2: [],
      selected: "",
      newMarker: [],
      districts: [
        { "District ID": "1", "District Name": "Thiruvananthapuram", "Malayalam Name": "തിരുവനന്തപുരം" },
        { "District ID": "2", "District Name": "Kollam", "Malayalam Name": "കൊല്ലം" },
        { "District ID": "3", "District Name": "Pathanamthitta", "Malayalam Name": "പത്തനംതിട്ട" },
        { "District ID": "4", "District Name": "Alappuzha", "Malayalam Name": "ആലപ്പുഴ" },
        { "District ID": "5", "District Name": "Kottayam", "Malayalam Name": "കോട്ടയം" },
        { "District ID": "6", "District Name": "Idukki", "Malayalam Name": "ഇടുക്കി" },
        { "District ID": "7", "District Name": "Ernakulam", "Malayalam Name": "എറണാകുളം" },
        { "District ID": "8", "District Name": "Thrissur", "Malayalam Name": "തൃശ്ശൂര്‍" },
        { "District ID": "9", "District Name": "Palakkad", "Malayalam Name": "പാലക്കാട്‌" },
        { "District ID": "10", "District Name": "Malappuram", "Malayalam Name": "മലപ്പുറം" },
        { "District ID": "11", "District Name": "Kozhikode", "Malayalam Name": "കോഴിക്കോട്‌" },
        { "District ID": "12", "District Name": "Wayanad", "Malayalam Name": "വയനാട്‌" },
        { "District ID": "13", "District Name": "Kannur", "Malayalam Name": "കണ്ണൂര്‍" },
        { "District ID": "14", "District Name": "Kasaragod", "Malayalam Name": "കാസര്‍ഗോഡ്‌" }
      ],
      Municipality: [
  { id: 1, name: "Neyyattinkara" },
  { id: 2, name: "Nedumangad" },
  { id: 3, name: "Attingal" },
  { id: 4, name: "Varkala" },
  { id: 5, name: "Punalur" },
  { id: 6, name: "Karunagapally" },
  { id: 7, name: "Paravur" },
  { id: 8, name: "Kottarakkara" },
  { id: 9, name: "Thiruvalla" },
  { id: 10, name: "Pathanamthitta" },
  { id: 11, name: "Adoor" },
  { id: 12, name: "Pandalam" },
  { id: 13, name: "Alappuzha" },
  { id: 14, name: "Kayamkulam" },
  { id: 15, name: "Cherthala" },
  { id: 16, name: "Mavelikara" },
  { id: 17, name: "Chengannur" },
  { id: 18, name: "Haripad" },
  { id: 19, name: "Kottayam" },
  { id: 20, name: "Changanacherry" },
  { id: 21, name: "Pala" },
  { id: 22, name: "Vaikom" },
  { id: 23, name: "Ettumanoor" },
  { id: 24, name: "Erattupetta" },
  { id: 25, name: "Thodupuzha" },
  { id: 26, name: "Kattappana" },
  { id: 27, name: "Thripunithura" },
  { id: 28, name: "Thrikkakara" },
  { id: 29, name: "Kalamassery" },
  { id: 30, name: "Perumbavoor" },
  { id: 31, name: "Aluva" },
  { id: 32, name: "Muvattupuzha" },
  { id: 33, name: "Kothamangalam" },
  { id: 34, name: "North Paravoor" },
  { id: 35, name: "Angamaly" },
  { id: 36, name: "Maradu" },
  { id: 37, name: "Eloor" },
  { id: 38, name: "Piravom" },
  { id: 39, name: "Koothattukulam" },
  { id: 40, name: "Irinjalakuda" },
  { id: 41, name: "Kunnamkulam" },
  { id: 42, name: "Chalakkudy" },
  { id: 43, name: "Kodungallur" },
  { id: 44, name: "Guruvayoor" },
  { id: 45, name: "Chavakkad" },
  { id: 46, name: "Wadakkancheri" },
  { id: 47, name: "Palakkad" },
  { id: 48, name: "Chittur-Thathamangalam" },
  { id: 49, name: "Ottappalam" },
  { id: 50, name: "Shornur" },
  { id: 51, name: "Mannarkkad" },
  { id: 52, name: "Pattambi" },
  { id: 53, name: "Cherpulassery" },
  { id: 54, name: "Malappuram" },
  { id: 55, name: "Manjeri" },
  { id: 56, name: "Ponnani" },
  { id: 57, name: "Tirur" },
  { id: 58, name: "Perinthalmanna" },
  { id: 59, name: "Kottakkal" },
  { id: 60, name: "Nilambur" },
  { id: 61, name: "Kondotty" },
  { id: 62, name: "Valanchery" },
  { id: 63, name: "Tanur" },
  { id: 64, name: "Parappanangadi" },
  { id: 65, name: "Tirurangadi" },
  { id: 66, name: "Vatakara" },
  { id: 67, name: "Koyilandy" },
  { id: 68, name: "Mukkam" },
  { id: 69, name: "Ramanattukara" },
  { id: 70, name: "Feroke" },
  { id: 71, name: "Payyoli" },
  { id: 72, name: "Koduvally" },
  { id: 73, name: "Kalpetta" },
  { id: 74, name: "Mananthavadi" },
  { id: 75, name: "Sultan Bathery" },
  { id: 76, name: "Thalassery" },
  { id: 77, name: "Taliparamba" },
  { id: 78, name: "Payyanur" },
  { id: 79, name: "Mattannur" },
  { id: 80, name: "Koothuparamba" },
  { id: 81, name: "Anthoor" },
  { id: 82, name: "Iritty" },
  { id: 83, name: "Panoor" },
  { id: 84, name: "Sreekandapuram" },
  { id: 85, name: "Kasaragod" },
  { id: 86, name: "Kanhangad" },
  { id: 87, name: "Nileshwaram" },
  { id: 88, name: "Mananthavadi" },
  { id: 89, name: "Wayanad" },
],
corporation: [
  { id: 1, name: "Thiruvananthapuram" },
  { id: 2, name: "Kochi" },
  { id: 3, name: "Kozhikode" },
  { id: 4, name: "Thrissur" },
  { id: 5, name: "Kollam" },
  { id: 6, name: "Kannur" },
    ],
      assemblies:[
  { name: "Manjeshwaram", districtId: 14 },
  { name: "Kasaragod", districtId: 14 },
  { name: "Udma", districtId: 14 },
  { name: "Kanhangad", districtId: 14 },
  { name: "Thrikaripur", districtId: 14 },
  { name: "Payyanur", districtId: 13 },
  { name: "Kalliasseri", districtId: 13 },
  { name: "Taliparamba", districtId: 13 },
  { name: "Irikkur", districtId: 13 },
  { name: "Azhikode", districtId: 13 },
  { name: "Kannur", districtId: 13 },
  { name: "Dharmadom", districtId: 13 },
  { name: "Thalassery", districtId: 13 },
  { name: "Kuthuparamba", districtId: 13 },
  { name: "Mattanur", districtId: 13 },
  { name: "Peravoor", districtId: 13 },
  { name: "Mananthavady", districtId: 12 },
  { name: "Sulthan Bathery", districtId: 12 },
  { name: "Kalpetta", districtId: 12 },
  { name: "Vatakara", districtId: 11 },
  { name: "Kuttiady", districtId: 11 },
  { name: "Nadapuram", districtId: 11 },
  { name: "Koyilandy", districtId: 11 },
  { name: "Perambra", districtId: 11 },
  { name: "Balussery", districtId: 11 },
  { name: "Elathur", districtId: 11 },
  { name: "Kozhikode North", districtId: 11 },
  { name: "Kozhikode South", districtId: 11 },
  { name: "Beypore", districtId: 11 },
  { name: "Kunnamangalam", districtId: 11 },
  { name: "Koduvally", districtId: 11 },
  { name: "Thiruvambady", districtId: 11 },
  { name: "Kondotty", districtId: 10 },
  { name: "Eranad", districtId: 10 },
  { name: "Nilambur", districtId: 10 },
  { name: "Wandoor", districtId: 10 },
  { name: "Manjeri", districtId: 10 },
  { name: "Perinthalmanna", districtId: 10 },
  { name: "Mankada", districtId: 10 },
  { name: "Malappuram", districtId: 10 },
  { name: "Vengara", districtId: 10 },
  { name: "Vallikkunnu", districtId: 10 },
  { name: "Tirurangadi", districtId: 10 },
  { name: "Tanur", districtId: 10 },
  { name: "Tirur", districtId: 10 },
  { name: "Kottakkal", districtId: 10 },
  { name: "Thavanur", districtId: 10 },
  { name: "Ponnani", districtId: 10 },
  { name: "Thrithala", districtId: 9 },
  { name: "Pattambi", districtId: 9 },
  { name: "Shornur", districtId: 9 },
  { name: "Ottapalam", districtId: 9 },
  { name: "Kongad", districtId: 9 },
  { name: "Mannarkkad", districtId: 9 },
  { name: "Malampuzha", districtId: 9 },
  { name: "Palakkad", districtId: 9 },
  { name: "Tarur", districtId: 9 },
  { name: "Chittur", districtId: 9 },
  { name: "Nenmara", districtId: 9 },
  { name: "Alathur", districtId: 9 },
  { name: "Chelakkara", districtId: 8 },
  { name: "Kunnamkulam", districtId: 8 },
  { name: "Guruvayur", districtId: 8 },
  { name: "Manalur", districtId: 8 },
  { name: "Wadakkanchery", districtId: 8 },
  { name: "Ollur", districtId: 8 },
  { name: "Thrissur", districtId: 8 },
  { name: "Nattika", districtId: 8 },
  { name: "Kaipamangalam", districtId: 8 },
  { name: "Irinjalakuda", districtId: 8 },
  { name: "Puthukkad", districtId: 8 },
  { name: "Chalakudy", districtId: 8 },
  { name: "Kodungallur", districtId: 8 },
  { name: "Perumbavoor", districtId: 7 },
  { name: "Angamaly", districtId: 7 },
  { name: "Aluva", districtId: 7 },
  { name: "Kalamassery", districtId: 7 },
  { name: "Paravur", districtId: 7 },
  { name: "Vypin", districtId: 7 },
  { name: "Kochi", districtId: 7 },
  { name: "Thrippunithura", districtId: 7 },
  { name: "Ernakulam", districtId: 7 },
  { name: "Thrikkakara", districtId: 7 },
  { name: "Kunnathunad", districtId: 7 },
  { name: "Piravom", districtId: 7 },
  { name: "Muvattupuzha", districtId: 7 },
  { name: "Kothamangalam", districtId: 7 },
  { name: "Devikulam", districtId: 6 },
  { name: "Udumbanchola", districtId: 6 },
  { name: "Thodupuzha", districtId: 6 },
  { name: "Idukki", districtId: 6 },
  { name: "Peerumade", districtId: 6 },
  { name: "Pala", districtId: 5 },
  { name: "Kaduthuruthy", districtId: 5 },
  { name: "Vaikom", districtId: 5 },
  { name: "Ettumanoor", districtId: 5 },
  { name: "Kottayam", districtId: 5 },
  { name: "Puthuppally", districtId: 5 },
  { name: "Changanassery", districtId: 5 },
  { name: "Kanjirappally", districtId: 5 },
  { name: "Poonjar", districtId: 5 },
  { name: "Aroor", districtId: 4 },
  { name: "Cherthala", districtId: 4 },
  { name: "Alappuzha", districtId: 4 },
  { name: "Ambalappuzha", districtId: 4 },
  { name: "Kuttanad", districtId: 4 },
  { name: "Haripad", districtId: 4 },
  { name: "Kayamkulam", districtId: 4 },
  { name: "Mavelikara", districtId: 4 },
  { name: "Chengannur", districtId: 4 },
  { name: "Thiruvalla", districtId: 3 },
  { name: "Ranni", districtId: 3 },
  { name: "Aranmula", districtId: 3 },
  { name: "Konni", districtId: 3 },
  { name: "Adoor", districtId: 3 },
  { name: "Karunagapally", districtId: 2 },
  { name: "Chavara", districtId: 2 },
  { name: "Kunnathur", districtId: 2 },
  { name: "Kottarakkara", districtId: 2 },
  { name: "Pathanapuram", districtId: 2 },
  { name: "Punalur", districtId: 2 },
  { name: "Chadayamangalam", districtId: 2 },
  { name: "Kundara", districtId: 2 },
  { name: "Kollam", districtId: 2 },
  { name: "Eravipuram", districtId: 2 },
  { name: "Chathannoor", districtId: 2 },
  { name: "Varkala", districtId: 1 },
  { name: "Attingal", districtId: 1 },
  { name: "Chirayinkeezhu", districtId: 1 },
  { name: "Nedumangad", districtId: 1 },
  { name: "Vamanapuram", districtId: 1 },
  { name: "Kazhakkoottam", districtId: 1 },
  { name: "Vattiyoorkavu", districtId: 1 },
  { name: "Thiruvananthapuram", districtId: 1 },
  { name: "Nemom", districtId: 1 },
  { name: "Aruvikkara", districtId: 1 },
  { name: "Parassala", districtId: 1 },
  { name: "Kattakkada", districtId: 1 },
  { name: "Kovalam", districtId: 1 },
  { name: "Neyyattinkara", districtId: 1 }
],
constituencies:[
  { name: "Kasaragod", districtId: 14 },
  { name: "Kannur", districtId: 13 },
  { name: "Vadakara", districtId: 11 },
  { name: "Wayanad", districtId: 12 },
  { name: "Kozhikode", districtId: 11 },
  { name: "Malappuram", districtId: 10 },
  { name: "Ponnani", districtId: 10 },
  { name: "Palakkad", districtId: 9 },
  { name: "Alathur", districtId: 9 },
  { name: "Thrissur", districtId: 8 },
  { name: "Chalakudy", districtId: 8 },
  { name: "Ernakulam", districtId: 7 },
  { name: "Idukki", districtId: 6 },
  { name: "Kottayam", districtId: 5 },
  { name: "Alappuzha", districtId: 4 },
  { name: "Mavelikara", districtId: 4 },
  { name: "Pathanamthitta", districtId: 3 },
  { name: "Kollam", districtId: 2 },
  { name: "Attingal", districtId: 1 },
  { name: "Thiruvananthapuram", districtId: 1 },
  { name: "Chalakudy", districtId: 7 },
  { name: "Chalakudy", districtId: 6 },
  { name: "Idukki", districtId: 7 },
  { name: "Mavelikkara", districtId: 2 },
],
panchayats: [
  { name: "Ala", districtId: 4 },
  { name: "Ambalapuzha South", districtId: 4 },
  { name: "Ambalapuzha North", districtId: 4 },
  { name: "Arattupuzha", districtId: 4 },
  { name: "Arookutty", districtId: 4 },
  { name: "Aroor", districtId: 4 },
  { name: "Aryad", districtId: 4 },
  { name: "Bharanikkavu", districtId: 4 },
  { name: "Budhanoor", districtId: 4 },
  { name: "Chambakulam", districtId: 4 },
  { name: "Chennampallipuram", districtId: 4 },
  { name: "Chennithala Thriperumthura", districtId: 4 },
  { name: "Cheppad", districtId: 4 },
  { name: "Cheriyanad", districtId: 4 },
  { name: "Cherthala south", districtId: 4 },
  { name: "Cheruthana", districtId: 4 },
  { name: "Chettikulangara", districtId: 4 },
  { name: "Chingoli", districtId: 4 },
  { name: "Chunakkara", districtId: 4 },
  { name: "Devikulangara", districtId: 4 },
  { name: "Edathua", districtId: 4 },
  { name: "Ezhupunna", districtId: 4 },
  { name: "Kadakarappally", districtId: 4 },
  { name: "Kainakary", districtId: 4 },
  { name: "Kandalloor", districtId: 4 },
  { name: "Kanjikuzhy", districtId: 4 },
  { name: "Karthikapally", districtId: 4 },
  { name: "Karuvatta", districtId: 4 },
  { name: "Kavalam", districtId: 4 },
  { name: "Kodamthuruth", districtId: 4 },
  { name: "Krishnapuram", districtId: 4 },
  { name: "Kumarapuram", districtId: 4 },
  { name: "Kuthiathode", districtId: 4 },
  { name: "Mannanchery", districtId: 4 },
  { name: "Mannar", districtId: 4 },
  { name: "Mararikulam south", districtId: 4 },
  { name: "Mararikulam North", districtId: 4 },
  { name: "Mavelikara Thamarakulam", districtId: 4 },
  { name: "Mavelikara Thekkekara", districtId: 4 },
  { name: "Muhamma", districtId: 4 },
  { name: "Mulakuzha", districtId: 4 },
  { name: "Muthukulam", districtId: 4 },
  { name: "Muttar", districtId: 4 },
  { name: "Nedumudy", districtId: 4 },
  { name: "Neelamperoor", districtId: 4 },
  { name: "Nooranad", districtId: 4 },
  { name: "Palamel", districtId: 4 },
  { name: "Pallippad", districtId: 4 },
  { name: "Panavally", districtId: 4 },
  { name: "Pandanad", districtId: 4 },
  { name: "Pathiyoor", districtId: 4 },
  { name: "Pattanakkad", districtId: 4 },
  { name: "Perumbalam", districtId: 4 },
  { name: "Pulincunnu", districtId: 4 },
  { name: "Puliyoor", districtId: 4 },
  { name: "Punnapra south", districtId: 4 },
  { name: "Punnapra north", districtId: 4 },
  { name: "Purakkad", districtId: 4 },
  { name: "Ramankary", districtId: 4 },
  { name: "Thakazhy", districtId: 4 },
  { name: "Thalavady", districtId: 4 },
  { name: "Thannermukkom", districtId: 4 },
  { name: "Thazhakkara", districtId: 4 },
  { name: "Thiruvanvandoor", districtId: 4 },
  { name: "Thrikkunnappuzha", districtId: 4 },
  { name: "Thuravoor", districtId: 4 },
  { name: "Thykattussery", districtId: 4 },
  { name: "Vallikunnam", districtId: 4 },
  { name: "Vayalar", districtId: 4 },
  { name: "Veeyapuram", districtId: 4 },
  { name: "Veliyanad", districtId: 4 },
  { name: "Venmony", districtId: 4 },
  { name: "Aikkaranadu", districtId: 7 },
  { name: "Alengadu", districtId: 7 },
  { name: "Amballur", districtId: 7 },
  { name: "Thuravur", districtId: 7 },
  { name: "Arakkuzha", districtId: 7 },
  { name: "Asamannur", districtId: 7 },
  { name: "Avoli", districtId: 7 },
  { name: "Ayavana", districtId: 7 },
  { name: "Ayyampuzha", districtId: 7 },
  { name: "Chellanam", districtId: 7 },
  { name: "Chendamangalam", districtId: 7 },
  { name: "Chengamanad", districtId: 7 },
  { name: "Cheranallur", districtId: 7 },
  { name: "Chittattukara", districtId: 7 },
  { name: "Choornnikkara", districtId: 7 },
  { name: "Chottanikkara", districtId: 7 },
  { name: "Edakkattuvayal", districtId: 7 },
  { name: "Edathala", districtId: 7 },
  { name: "Edavanakkadu", districtId: 7 },
  { name: "Elanji", districtId: 7 },
  { name: "Elamkunnappuzha", districtId: 7 },
  { name: "Kalady", districtId: 7 },
  { name: "Ezhikkara", districtId: 7 },
  { name: "Kadamakkudi", districtId: 7 },
  { name: "Kadungalloor", districtId: 7 },
  { name: "Kalloorkadu", districtId: 7 },
  { name: "Kanjoor", districtId: 7 },
  { name: "Karukutty", districtId: 7 },
  { name: "Karumaloor", districtId: 7 },
  { name: "Kavalangad", districtId: 7 },
  { name: "Keerambara", districtId: 7 },
  { name: "Keezhmadu", districtId: 7 },
  { name: "Kizhakkambalam", districtId: 7 },
  { name: "Kuvappady", districtId: 7 },
  { name: "Kottappadi", districtId: 7 },
  { name: "Kottuvalli", districtId: 7 },
  { name: "Kumbalam", districtId: 7 },
  { name: "Kumbalangi", districtId: 7 },
  { name: "Kunnathunadu", districtId: 7 },
  { name: "Kunnukara", districtId: 7 },
  { name: "Kuttambuzha", districtId: 7 },
  { name: "Kuzhuppilli", districtId: 7 },
  { name: "Malayattoor -Neeleswaram", districtId: 7 },
  { name: "Maneed", districtId: 7 },
  { name: "Manjalloor", districtId: 7 },
  { name: "Manjapra", districtId: 7 },
  { name: "Marady", districtId: 7 },
  { name: "Mazhuvannur", districtId: 7 },
  { name: "Mudakkuzha", districtId: 7 },
  { name: "Mookkannur", districtId: 7 },
  { name: "Mulanthuruthi", districtId: 7 },
  { name: "Mulavukadu", districtId: 7 },
  { name: "Narayambalam", districtId: 7 },
  { name: "Nedumbassery", districtId: 7 },
  { name: "Nellikkuzhi", districtId: 7 },
  { name: "Njarakkal", districtId: 7 },
  { name: "Okkal", districtId: 7 },
  { name: "Paingottur", districtId: 7 },
  { name: "Payipra", districtId: 7 },
  { name: "Palakkuzha", districtId: 7 },
  { name: "Pallarimangalam", districtId: 7 },
  { name: "Pallippuram", districtId: 7 },
  { name: "Pambakkuda", districtId: 7 },
  { name: "Parakadavu", districtId: 7 },
  { name: "Pindimana", districtId: 7 },
  { name: "Poothrikka", districtId: 7 },
  { name: "Pothanikadu", districtId: 7 },
  { name: "Puthenvelikkara", districtId: 7 },
  { name: "Ramamangalam", districtId: 7 },
  { name: "Rayamangalam", districtId: 7 },
  { name: "Sreemoola Nagaram", districtId: 7 },
  { name: "Thirumaradi", districtId: 7 },
  { name: "Thiruvaniyoor", districtId: 7 },
  { name: "Udayamperoor", districtId: 7 },
  { name: "Vadakkekkara", districtId: 7 },
  { name: "Vadavukodu- Puthankurisu", districtId: 7 },
  { name: "Valakom", districtId: 7 },
  { name: "Varappetti", districtId: 7 },
  { name: "Varappuzha", districtId: 7 },
  { name: "Vazhakkulam", districtId: 7 },
  { name: "Vengola", districtId: 7 },
  { name: "Vengoor", districtId: 7 },
  { name: "Adimaly", districtId: 6 },
  { name: "Alakode", districtId: 6 },
  { name: "ARAKULAM", districtId: 6 },
  { name: "Ayyappancoil", districtId: 6 },
  { name: "Bisonvalley", districtId: 6 },
  { name: "Chakkupallam", districtId: 6 },
  { name: "CHINNAKANAL", districtId: 6 },
  { name: "Devikulam", districtId: 6 },
  { name: "EDAVETTY", districtId: 6 },
  { name: "Elappara", districtId: 6 },
  { name: "Erattayar", districtId: 6 },
  { name: "IDUKKI KANJIKUZHY", districtId: 6 },
  { name: "Edamalakudi", districtId: 6 },
  { name: "Kamakshy", districtId: 6 },
  { name: "Kanchiyar", districtId: 6 },
  { name: "KANTHALLOOR", districtId: 6 },
  { name: "Karimannoor", districtId: 6 },
  { name: "karimkunnam", districtId: 6 },
  { name: "KARUNAPURAM", districtId: 6 },
  { name: "Kodikulam", districtId: 6 },
  { name: "Kokkayar", districtId: 6 },
  { name: "Konnathady", districtId: 6 },
  { name: "Kudayathoor", districtId: 6 },
  { name: "KUMILY", districtId: 6 },
  { name: "KUMARAMANGALAM", districtId: 6 },
  { name: "Manakkad", districtId: 6 },
  { name: "Mankulam", districtId: 6 },
  { name: "MARAYOOR", districtId: 6 },
  { name: "Mariyapuram", districtId: 6 },
  { name: "Munnar", districtId: 6 },
  { name: "Muttom", districtId: 6 },
  { name: "NEDUMKANDAM", districtId: 6 },
  { name: "PALLIVASAL", districtId: 6 },
  { name: "Pampadumpara", districtId: 6 },
  { name: "Peermade", districtId: 6 },
  { name: "Peruvanthanam", districtId: 6 },
  { name: "PURAPUZHA", districtId: 6 },
  { name: "Rajakad", districtId: 6 },
  { name: "Rajakumary", districtId: 6 },
  { name: "Santhanpara", districtId: 6 },
  { name: "Senapathy", districtId: 6 },
  { name: "Udumbanchola", districtId: 6 },
  { name: "Udumbannoor", districtId: 6 },
  { name: "Upputhara", districtId: 6 },
  { name: "VANDANMEDU", districtId: 6 },
  { name: "Vandiperiyar", districtId: 6 },
  { name: "Vannappuram", districtId: 6 },
  { name: "VATHIKUDY", districtId: 6 },
  { name: "Vattavada", districtId: 6 },
  { name: "VAZHATHOPE", districtId: 6 },
  { name: "Vellathooval", districtId: 6 },
  { name: "Velliyamattom", districtId: 6 },
  { name: "Alakkode", districtId: 13 },
  { name: "Anjarakkandi", districtId: 13 },
  { name: "Aralam", districtId: 13 },
  { name: "Ayyankunnu", districtId: 13 },
  { name: "Azhikode", districtId: 13 },
  { name: "Chapparappadavu", districtId: 13 },
  { name: "Chembilode", districtId: 13 },
  { name: "Chengalai", districtId: 13 },
  { name: "Cherukunnu", districtId: 13 },
  { name: "Cherupuzha", districtId: 13 },
  { name: "Cheruthazham", districtId: 13 },
  { name: "Chirakkal", districtId: 13 },
  { name: "Chittariparamba", districtId: 13 },
  { name: "Chokli", districtId: 13 },
  { name: "Dharmadam", districtId: 13 },
  { name: "Eramam-Kuttoor", districtId: 13 },
  { name: "Eranholi", districtId: 13 },
  { name: "Eruvessi", districtId: 13 },
  { name: "Ezhom", districtId: 13 },
  { name: "Irikkoor", districtId: 13 },
  { name: "Kadamboor", districtId: 13 },
  { name: "Kadannapally-Panapuzha", districtId: 13 },
  { name: "Kadirur", districtId: 13 },
  { name: "Kalliasseri", districtId: 13 },
  { name: "Kanichar", districtId: 13 },
  { name: "Kankol-Alappadamba", districtId: 13 },
  { name: "Kannapuram", districtId: 13 },
  { name: "Pariyaram", districtId: 13 },
  { name: "Karivlloor-perlam", districtId: 13 },
  { name: "Kizhallur", districtId: 13 },
  { name: "Kelakam", districtId: 13 },
  { name: "Kolacheri", districtId: 13 },
  { name: "Kolayad", districtId: 13 },
  { name: "Koodali", districtId: 13 },
  { name: "Kottayam", districtId: 13 },
  { name: "Kottiyoor", districtId: 13 },
  { name: "Kunhimangalam", districtId: 13 },
  { name: "Kunnothparamba", districtId: 13 },
  { name: "Kurumathoor", districtId: 13 },
  { name: "Kuttiattur", districtId: 13 },
  { name: "Madayi", districtId: 13 },
  { name: "Malapattam", districtId: 13 },
  { name: "Maloor", districtId: 13 },
  { name: "Mangattidom", districtId: 13 },
  { name: "Mattool", districtId: 13 },
  { name: "Mayyil", districtId: 13 },
  { name: "Mokeri", districtId: 13 },
  { name: "Munderi", districtId: 13 },
  { name: "Muzhakkunnu", districtId: 13 },
  { name: "Muzhappilangad", districtId: 13 },
  { name: "Naduvil", districtId: 13 },
  { name: "Narath", districtId: 13 },
  { name: "New Mahi", districtId: 13 },
  { name: "Padiyoor", districtId: 13 },
  { name: "Panniannur", districtId: 13 },
  { name: "Pappinisseri", districtId: 13 },
  { name: "Pattiam", districtId: 13 },
  { name: "Pattuvam", districtId: 13 },
  { name: "Payam", districtId: 13 },
  { name: "Payyavoor", districtId: 13 },
  { name: "Peralasseri", districtId: 13 },
  { name: "Peravoor", districtId: 13 },
  { name: "Peringome-Vayakkara", districtId: 13 },
  { name: "Pinarayi", districtId: 13 },
  { name: "Ramanthali", districtId: 13 },
  { name: "Thillankeri", districtId: 13 },
  { name: "Thrippangottoor", districtId: 13 },
  { name: "Udayagiri", districtId: 13 },
  { name: "Ulikkal", districtId: 13 },
  { name: "Valapattanam", districtId: 13 },
  { name: "Vengad", districtId: 13 },
  { name: "Ajanur", districtId: 14 },
  { name: "Badiadka", districtId: 14 },
  { name: "Balal", districtId: 14 },
  { name: "Bedadka", districtId: 14 },
  { name: "Belloor", districtId: 14 },
  { name: "Chemnad", districtId: 14 },
  { name: "Chengala", districtId: 14 },
  { name: "Cheruvathur", districtId: 14 },
  { name: "Delampady", districtId: 14 },
  { name: "East Eleri", districtId: 14 },
  { name: "Enmakaje", districtId: 14 },
  { name: "Kallar", districtId: 14 },
  { name: "Karadka", districtId: 14 },
  { name: "K.Cheemeni", districtId: 14 },
  { name: "K.karinthalam", districtId: 14 },
  { name: "Kodombelur", districtId: 14 },
  { name: "Kumbadaje", districtId: 14 },
  { name: "Kumbla", districtId: 14 },
  { name: "Kuttikol", districtId: 14 },
  { name: "Madhur", districtId: 14 },
  { name: "Madikai", districtId: 14 },
  { name: "Mangalpady", districtId: 14 },
  { name: "Manjeswar", districtId: 14 },
  { name: "Meenja", districtId: 14 },
  { name: "Mogralputhur", districtId: 14 },
  { name: "Muliyar", districtId: 14 },
  { name: "Padne", districtId: 14 },
  { name: "Paivalike", districtId: 14 },
  { name: "Pallikkere", districtId: 14 },
  { name: "Panathady", districtId: 14 },
  { name: "Pilicode", districtId: 14 },
  { name: "Pullurperiye", districtId: 14 },
  { name: "Puthige", districtId: 14 },
  { name: "Trikaripur", districtId: 14 },
  { name: "Udma", districtId: 14 },
  { name: "Valiyaparamba", districtId: 14 },
  { name: "Vorkady", districtId: 14 },
  { name: "West-Eleri", districtId: 14 },
  { name: "Adhichanalloor", districtId: 2 },
  { name: "Alappad", districtId: 2 },
  { name: "Alayamon", districtId: 2 },
  { name: "Anchal", districtId: 2 },
  { name: "Aryancavu", districtId: 2 },
  { name: "Chadayamanglam", districtId: 2 },
  { name: "Chathannoor", districtId: 2 },
  { name: "Chavara", districtId: 2 },
  { name: "Chirakkara", districtId: 2 },
  { name: "Chithara", districtId: 2 },
  { name: "Clappana", districtId: 2 },
  { name: "Kizhakke Kallada", districtId: 2 },
  { name: "Edamulakkal", districtId: 2 },
  { name: "Elamadu", districtId: 2 },
  { name: "Elampalloor", districtId: 2 },
  { name: "Ezhukone", districtId: 2 },
  { name: "Ittiva", districtId: 2 },
  { name: "Kadakkal", districtId: 2 },
  { name: "Kalluvathukkal", districtId: 2 },
  { name: "Karavaloor", districtId: 2 },
  { name: "Kareepra", districtId: 2 },
  { name: "Kottamkara", districtId: 2 },
  { name: "Kulakkada", districtId: 2 },
  { name: "Kulasekhara Puram", districtId: 2 },
  { name: "Kulathupuzha", districtId: 2 },
  { name: "Kummil", districtId: 2 },
  { name: "Kundara", districtId: 2 },
  { name: "Kunnathoor", districtId: 2 },
  { name: "Munroethuruthu", districtId: 2 },
  { name: "Mayyanad", districtId: 2 },
  { name: "Melila", districtId: 2 },
  { name: "Mylom", districtId: 2 },
  { name: "Mynagappally", districtId: 2 },
  { name: "Nedumpana", districtId: 2 },
  { name: "Neduvathoor", districtId: 2 },
  { name: "Neendakara", districtId: 2 },
  { name: "Nilamel", districtId: 2 },
  { name: "Oachira", districtId: 2 },
  { name: "Panayam", districtId: 2 },
  { name: "Panmana", districtId: 2 },
  { name: "Pathanapuram", districtId: 2 },
  { name: "Pattazhy", districtId: 2 },
  { name: "Pattazhy Vadakkekara", districtId: 2 },
  { name: "Pavithreswaram", districtId: 2 },
  { name: "Perayam", districtId: 2 },
  { name: "Perinad", districtId: 2 },
  { name: "Piravanthoor", districtId: 2 },
  { name: "Poothakkulam", districtId: 2 },
  { name: "Pooyappally", districtId: 2 },
  { name: "Poruvazhy", districtId: 2 },
  { name: "Sasthamcotta", districtId: 2 },
  { name: "Sooranadu North", districtId: 2 },
  { name: "Sooranadu South", districtId: 2 },
  { name: "Thalavoor", districtId: 2 },
  { name: "Thazhava", districtId: 2 },
  { name: "Thekkumbhagom", districtId: 2 },
  { name: "Thenmala", districtId: 2 },
  { name: "Thevalakkara", districtId: 2 },
  { name: "Thodiyoor", districtId: 2 },
  { name: "Thrikkaruva", districtId: 2 },
  { name: "Thrikkovilvattom", districtId: 2 },
  { name: "Ummannoor", districtId: 2 },
  { name: "Velinalloor", districtId: 2 },
  { name: "Veliyam", districtId: 2 },
  { name: "Vettikkavala", districtId: 2 },
  { name: "Vilakkudy", districtId: 2 },
  { name: "West Kallada", districtId: 2 },
  { name: "Yeroor", districtId: 2 },
  { name: "AKALAKUNNAM", districtId: 5 },
  { name: "ARPOOKARA", districtId: 5 },
  { name: "Athirampuzha", districtId: 5 },
  { name: "Ayarkunnam", districtId: 5 },
  { name: "AYMANAM", districtId: 5 },
  { name: "Bharananganam", districtId: 5 },
  { name: "Chempu", districtId: 5 },
  { name: "chirakkadavu", districtId: 5 },
  { name: "ELIKULAM", districtId: 5 },
  { name: "Erumely", districtId: 5 },
  { name: "Kadanad", districtId: 5 },
  { name: "Kadaplamattom", districtId: 5 },
  { name: "Kaduthuruthy", districtId: 5 },
  { name: "Kanakkary", districtId: 5 },
  { name: "Kangazha", districtId: 5 },
  { name: "Kanjirappally", districtId: 5 },
  { name: "Karoor", districtId: 5 },
  { name: "Karukachal", districtId: 5 },
  { name: "Kidangoor", districtId: 5 },
  { name: "Kooroppada", districtId: 5 },
  { name: "Koottickal", districtId: 5 },
  { name: "Koruthodu", districtId: 5 },
  { name: "Kallara (Vaikom)", districtId: 5 },
  { name: "Kozhuvanal", districtId: 5 },
  { name: "KUMARAKOM", districtId: 5 },
  { name: "Kuravilangad", districtId: 5 },
  { name: "KURICHY", districtId: 5 },
  { name: "Madappally", districtId: 5 },
  { name: "Manarcad", districtId: 5 },
  { name: "MANIMALA", districtId: 5 },
  { name: "Manjoor", districtId: 5 },
  { name: "Marangattupilly", districtId: 5 },
  { name: "Maravanthuruth", districtId: 5 },
  { name: "Meenachil", districtId: 5 },
  { name: "Meenadom", districtId: 5 },
  { name: "Melukavu", districtId: 5 },
  { name: "Moonnilavu", districtId: 5 },
  { name: "Mulakulam", districtId: 5 },
  { name: "Mundakayam", districtId: 5 },
  { name: "Mutholy", districtId: 5 },
  { name: "Nedumkunnam", districtId: 5 },
  { name: "Neendoor", districtId: 5 },
  { name: "Njeezhoor", districtId: 5 },
  { name: "Paippad", districtId: 5 },
  { name: "Pallickathodu", districtId: 5 },
  { name: "Pampady", districtId: 5 },
  { name: "Panachikad", districtId: 5 },
  { name: "PARATHODU", districtId: 5 },
  { name: "Poonjar", districtId: 5 },
  { name: "Poonjar Thekkekara", districtId: 5 },
  { name: "Puthuppally", districtId: 5 },
  { name: "RAMAPURAM", districtId: 5 },
  { name: "T V PURAM", districtId: 5 },
  { name: "Teekoy", districtId: 5 },
  { name: "Thalanad", districtId: 5 },
  { name: "Thalappalam", districtId: 5 },
  { name: "Thalayazham", districtId: 5 },
  { name: "Thalayolaparambu", districtId: 5 },
  { name: "Thidanadu", districtId: 5 },
  { name: "Thiruvarppu", districtId: 5 },
  { name: "Thrikodithanam", districtId: 5 },
  { name: "Udayanapuram", districtId: 5 },
  { name: "Uzhavoor", districtId: 5 },
  { name: "Vakathanam", districtId: 5 },
  { name: "Vazhappally", districtId: 5 },
  { name: "Vazhoor", districtId: 5 },
  { name: "Vechoor", districtId: 5 },
  { name: "VELIYANNOOR", districtId: 5 },
  { name: "Vellavoor", districtId: 5 },
  { name: "Velloor", districtId: 5 },
  { name: "Vijayapuram", districtId: 5 },
  { name: "Arikkulam", districtId: 11 },
  { name: "Atholi", districtId: 11 },
  { name: "Ayancheri", districtId: 11 },
  { name: "Azhiyur", districtId: 11 },
  { name: "Balussery", districtId: 11 },
  { name: "Chakkittapara", districtId: 11 },
  { name: "Changaroth", districtId: 11 },
  { name: "Chathamangalam", districtId: 11 },
  { name: "Chekkiad", districtId: 11 },
  { name: "Chelannur", districtId: 11 },
  { name: "Chemancheri", districtId: 11 },
  { name: "Chengottukavu", districtId: 11 },
  { name: "Cheruvannur", districtId: 11 },
  { name: "Chorode", districtId: 11 },
  { name: "Edacheri", districtId: 11 },
  { name: "Eramala", districtId: 11 },
  { name: "Kadalundi", districtId: 11 },
  { name: "Kakkodi", districtId: 11 },
  { name: "Kakkur", districtId: 11 },
  { name: "Karassery", districtId: 11 },
  { name: "Kattipara", districtId: 11 },
  { name: "Kavilumpara", districtId: 11 },
  { name: "Kayakkodi", districtId: 11 },
  { name: "Kayanna", districtId: 11 },
  { name: "Keezhariyur", districtId: 11 },
  { name: "Kizhakkoth", districtId: 11 },
  { name: "Kodenchery", districtId: 11 },
  { name: "Kodiyathur", districtId: 11 },
  { name: "Koodaranhi", districtId: 11 },
  { name: "Koorachundu", districtId: 11 },
  { name: "Koothali", districtId: 11 },
  { name: "Kottur", districtId: 11 },
  { name: "Kunnamangalam", districtId: 11 },
  { name: "Kunnummel", districtId: 11 },
  { name: "Kuruvattur", districtId: 11 },
  { name: "Kuttiadi", districtId: 11 },
  { name: "Madavoor", districtId: 11 },
  { name: "Maniyoor", districtId: 11 },
  { name: "Maruthomkara", districtId: 11 },
  { name: "Mavoor", districtId: 11 },
  { name: "Meppayur", districtId: 11 },
  { name: "Moodadi", districtId: 11 },
  { name: "Nadapuram", districtId: 11 },
  { name: "Naduvannur", districtId: 11 },
  { name: "Nanminda", districtId: 11 },
  { name: "Narikkuni", districtId: 11 },
  { name: "Narippatta", districtId: 11 },
  { name: "Nochad", districtId: 11 },
  { name: "Olavanna", districtId: 11 },
  { name: "Omasseri", districtId: 11 },
  { name: "Onchiyam", districtId: 11 },
  { name: "Panangad", districtId: 11 },
  { name: "Perambra", districtId: 11 },
  { name: "Perumanna", districtId: 11 },
  { name: "Peruvayal", districtId: 11 },
  { name: "Purameri", districtId: 11 },
  { name: "Puduppadi", districtId: 11 },
  { name: "Thalakkulathur", districtId: 11 },
  { name: "Thamarasseri", districtId: 11 },
  { name: "Thikkodi", districtId: 11 },
  { name: "Thiruvallur", districtId: 11 },
  { name: "Thiruvambadi", districtId: 11 },
  { name: "Thurayur", districtId: 11 },
  { name: "Thuneri", districtId: 11 },
  { name: "Ulliyeri", districtId: 11 },
  { name: "Unnikulam", districtId: 11 },
  { name: "Valayam", districtId: 11 },
  { name: "Vanimal", districtId: 11 },
  { name: "Velom", districtId: 11 },
  { name: "Villiappally", districtId: 11 },
  { name: "A R Nagar", districtId: 10 },
  { name: "Alamcode", districtId: 10 },
  { name: "Aliparamba", districtId: 10 },
  { name: "Amarambalam", districtId: 10 },
  { name: "Anakkayam", districtId: 10 },
  { name: "Angadipuram", districtId: 10 },
  { name: "Areacode", districtId: 10 },
  { name: "Athavanad", districtId: 10 },
  { name: "Chaliyar", districtId: 10 },
  { name: "Cheakode", districtId: 10 },
  { name: "Chelembra", districtId: 10 },
  { name: "Cheriyamundam", districtId: 10 },
  { name: "Cherukavu", districtId: 10 },
  { name: "Chokkad", districtId: 10 },
  { name: "Chungathara", districtId: 10 },
  { name: "Edakkara", districtId: 10 },
  { name: "Edappatta", districtId: 10 },
  { name: "Edappal", districtId: 10 },
  { name: "Edarikode", districtId: 10 },
  { name: "Edavanna", districtId: 10 },
  { name: "Edayoor", districtId: 10 },
  { name: "Elamkulam", districtId: 10 },
  { name: "Irimbiliyam", districtId: 10 },
  { name: "Kalady", districtId: 10 },
  { name: "Kalikavu", districtId: 10 },
  { name: "Kalpakancheri", districtId: 10 },
  { name: "Kannamangalam", districtId: 10 },
  { name: "Karulai", districtId: 10 },
  { name: "Karuvarakundu", districtId: 10 },
  { name: "Kavannur", districtId: 10 },
  { name: "Keezhattur", districtId: 10 },
  { name: "Keezhuparamba", districtId: 10 },
  { name: "Kodur", districtId: 10 },
  { name: "Koottilangadi", districtId: 10 },
  { name: "Kuruva", districtId: 10 },
  { name: "Kuttippuram", districtId: 10 },
  { name: "Kuzhimanna", districtId: 10 },
  { name: "Makkaraparamba", districtId: 10 },
  { name: "Mampad", districtId: 10 },
  { name: "Mangalam", districtId: 10 },
  { name: "Mankada", districtId: 10 },
  { name: "Marakkara", districtId: 10 },
  { name: "Maranchery", districtId: 10 },
  { name: "Melattur", districtId: 10 },
  { name: "Moonniyur", districtId: 10 },
  { name: "Moorkkanad", districtId: 10 },
  { name: "Moothedam", districtId: 10 },
  { name: "Morayur", districtId: 10 },
  { name: "Muthuvallur", districtId: 10 },
  { name: "Nannambra", districtId: 10 },
  { name: "Nannamukku", districtId: 10 },
  { name: "Niramaruthoor", districtId: 10 },
  { name: "Othukkungal", districtId: 10 },
  { name: "Ozhur", districtId: 10 },
  { name: "Pallikkal", districtId: 10 },
  { name: "Pandikkad", districtId: 10 },
  { name: "Parappur", districtId: 10 },
  { name: "Perumana klari", districtId: 10 },
  { name: "Perumpadappu", districtId: 10 },
  { name: "Peruvallur", districtId: 10 },
  { name: "Ponmala", districtId: 10 },
  { name: "Ponmundam", districtId: 10 },
  { name: "Pookkottur", districtId: 10 },
  { name: "Porur", districtId: 10 },
  { name: "Pothukkal", districtId: 10 },
  { name: "Pulamanthole", districtId: 10 },
  { name: "Pulikkal", districtId: 10 },
  { name: "Pulpatta", districtId: 10 },
  { name: "Purathur", districtId: 10 },
  { name: "Puzhakkattiri", districtId: 10 },
  { name: "Tavanur", districtId: 10 },
  { name: "Thalakkad", districtId: 10 },
  { name: "Tanalur", districtId: 10 },
  { name: "Thazhekode", districtId: 10 },
  { name: "Thenhippalam", districtId: 10 },
  { name: "Thennala", districtId: 10 },
  { name: "Thirunavaya", districtId: 10 },
  { name: "Thiruvali", districtId: 10 },
  { name: "Thuvvur", districtId: 10 },
  { name: "Trikkalangode", districtId: 10 },
  { name: "Triprangode", districtId: 10 },
  { name: "Uragam", districtId: 10 },
  { name: "Urangattiri", districtId: 10 },
  { name: "Valavannur", districtId: 10 },
  { name: "Vallikkunnu", districtId: 10 },
  { name: "Vattamkulam", districtId: 10 },
  { name: "Vazhakkad", districtId: 10 },
  { name: "Vazhayur", districtId: 10 },
  { name: "Vazhikkadavu", districtId: 10 },
  { name: "Veliyancode", districtId: 10 },
  { name: "Vengara", districtId: 10 },
  { name: "Vettathur", districtId: 10 },
  { name: "Vettom", districtId: 10 },
  { name: "Wandoor", districtId: 10 },
  { name: "Anakkara-president", districtId: 9 },
  { name: "Agali", districtId: 9 },
  { name: "Akathethara", districtId: 9 },
  { name: "Alanallur", districtId: 9 },
  { name: "Alathur", districtId: 9 },
  { name: "Ambalappara", districtId: 9 },
  { name: "Anangnadi", districtId: 9 },
  { name: "Ayiloor", districtId: 9 },
  { name: "Chalavara", districtId: 9 },
  { name: "Chalissery-president", districtId: 9 },
  { name: "Elappully", districtId: 9 },
  { name: "Elavancheri", districtId: 9 },
  { name: "Erimayoor", districtId: 9 },
  { name: "Eruthenpathi", districtId: 9 },
  { name: "Kadampazhypuram", districtId: 9 },
  { name: "Kanjirapuzha", districtId: 9 },
  { name: "Kannadi", districtId: 9 },
  { name: "Kannambra", districtId: 9 },
  { name: "Kappur-president", districtId: 9 },
  { name: "Karakurissi", districtId: 9 },
  { name: "Karimba", districtId: 9 },
  { name: "Karimpuzha", districtId: 9 },
  { name: "Kavasseri", districtId: 9 },
  { name: "Keralasseri", districtId: 9 },
  { name: "Kizhakkencheri", districtId: 9 },
  { name: "Kodumbu", districtId: 9 },
  { name: "Koduvayur", districtId: 9 },
  { name: "Kollengode", districtId: 9 },
  { name: "Kongadu", districtId: 9 },
  { name: "Koppam", districtId: 9 },
  { name: "Kottayi", districtId: 9 },
  { name: "Kottopadam", districtId: 9 },
  { name: "Kozhinjampara", districtId: 9 },
  { name: "Kulukkallor", districtId: 9 },
  { name: "Kumaramputhur", districtId: 9 },
  { name: "Kuthanoor", districtId: 9 },
  { name: "Kuzhalmannam", districtId: 9 },
  { name: "Lekkidi-peroor", districtId: 9 },
  { name: "Malampuzha", districtId: 9 },
  { name: "Mankara", districtId: 9 },
  { name: "Mannor", districtId: 9 },
  { name: "Maruttha road", districtId: 9 },
  { name: "Mathoor", districtId: 9 },
  { name: "Melarkode", districtId: 9 },
  { name: "Mundoor", districtId: 9 },
  { name: "Muthalamada", districtId: 9 },
  { name: "Muthuthala", districtId: 9 },
  { name: "Nagalassery", districtId: 9 },
  { name: "Nallepilly", districtId: 9 },
  { name: "Nellaya", districtId: 9 },
  { name: "Nelliyampathy", districtId: 9 },
  { name: "Nemmara", districtId: 9 },
  { name: "Ongallur", districtId: 9 },
  { name: "Pallassana", districtId: 9 },
  { name: "Parali", districtId: 9 },
  { name: "Paruthur", districtId: 9 },
  { name: "Pattanchery", districtId: 9 },
  { name: "Pattithara-president", districtId: 9 },
  { name: "Perungottukurissi", districtId: 9 },
  { name: "Perumatty", districtId: 9 },
  { name: "Peruvemba", districtId: 9 },
  { name: "Pirayiri", districtId: 9 },
  { name: "Polpully", districtId: 9 },
  { name: "Pookkottukavu", districtId: 9 },
  { name: "Puthucode", districtId: 9 },
  { name: "Puthunagaram", districtId: 9 },
  { name: "Puthupariyaram", districtId: 9 },
  { name: "Pudur", districtId: 9 },
  { name: "Pudussery", districtId: 9 },
  { name: "Sholayur", districtId: 9 },
  { name: "Sreekrishnapuram", districtId: 9 },
  { name: "Thachampara", districtId: 9 },
  { name: "Thachanattukara", districtId: 9 },
  { name: "Tharoor", districtId: 9 },
  { name: "Thenkara", districtId: 9 },
  { name: "Thenkurissi", districtId: 9 },
  { name: "Thirumittakode-president", districtId: 9 },
  { name: "Thiruvegappura", districtId: 9 },
  { name: "Thrikedderi", districtId: 9 },
  { name: "Thrithala", districtId: 9 },
  { name: "Vadakarappathi", districtId: 9 },
  { name: "Vadakkencheri", districtId: 9 },
  { name: "Vadavanoor", districtId: 9 },
  { name: "Vallapuzha", districtId: 9 },
  { name: "Vandazhi", districtId: 9 },
  { name: "Vaniyamkulam", districtId: 9 },
  { name: "Vellinezhi", districtId: 9 },
  { name: "Vilayur", districtId: 9 },
  { name: "Anicaud", districtId: 3 },
  { name: "Aranmula", districtId: 3 },
  { name: "Aruvappulam", districtId: 3 },
  { name: "Ayroor", districtId: 3 },
  { name: "Chenneerkara", districtId: 3 },
  { name: "Cherukole", districtId: 3 },
  { name: "Chittar", districtId: 3 },
  { name: "Elanthur", districtId: 3 },
  { name: "Enadimangalam", districtId: 3 },
  { name: "Erathu", districtId: 3 },
  { name: "Eraviperoor", districtId: 3 },
  { name: "Ezhamkulam", districtId: 3 },
  { name: "Ezhumattur", districtId: 3 },
  { name: "Kadampanad", districtId: 3 },
  { name: "Kadapra", districtId: 3 },
  { name: "Kalanjoor", districtId: 3 },
  { name: "Kallooppara", districtId: 3 },
  { name: "Kaviyoor", districtId: 3 },
  { name: "Kodumon", districtId: 3 },
  { name: "Konni", districtId: 3 },
  { name: "Kottanad", districtId: 3 },
  { name: "Kottangal", districtId: 3 },
  { name: "Koipuram", districtId: 3 },
  { name: "Kozhenchery", districtId: 3 },
  { name: "Kulanada", districtId: 3 },
  { name: "Kunnanthanam", districtId: 3 },
  { name: "Kuttoor", districtId: 3 },
  { name: "Malayalapuzha", districtId: 3 },
  { name: "Mallappally", districtId: 3 },
  { name: "Mallapuzhassery", districtId: 3 },
  { name: "Mezhuveli", districtId: 3 },
  { name: "Mylapra", districtId: 3 },
  { name: "Naranamoozhi", districtId: 3 },
  { name: "Naranganam", districtId: 3 },
  { name: "Nedumpuram", districtId: 3 },
  { name: "Niranam", districtId: 3 },
  { name: "Omallur", districtId: 3 },
  { name: "Pandalam Thekkekkara", districtId: 3 },
  { name: "Pallickal", districtId: 3 },
  { name: "Peringara", districtId: 3 },
  { name: "Pramadom", districtId: 3 },
  { name: "Puramattom", districtId: 3 },
  { name: "Ranni", districtId: 3 },
  { name: "Ranni Angadi", districtId: 3 },
  { name: "Ranni Pazhavangady", districtId: 3 },
  { name: "Ranni Perunad", districtId: 3 },
  { name: "Seethathode", districtId: 3 },
  { name: "Thannithode", districtId: 3 },
  { name: "Thottapuzhassery", districtId: 3 },
  { name: "Thumpamon", districtId: 3 },
  { name: "Vadasserikkara", districtId: 3 },
  { name: "Vallicode", districtId: 3 },
  { name: "Vechoochira", districtId: 3 },
  { name: "Amboori", districtId: 1 },
  { name: "Anadu", districtId: 1 },
  { name: "Anchuthengu", districtId: 1 },
  { name: "Andoorkonam", districtId: 1 },
  { name: "Aruvikkara", districtId: 1 },
  { name: "Aryad", districtId: 1 },
  { name: "Aryancode", districtId: 1 },
  { name: "Athiyannoor", districtId: 1 },
  { name: "Azhoor", districtId: 1 },
  { name: "Balaramapuram", districtId: 1 },
  { name: "Chemmaruthy", districtId: 1 },
  { name: "Chenkal", districtId: 1 },
  { name: "Cherunniyoor", districtId: 1 },
  { name: "Chirayinkeezhu", districtId: 1 },
  { name: "Edava", districtId: 1 },
  { name: "Elakamon", districtId: 1 },
  { name: "Kadaykkavoor", districtId: 1 },
  { name: "Kadinamkulam", districtId: 1 },
  { name: "Kallara", districtId: 1 },
  { name: "Kallikkadu", districtId: 1 },
  { name: "Kalliyoor", districtId: 1 },
  { name: "Kanjiramkulam", districtId: 1 },
  { name: "Karakulam", districtId: 1 },
  { name: "Karavaram", districtId: 1 },
  { name: "Karode", districtId: 1 },
  { name: "Karumkulam", districtId: 1 },
  { name: "Kattakkada", districtId: 1 },
  { name: "Kilimanoor", districtId: 1 },
  { name: "Keezhvillam", districtId: 1 },
  { name: "Kollayil", districtId: 1 },
  { name: "Kottukal", districtId: 1 },
  { name: "Kulathoor", districtId: 1 },
  { name: "Kunnathukal", districtId: 1 },
  { name: "Kuttichal", districtId: 1 },
  { name: "Madavoor", districtId: 1 },
  { name: "Malayinkil", districtId: 1 },
  { name: "Manamboor", districtId: 1 },
  { name: "Mangalapuram", districtId: 1 },
  { name: "Manikkal", districtId: 1 },
  { name: "Maranaloor", districtId: 1 },
  { name: "Mudakkal", districtId: 1 },
  { name: "Nagroor", districtId: 1 },
  { name: "Nanniyodu", districtId: 1 },
  { name: "Navayikkulam", districtId: 1 },
  { name: "Nellanadu", districtId: 1 },
  { name: "Ottasekharamangalam", districtId: 1 },
  { name: "Ottoor", districtId: 1 },
  { name: "Pallichal", districtId: 1 },
  { name: "Pallikkal", districtId: 1 },
  { name: "Panavoor", districtId: 1 },
  { name: "Pangode", districtId: 1 },
  { name: "Parassala", districtId: 1 },
  { name: "Pazhayakunnummal", districtId: 1 },
  { name: "Peringammala", districtId: 1 },
  { name: "Perunkadavila", districtId: 1 },
  { name: "Poovachal", districtId: 1 },
  { name: "Poovar", districtId: 1 },
  { name: "Pothencode", districtId: 1 },
  { name: "Pulimath", districtId: 1 },
  { name: "Pullambara", districtId: 1 },
  { name: "Thirupuram", districtId: 1 },
  { name: "Tholikkodu", districtId: 1 },
  { name: "Uzhamalaykkal", districtId: 1 },
  { name: "Vakkam", districtId: 1 },
  { name: "Vamanapuram", districtId: 1 },
  { name: "Vellanad", districtId: 1 },
  { name: "Vellarada", districtId: 1 },
  { name: "Vembayam", districtId: 1 },
  { name: "Venganoor", districtId: 1 },
  { name: "Vetoor", districtId: 1 },
  { name: "Vilappil", districtId: 1 },
  { name: "Vilavoorkal", districtId: 1 },
  { name: "Vithura", districtId: 1 },
  { name: "Adat", districtId: 8 },
  { name: "Alagapanagar", districtId: 8 },
  { name: "Aloor", districtId: 8 },
  { name: "Annamanada", districtId: 8 },
  { name: "Anthikad", districtId: 8 },
  { name: "Arimbur", districtId: 8 },
  { name: "Athirappilly", districtId: 8 },
  { name: "Avanoor", districtId: 8 },
  { name: "Avinissery", districtId: 8 },
  { name: "Chazhoor", districtId: 8 },
  { name: "Chelakkara", districtId: 8 },
  { name: "Cherpu", districtId: 8 },
  { name: "Choondal", districtId: 8 },
  { name: "Chowannur", districtId: 8 },
  { name: "Desamangalam", districtId: 8 },
  { name: "Edathiruthy", districtId: 8 },
  { name: "Edavilangu", districtId: 8 },
  { name: "Elavally", districtId: 8 },
  { name: "Engandiyur", districtId: 8 },
  { name: "Eriyad", districtId: 8 },
  { name: "Erumapetty", districtId: 8 },
  { name: "Kadangode", districtId: 8 },
  { name: "Kadappuram", districtId: 8 },
  { name: "Kadavallur", districtId: 8 },
  { name: "Kadukutty", districtId: 8 },
  { name: "Kaiparambu", districtId: 8 },
  { name: "Kaipamangalam", districtId: 8 },
  { name: "Kandanassery", districtId: 8 },
  { name: "Karalam", districtId: 8 },
  { name: "Kattakampal", districtId: 8 },
  { name: "Kattur", districtId: 8 },
  { name: "Kodakara", districtId: 8 },
  { name: "Kodassery", districtId: 8 },
  { name: "Kolazhy", districtId: 8 },
  { name: "Kondazhy", districtId: 8 },
  { name: "Koratty", districtId: 8 },
  { name: "Kuzhur", districtId: 8 },
  { name: "Madakkathara", districtId: 8 },
  { name: "Mala", districtId: 8 },
  { name: "Manalur", districtId: 8 },
  { name: "Mathilakam", districtId: 8 },
  { name: "Mattathur", districtId: 8 },
  { name: "Melur", districtId: 8 },
  { name: "Mulamkunnathukavu", districtId: 8 },
  { name: "Mullassery", districtId: 8 },
  { name: "Mulloorkara", districtId: 8 },
  { name: "Muriyad", districtId: 8 },
  { name: "Nadathara", districtId: 8 },
  { name: "Nattika", districtId: 8 },
  { name: "Nenmanikkara", districtId: 8 },
  { name: "Orumanayur", districtId: 8 },
  { name: "Padiyur", districtId: 8 },
  { name: "Pananchery", districtId: 8 },
  { name: "Panjal", districtId: 8 },
  { name: "Paralam", districtId: 8 },
  { name: "Parappukkara", districtId: 8 },
  { name: "Pariyaram", districtId: 8 },
  { name: "Pavaratty", districtId: 8 },
  { name: "Pazhayannur", districtId: 8 },
  { name: "Perinjanam", districtId: 8 },
  { name: "Poomangalam", districtId: 8 },
  { name: "Porkulam", districtId: 8 },
  { name: "Poyya", districtId: 8 },
  { name: "Pudukkad", districtId: 8 },
  { name: "Punnayur", districtId: 8 },
  { name: "Punnayurkulam", districtId: 8 },
  { name: "Puthenchira", districtId: 8 },
  { name: "Puthur", districtId: 8 },
  { name: "Sreenarayanapuram", districtId: 8 },
  { name: "Thalikulam", districtId: 8 },
  { name: "Thanniam", districtId: 8 },
  { name: "Thekkumkara", districtId: 8 },
  { name: "Thiruvilwamala", districtId: 8 },
  { name: "Tholur", districtId: 8 },
  { name: "Thrikkur", districtId: 8 },
  { name: "Vadakkekad", districtId: 8 },
  { name: "Vatanappilly", districtId: 8 },
  { name: "Valappad", districtId: 8 },
  { name: "Vallachira", districtId: 8 },
  { name: "Vallathol Nagar", districtId: 8 },
  { name: "Varandarappilly", districtId: 8 },
  { name: "Varavoor", districtId: 8 },
  { name: "Vellangallur", districtId: 8 },
  { name: "Velukkara", districtId: 8 },
  { name: "Velur", districtId: 8 },
  { name: "Venkidangu", districtId: 8 },
  { name: "Ambalavayal", districtId: 12 },
  { name: "Edavaka", districtId: 12 },
  { name: "Kaniyambetta", districtId: 12 },
  { name: "Kottathara", districtId: 12 },
  { name: "Meeanangadi", districtId: 12 },
  { name: "Meppadi", districtId: 12 },
  { name: "Mooppainadu", districtId: 12 },
  { name: "Mullankolly", districtId: 12 },
  { name: "Muttil", districtId: 12 },
  { name: "Nenmeni", districtId: 12 },
  { name: "Noolpuzha", districtId: 12 },
  { name: "Padincharathara", districtId: 12 },
  { name: "Panamaram", districtId: 12 },
  { name: "Poothadi", districtId: 12 },
  { name: "Pozhuthana", districtId: 12 },
  { name: "Pulpalli", districtId: 12 },
  { name: "Thariode", districtId: 12 },
  { name: "Thavinchal", districtId: 12 },
  { name: "Thirunelli", districtId: 12 },
  { name: "Thondernadu", districtId: 12 },
  { name: "Vythiri", districtId: 12 },
  { name: "Vellamunda", districtId: 12 },
  { name: "Vengapalli", districtId: 12 },
  { name: "Wayanad", districtId: 12 },
  { name: "Wayanad", districtId: 10 },
  { name: "Akampadam", districtId: 10 },
  { name: "Puthuseri", districtId: 9 },
],
Typeofcrops: [],
      defaultChecked: true,
      geocoder: null,
      marker: null,
      prevLocation: null,
      keralaBounds: {
        north: 12.924,
        south: 8.074,
        west: 74.855,
        east: 77.509,
      },

      docs1: [],
      docs1Public: [],
      docsPublic: [],
      docs: [],
      displayImage: [],
      userList: [],
      incidentDate: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`,
      incidentTime: `${pad(now.getHours())}:${pad(now.getMinutes())}`,
      dateMenu: false,
      userArray: [],
      newArray: [],
      doc: null,
      file: null,
      keyword: "",
      proceduresCompleted24hrs: "",
      registerAssets: {},
      formData: new FormData(),
      assetId: "",
      search: "",
      Rules: [(value) => !!value || "Required."],
      fileArray: [],
      byte: "",
      kb: "",
      mb: "",
      gb: "",
      selectedDistrict: "",
    selectedAssembly: "",
    selectedConstituency: "",
    selectedPanchayat: "",
    localBodyType: "",
    filteredAssemblies: [],
    filteredConstituencies: [],
    filteredPanchayats: [],
    rangeList: [],
    rangename: "",
    ConflictTypes: [],
    ConflictType: [],
    Unitsofcrops: [
      "Acre",
      "Hectare",
      "Square Meter",
      "Square Kilometer",
      "Nos",
    ],
    cropTypedetails: [{ cropId: "", count: "", unit: "" }],
    propertyTypedetails: [{ propertyType: "", damageDetail: "" }],
    nopeopleinjured: 0,
    injuredPeople: [],
    speciesOptions: [
      "Tiger",
      "Wild Boar",
      "Elephant",
      "Wild gaur",
      "Leopard",
      "Sambar Deer",
      "Jackal",
      "Monkey",
      "Snake",
      "Deer",
      "Wild Dog",
      "Wild Cat",
      "Bear",
      "Otter",
      "Blue Whale",
      "Civet",
      "Langoor",
      "Indian Giant Squirrel",
      "Indian Wolf",
      "Nilgiri Langoor",
      "Peacock",
      "Procupine",
      "Spotted Deer",
      "Wasp",
      "Bees",
      "Unidentified Wild Animal",
    ],
    persongender: ["Male", "Female", "Other"],
    tribeStatus: ["Tribe", "Non-Tribe"],
    WhetherHospitalized: ["Yes", "No"],
    nopeopledied: 0,
    peopleDead: [],
    animalInjuryDetails: { injuredNumber: "", typeOfInjury: "" },
    animalDeathDetails: { numberOfDied: "" },
    animalDeathDetailsList: [{ species: "", gender: "", causeOfDeath: "" }],
    depredationType: ["Injury", "Death"],
    livestockanimal: [
      { injuryOrDeath: "", typeOfAnimal: "", numberOfAnimals: "" },
    ],
    locationLoading: false,
    locationTimer: null,
    reportId: null,           
    isSaved: false,    
    isEditMode: false,     
    hasChanges: false,  
    hasUnsavedChanges: false,
    isSubmitted: false,
    saving: false,           
    submitting: false,
    SectionData: [
  {
    "id": 1,
    "name": "Ettapadappu Forest Section",
    "created_date": "2024-01-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 48
  },
  {
    "id": 2,
    "name": "Kalamkunnu Forest Section",
    "created_date": "2024-01-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 48
  },
  {
    "id": 3,
    "name": "Kalluvarambu Forest Section",
    "created_date": "2024-01-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 48
  },
  {
    "id": 4,
    "name": "Chembuthangi Forest Section",
    "created_date": "2024-01-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 85
  },
  {
    "id": 5,
    "name": "Kottoor Forest Section",
    "created_date": "2024-01-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 85
  },
  {
    "id": 6,
    "name": "Pulininnakala Forest Section",
    "created_date": "2024-01-11",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 85
  },
  {
    "id": 7,
    "name": "Special Duty Forest Section",
    "created_date": "2024-01-12",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 85
  },
  {
    "id": 8,
    "name": "Neyyar Wildlife Sanctuary",
    "created_date": "2024-01-13",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 83
  },
  {
    "id": 9,
    "name": "Klamala 1 Forest Section",
    "created_date": "2024-01-14",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 83
  },
  {
    "id": 10,
    "name": "Klamala 2 Forest Section",
    "created_date": "2024-01-15",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 83
  },
  {
    "id": 11,
    "name": "Kottoor Forest Section",
    "created_date": "2024-01-16",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 83
  },
  {
    "id": 12,
    "name": "Peppara Wildlife Sanctuary",
    "created_date": "2024-01-17",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 86
  },
  {
    "id": 13,
    "name": "Athirumala Forest Section",
    "created_date": "2024-01-18",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 86
  },
  {
    "id": 14,
    "name": "Thodayar Forest Section",
    "created_date": "2024-01-19",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 86
  },
  {
    "id": 16,
    "name": "Parakkadavu Forest Section",
    "created_date": "2024-01-20",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 89
  },
  {
    "id": 17,
    "name": "Varandarappilly Forest Section",
    "created_date": "2024-01-21",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 89
  },
  {
    "id": 19,
    "name": "Karikkadavu Forest Section",
    "created_date": "2024-01-22",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 8
  },
  {
    "id": 20,
    "name": "Kodassery Forest Section",
    "created_date": "2024-01-23",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 8
  },
  {
    "id": 21,
    "name": "Kormala Forest Section",
    "created_date": "2024-01-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 8
  },
  {
    "id": 22,
    "name": "Mullappana Forest Section",
    "created_date": "2024-01-25",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 8
  },
  {
    "id": 24,
    "name": "Chettikkulam Forest Section",
    "created_date": "2024-01-26",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 87
  },
  {
    "id": 25,
    "name": "Kavala Forest Section",
    "created_date": "2024-01-27",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 87
  },
  {
    "id": 27,
    "name": "Mupliyam Forest Section",
    "created_date": "2024-01-28",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 87
  },
  {
    "id": 28,
    "name": "Ennaikkal Forest Station",
    "created_date": "2024-01-29",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 2
  },
  {
    "id": 29,
    "name": "Perumuzhy Forest Station",
    "created_date": "2024-01-30",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 2
  },
  {
    "id": 30,
    "name": "Evergreen Forest Station",
    "created_date": "2024-01-31",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 3
  },
  {
    "id": 32,
    "name": "Kannimanagalam Forest Station",
    "created_date": "2024-02-01",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 3
  },
  {
    "id": 33,
    "name": "Karakkad Forest Station",
    "created_date": "2024-02-02",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 3
  },
  {
    "id": 36,
    "name": "Erumugham Forest Station",
    "created_date": "2024-02-03",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 4
  },
  {
    "id": 37,
    "name": "Kaprikkad Forest Section",
    "created_date": "2024-02-04",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 4
  },
  {
    "id": 38,
    "name": "Maikappala Forest Station",
    "created_date": "2024-02-05",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 4
  },
  {
    "id": 39,
    "name": "Perumthodu Forest Station",
    "created_date": "2024-02-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 4
  },
  {
    "id": 40,
    "name": "Anakulam Forest Station",
    "created_date": "2024-02-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 14
  },
  {
    "id": 41,
    "name": "Pooyamkutty Forest Station",
    "created_date": "2024-02-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 14
  },
  {
    "id": 42,
    "name": "Bhoothathankettu Forest Station",
    "created_date": "2024-02-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 5
  },
  {
    "id": 44,
    "name": "Edamalayar Forest Station",
    "created_date": "2024-02-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 5
  },
  {
    "id": 45,
    "name": "Karimpani Forest Station",
    "created_date": "2024-02-11",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 5
  },
  {
    "id": 46,
    "name": "Vadattupara Forest Station",
    "created_date": "2024-02-12",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 5
  },
  {
    "id": 47,
    "name": "Akamala Forest Station",
    "created_date": "2024-02-13",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 95
  },
  {
    "id": 48,
    "name": "Attur Forest Section",
    "created_date": "2024-02-14",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 95
  },
  {
    "id": 49,
    "name": "Chelakkara Forest Section",
    "created_date": "2024-02-15",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 95
  },
  {
    "id": 50,
    "name": "Elanad Forest Section",
    "created_date": "2024-02-16",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 95
  },
  {
    "id": 52,
    "name": "Engakkad Forest Section",
    "created_date": "2024-02-18",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 95
  },
  {
    "id": 53,
    "name": "Machad Section",
    "created_date": "2024-02-19",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 95
  },
  {
    "id": 55,
    "name": "Potta Forest Section",
    "created_date": "2024-02-20",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 95
  },
  {
    "id": 56,
    "name": "Vazhani Forest Station",
    "created_date": "2024-02-21",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 95
  },
  {
    "id": 57,
    "name": "Pattikkad Forest Station",
    "created_date": "2024-02-22",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 88
  },
  {
    "id": 58,
    "name": "Mannamangalam Forest Station",
    "created_date": "2024-02-23",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 88
  },
  {
    "id": 59,
    "name": "Erumappety Forest Station",
    "created_date": "2024-02-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 60,
    "name": "Kadangodu Forest Section",
    "created_date": "2024-02-25",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 61,
    "name": "Kanjirakkodu Forest Section",
    "created_date": "2024-02-26",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 62,
    "name": "Kondazhi Forest Section",
    "created_date": "2024-02-27",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 63,
    "name": "Mayannur Forest Station",
    "created_date": "2024-02-28",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 64,
    "name": "Medhuku Forest Section",
    "created_date": "2024-02-29",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 65,
    "name": "Mulloorkara Forest Section",
    "created_date": "2024-03-01",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 66,
    "name": "Nelluvai Forest Section",
    "created_date": "2024-03-02",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 67,
    "name": "Pazhavoor-Thayoor Forest Section",
    "created_date": "2024-03-03",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 68,
    "name": "Poongodu Forest Station",
    "created_date": "2024-03-04",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 69,
    "name": "Thiruvilwamala Forest Section",
    "created_date": "2024-03-05",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 70,
    "name": "Vettikkad Forest Section",
    "created_date": "2024-03-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 63
  },
  {
    "id": 71,
    "name": "Athirappilly Forest Station",
    "created_date": "2024-03-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 6
  },
  {
    "id": 72,
    "name": "Ezhattumugham Forest Station",
    "created_date": "2024-03-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 6
  },
  {
    "id": 73,
    "name": "Kannankuzhy Forest Station",
    "created_date": "2024-03-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 90
  },
  {
    "id": 74,
    "name": "Vazhachal Forest Chek Post",
    "created_date": "2024-03-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 90
  },
  {
    "id": 75,
    "name": "Kollathirumedu Forest Station",
    "created_date": "2024-03-11",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 7
  },
  {
    "id": 77,
    "name": "Malakkappara Forest Station",
    "created_date": "2024-03-12",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 91
  },
  {
    "id": 78,
    "name": "Sholayar Forest Station",
    "created_date": "2024-03-13",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 91
  },
  {
    "id": 79,
    "name": "Mukkumpuzha Forest Station",
    "created_date": "2024-03-14",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 92
  },
  {
    "id": 80,
    "name": "Vazhachal Forest Station",
    "created_date": "2024-03-15",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 92
  },
  {
    "id": 81,
    "name": "Ommala Forest Station",
    "created_date": "2024-03-16",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 71
  },
  {
    "id": 82,
    "name": "Sholayur Forest Station",
    "created_date": "2024-03-17",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 71
  },
  {
    "id": 83,
    "name": "Singappara Forest Station",
    "created_date": "2024-03-18",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 71
  },
  {
    "id": 84,
    "name": "Mukkali Forest Station",
    "created_date": "2024-03-19",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 72
  },
  {
    "id": 85,
    "name": "Pudur Forest Station",
    "created_date": "2024-03-20",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 72
  },
  {
    "id": 86,
    "name": "Anamooly Forest Station",
    "created_date": "2024-03-21",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 73
  },
  {
    "id": 87,
    "name": "Palakkayam Forest Station",
    "created_date": "2024-03-22",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 73
  },
  {
    "id": 88,
    "name": "Thiruvizhamkunmu Forest Station",
    "created_date": "2024-03-23",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 73
  },
  {
    "id": 89,
    "name": "Choolanur Forest Section",
    "created_date": "2024-03-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 61
  },
  {
    "id": 90,
    "name": "Mangalamdam Forest Station",
    "created_date": "2024-03-25",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 61
  },
  {
    "id": 91,
    "name": "Vadakkenchery Forest Section",
    "created_date": "2024-03-26",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 61
  },
  {
    "id": 93,
    "name": "Kollengode Forest Section",
    "created_date": "2024-03-27",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 65
  },
  {
    "id": 94,
    "name": "Thekkady Forest Station",
    "created_date": "2024-03-28",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 65
  },
  {
    "id": 95,
    "name": "Nelliyampathy Forest Station",
    "created_date": "2024-03-29",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 66
  },
  {
    "id": 96,
    "name": "Pothundy Forest Section",
    "created_date": "2024-03-30",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 66
  },
  {
    "id": 97,
    "name": "Thiruvizhayadu Forest Section",
    "created_date": "2024-03-31",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 66
  },
  {
    "id": 98,
    "name": "Akampadam Forest Station",
    "created_date": "2024-04-01",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 55
  },
  {
    "id": 99,
    "name": "Edacode Forest Station",
    "created_date": "2024-04-02",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 55
  },
  {
    "id": 100,
    "name": "Kodumpuzha Forest Station",
    "created_date": "2024-04-03",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 55
  },
  {
    "id": 101,
    "name": "Kanhirapuzha Forest Station",
    "created_date": "2024-04-04",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 57
  },
  {
    "id": 102,
    "name": "Valluvassery Forest Section",
    "created_date": "2024-04-05",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 57
  },
  {
    "id": 103,
    "name": "Panayamkode Forest Section",
    "created_date": "2024-04-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 57
  },
  {
    "id": 104,
    "name": "Vaniampuzha Forest Station",
    "created_date": "2024-04-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 57
  },
  {
    "id": 105,
    "name": "Nellikuthu Forest Station",
    "created_date": "2024-04-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 60
  },
  {
    "id": 106,
    "name": "Pothukal Forest Station",
    "created_date": "2024-04-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 60
  },
  {
    "id": 107,
    "name": "Chakkikuzhi Forest Station",
    "created_date": "2024-04-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 56
  },
  {
    "id": 108,
    "name": "Karuvarakundu Forest Station",
    "created_date": "2024-04-11",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 56
  },
  {
    "id": 109,
    "name": "Nedumkayam Forest Station",
    "created_date": "2024-04-12",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 58
  },
  {
    "id": 110,
    "name": "Padukka Forest Station",
    "created_date": "2024-04-13",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 58
  },
  {
    "id": 111,
    "name": "Dhoni Forest Section",
    "created_date": "2024-04-14",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 76
  },
  {
    "id": 112,
    "name": "Elival Forest Section",
    "created_date": "2024-04-15",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 76
  },
  {
    "id": 113,
    "name": "Mundur Forest Section",
    "created_date": "2024-04-16",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 76
  },
  {
    "id": 114,
    "name": "Town Forest Section",
    "created_date": "2024-04-17",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 76
  },
  {
    "id": 115,
    "name": "Kulappulli Forest Section",
    "created_date": "2024-04-18",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 75
  },
  {
    "id": 116,
    "name": "Pattambi Forest Section",
    "created_date": "2024-04-19",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 75
  },
  {
    "id": 117,
    "name": "Thiruvazhiyode Forest Section",
    "created_date": "2024-04-20",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 75
  },
  {
    "id": 118,
    "name": "Akathethara Forest Section",
    "created_date": "2024-04-21",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 77
  },
  {
    "id": 119,
    "name": "Kottekkad Forest Section",
    "created_date": "2024-04-22",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 77
  },
  {
    "id": 120,
    "name": "Akamalavaram Forest Section",
    "created_date": "2024-04-23",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 77
  },
  {
    "id": 121,
    "name": "Pudussery North Forest Section",
    "created_date": "2024-04-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 77
  },
  {
    "id": 122,
    "name": "Pudussery South Forest Section",
    "created_date": "2024-04-25",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 77
  },
  {
    "id": 123,
    "name": "Walayar Forest Section",
    "created_date": "2024-04-26",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 77
  },
  {
    "id": 124,
    "name": "Keezhukkanam Forest Section",
    "created_date": "2024-04-27",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 27
  },
  {
    "id": 125,
    "name": "Vellapara Forest Section",
    "created_date": "2024-04-28",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 27
  },
  {
    "id": 126,
    "name": "Thattekad Forest Section",
    "created_date": "2024-04-29",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 15
  },
  {
    "id": 127,
    "name": "Urulanthanni Forest Section",
    "created_date": "2024-04-30",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 15
  },
  {
    "id": 128,
    "name": "Chinnar Forest Section",
    "created_date": "2024-05-01",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 23
  },
  {
    "id": 129,
    "name": "Karimutty Forest Section",
    "created_date": "2024-05-02",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 23
  },
  {
    "id": 130,
    "name": "Poovar Forest Section",
    "created_date": "2024-05-03",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 20
  },
  {
    "id": 131,
    "name": "Rajamala Forest Section",
    "created_date": "2024-05-04",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 20
  },
  {
    "id": 132,
    "name": "Eravangalar Forest Section",
    "created_date": "2024-05-05",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 133,
    "name": "Kottamala Forest Section",
    "created_date": "2024-05-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 134,
    "name": "Manalar Forest Section",
    "created_date": "2024-05-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 135,
    "name": "Mavady Forest Section",
    "created_date": "2024-05-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 136,
    "name": "Mlappara Forest Section",
    "created_date": "2024-05-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 137,
    "name": "Moolavaiga Forest Section",
    "created_date": "2024-05-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 138,
    "name": "Periyar Forest Section",
    "created_date": "2024-05-11",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 139,
    "name": "Randattinkara Forest Section",
    "created_date": "2024-05-12",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 140,
    "name": "Sundaramala Forest Section",
    "created_date": "2024-05-13",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 141,
    "name": "Thamara Forest Section",
    "created_date": "2024-05-14",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 142,
    "name": "Thannikudy Forest Section",
    "created_date": "2024-05-15",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 143,
    "name": "Ummikkappan Forest Section",
    "created_date": "2024-05-16",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 31
  },
  {
    "id": 144,
    "name": "Edapalayam Forest Section",
    "created_date": "2024-05-17",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 32
  },
  {
    "id": 145,
    "name": "HQ Wireless Forest Station",
    "created_date": "2024-05-18",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 32
  },
  {
    "id": 146,
    "name": "Methakanam Forest Section",
    "created_date": "2024-05-19",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 32
  },
  {
    "id": 147,
    "name": "Mullakudy Forest Section",
    "created_date": "2024-05-20",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 32
  },
  {
    "id": 148,
    "name": "Nellikkampetty Forest Section",
    "created_date": "2024-05-21",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 32
  },
  {
    "id": 149,
    "name": "Thekkady Forest Section",
    "created_date": "2024-05-22",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 32
  },
  {
    "id": 150,
    "name": "Aruviyoda Forest Section",
    "created_date": "2024-05-23",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 33
  },
  {
    "id": 151,
    "name": "Kalardichan Forest Section",
    "created_date": "2024-05-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 33
  },
  {
    "id": 152,
    "name": "Kozhikkanam Forest Section",
    "created_date": "2024-05-25",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 33
  },
  {
    "id": 153,
    "name": "Thondiyar Forest Section",
    "created_date": "2024-05-26",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 33
  },
  {
    "id": 154,
    "name": "Vallakkadavu Forest Section",
    "created_date": "2024-05-27",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 33
  },
  {
    "id": 155,
    "name": "Azhutha Forest Section",
    "created_date": "2024-05-28",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 34
  },
  {
    "id": 156,
    "name": "Choozhi Forest Section",
    "created_date": "2024-05-29",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 34
  },
  {
    "id": 157,
    "name": "Kumarakom Forest Section",
    "created_date": "2024-05-30",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 34
  },
  {
    "id": 158,
    "name": "Moozhikkal Forest Section",
    "created_date": "2024-05-31",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 34
  },
  {
    "id": 159,
    "name": "Sathram Forest Section",
    "created_date": "2024-06-01",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 34
  },
  {
    "id": 160,
    "name": "Uppupara Forest Section",
    "created_date": "2024-06-02",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 34
  },
  {
    "id": 161,
    "name": "Pamba Assistant Wildlife Warden",
    "created_date": "2024-06-03",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 35
  },
  {
    "id": 162,
    "name": "Karimala Forest Section",
    "created_date": "2024-06-04",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 35
  },
  {
    "id": 163,
    "name": "Pachakanam Forest Section",
    "created_date": "2024-06-05",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 35
  },
  {
    "id": 164,
    "name": "Pampavalley Forest Section",
    "created_date": "2024-06-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 35
  },
  {
    "id": 165,
    "name": "Puthussery Forest Section",
    "created_date": "2024-06-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 35
  },
  {
    "id": 166,
    "name": "Sabarimala Forest Section",
    "created_date": "2024-06-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 35
  },
  {
    "id": 167,
    "name": "Kaliyar Forest Section",
    "created_date": "2024-06-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 11
  },
  {
    "id": 168,
    "name": "Neduvakkad Forest Section",
    "created_date": "2024-06-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 11
  },
  {
    "id": 169,
    "name": "Kothamangalam Forest Section",
    "created_date": "2024-06-11",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 9
  },
  {
    "id": 170,
    "name": "Thattekkad Forest Section",
    "created_date": "2024-06-12",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 9
  },
  {
    "id": 171,
    "name": "Chullikkandam Forest Section",
    "created_date": "2024-06-13",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 12
  },
  {
    "id": 172,
    "name": "Mullaringadu Forest Section",
    "created_date": "2024-06-14",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 12
  },
  {
    "id": 173,
    "name": "Arakkulam Forest Section",
    "created_date": "2024-06-15",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 18
  },
  {
    "id": 174,
    "name": "Kulamavu Forest Section",
    "created_date": "2024-06-16",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 18
  },
  {
    "id": 177,
    "name": "Peringassery Forest Section",
    "created_date": "2024-06-17",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 18
  },
  {
    "id": 178,
    "name": "Veloor Forest Station",
    "created_date": "2024-06-18",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 18
  },
  {
    "id": 179,
    "name": "Veloor Forest Section",
    "created_date": "2024-06-19",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 18
  },
  {
    "id": 180,
    "name": "Veloor T Plantation Section",
    "created_date": "2024-06-20",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 18
  },
  {
    "id": 181,
    "name": "Kanchiyar Forest Station",
    "created_date": "2024-06-21",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 28
  },
  {
    "id": 182,
    "name": "Chellarcoil Forest Section",
    "created_date": "2024-06-22",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 29
  },
  {
    "id": 183,
    "name": "Chinnar Special Forest Section",
    "created_date": "2024-06-23",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 29
  },
  {
    "id": 185,
    "name": "Kallar Forest Section",
    "created_date": "2024-06-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 29
  },
  {
    "id": 187,
    "name": "Puliyanmala Forest Section",
    "created_date": "2024-06-25",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 29
  },
  {
    "id": 188,
    "name": "Vandanmedu Forest Section",
    "created_date": "2024-06-26",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 29
  },
  {
    "id": 189,
    "name": "Murinjapuzha Forest Station",
    "created_date": "2024-06-27",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 10
  },
  {
    "id": 190,
    "name": "Plachery Forest Station",
    "created_date": "2024-06-28",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 10
  },
  {
    "id": 192,
    "name": "Vandanpathal Forest Station",
    "created_date": "2024-06-29",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 10
  },
  {
    "id": 194,
    "name": "Vairamony Forest Station",
    "created_date": "2024-06-30",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 30
  },
  {
    "id": 195,
    "name": "Vazhathopu Forest Station",
    "created_date": "2024-07-01",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 30
  },
  {
    "id": 196,
    "name": "Anakulam Forest Section",
    "created_date": "2024-07-02",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 24
  },
  {
    "id": 197,
    "name": "Viripara Forest Section",
    "created_date": "2024-07-03",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 24
  },
  {
    "id": 198,
    "name": "Kadalar Forest Section",
    "created_date": "2024-07-04",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 25
  },
  {
    "id": 199,
    "name": "Mankulam Forest Section",
    "created_date": "2024-07-05",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 25
  },
  {
    "id": 200,
    "name": "Kanthaloor Forest Station",
    "created_date": "2024-07-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 22
  },
  {
    "id": 201,
    "name": "Vannanthura Forest Station",
    "created_date": "2024-07-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 22
  },
  {
    "id": 202,
    "name": "Marayoor Forest Station",
    "created_date": "2024-07-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 26
  },
  {
    "id": 203,
    "name": "Nachivayal Forest Station",
    "created_date": "2024-07-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 26
  },
  {
    "id": 204,
    "name": "Machiplavu Forest Station",
    "created_date": "2024-07-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 16
  },
  {
    "id": 205,
    "name": "Panamkutty Forest Station",
    "created_date": "2024-07-11",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 16
  },
  {
    "id": 206,
    "name": "Aruvikkadu Forest Section",
    "created_date": "2024-07-12",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 19
  },
  {
    "id": 207,
    "name": "Chinnakkanal Forest Section",
    "created_date": "2024-07-13",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 19
  },
  {
    "id": 209,
    "name": "Pallivasal Forest Section",
    "created_date": "2024-07-14",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 19
  },
  {
    "id": 210,
    "name": "Ponmudi Forest Section",
    "created_date": "2024-07-15",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 19
  },
  {
    "id": 211,
    "name": "Thevarammettu Forest Section",
    "created_date": "2024-07-16",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 19
  },
  {
    "id": 212,
    "name": "Peettimudi Forest Station",
    "created_date": "2024-07-17",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 17
  },
  {
    "id": 213,
    "name": "Inchathotty Forest Station",
    "created_date": "2024-07-18",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 13
  },
  {
    "id": 214,
    "name": "Nagarampara Forest Station",
    "created_date": "2024-07-19",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 13
  },
  {
    "id": 216,
    "name": "Valara Forest Station",
    "created_date": "2024-07-20",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 13
  },
  {
    "id": 217,
    "name": "Kannavam Forest Section",
    "created_date": "2024-07-21",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 39
  },
  {
    "id": 218,
    "name": "Nedumpoil Forest Section",
    "created_date": "2024-07-22",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 39
  },
  {
    "id": 220,
    "name": "Iritty Forest Section",
    "created_date": "2024-07-23",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 36
  },
  {
    "id": 221,
    "name": "Keezhppalli Forest Section",
    "created_date": "2024-07-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 36
  },
  {
    "id": 222,
    "name": "Kottiyoor West Forest Section",
    "created_date": "2024-07-25",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 36
  },
  {
    "id": 223,
    "name": "Manathana Forest Section",
    "created_date": "2024-07-26",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 36
  },
  {
    "id": 224,
    "name": "Tholambra Forest Section",
    "created_date": "2024-07-27",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 36
  },
  {
    "id": 225,
    "name": "Karamaramthattu Forest Section",
    "created_date": "2024-07-28",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 38
  },
  {
    "id": 226,
    "name": "Sreekandapuram Forest Section",
    "created_date": "2024-07-29",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 38
  },
  {
    "id": 227,
    "name": "Bheemanadi Forest Section",
    "created_date": "2024-07-30",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 40
  },
  {
    "id": 228,
    "name": "Maruthome Forest Section",
    "created_date": "2024-07-31",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 40
  },
  {
    "id": 229,
    "name": "Panathadi Forest Section",
    "created_date": "2024-08-01",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 40
  },
  {
    "id": 231,
    "name": "Bandadukka Forest Section",
    "created_date": "2024-08-02",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 41
  },
  {
    "id": 232,
    "name": "Karadukka Forest Section",
    "created_date": "2024-08-03",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 41
  },
  {
    "id": 234,
    "name": "Parappa Forest Section",
    "created_date": "2024-08-04",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 41
  },
  {
    "id": 235,
    "name": "Pasukadavu Forest Section",
    "created_date": "2024-08-05",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 54
  },
  {
    "id": 236,
    "name": "Vilangad Forest Section",
    "created_date": "2024-08-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 54
  },
  {
    "id": 237,
    "name": "Kakkayam Forest Section",
    "created_date": "2024-08-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 52
  },
  {
    "id": 238,
    "name": "Pannikottoor Forest Section",
    "created_date": "2024-08-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 52
  },
  {
    "id": 239,
    "name": "Poozhithodu Forest Section",
    "created_date": "2024-08-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 52
  },
  {
    "id": 240,
    "name": "Edathara Forest Section",
    "created_date": "2024-08-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 53
  },
  {
    "id": 241,
    "name": "Kanalad Forest Section",
    "created_date": "2024-08-11",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 53
  },
  {
    "id": 242,
    "name": "Nairkolly Forest Section",
    "created_date": "2024-08-12",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 53
  },
  {
    "id": 243,
    "name": "Peedikapara Forest Section",
    "created_date": "2024-08-13",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 53
  },
  {
    "id": 244,
    "name": "Puduppady Forest Section",
    "created_date": "2024-08-14",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 53
  },
  {
    "id": 247,
    "name": "Begur Forest Section",
    "created_date": "2024-08-15",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 98
  },
  {
    "id": 249,
    "name": "Thalapoya Forest Station",
    "created_date": "2024-08-16",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 98
  },
  {
    "id": 250,
    "name": "Tirunelli Forest Station",
    "created_date": "2024-08-17",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 98
  },
  {
    "id": 251,
    "name": "Trisileri Forest Section",
    "created_date": "2024-08-18",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 98
  },
  {
    "id": 252,
    "name": "Makkiyad Forest Station",
    "created_date": "2024-08-19",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 96
  },
  {
    "id": 253,
    "name": "Vellamunda Forest Section",
    "created_date": "2024-08-20",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 96
  },
  {
    "id": 254,
    "name": "Kunjhom Forest Station",
    "created_date": "2024-08-21",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 97
  },
  {
    "id": 255,
    "name": "Panoth Forest Section",
    "created_date": "2024-08-22",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 97
  },
  {
    "id": 256,
    "name": "Peria Forest Section",
    "created_date": "2024-08-23",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 97
  },
  {
    "id": 257,
    "name": "Varayal Forest Station",
    "created_date": "2024-08-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 97
  },
  {
    "id": 258,
    "name": "Cheeyambam Forest Section",
    "created_date": "2024-08-25",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 100
  },
  {
    "id": 259,
    "name": "Padiri North Forest Section",
    "created_date": "2024-08-26",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 100
  },
  {
    "id": 260,
    "name": "Padiri South Forest Section",
    "created_date": "2024-08-27",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 100
  },
  {
    "id": 261,
    "name": "Pambra Forest Section",
    "created_date": "2024-08-28",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 100
  },
  {
    "id": 262,
    "name": "Kalpetta Forest Section",
    "created_date": "2024-08-29",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 105
  },
  {
    "id": 264,
    "name": "Padinharathara Forest Section",
    "created_date": "2024-08-30",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 105
  },
  {
    "id": 265,
    "name": "Sugandhagiri Forest Section",
    "created_date": "2024-08-31",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 105
  },
  {
    "id": 266,
    "name": "Baderi Forest Section",
    "created_date": "2024-09-01",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 101
  },
  {
    "id": 268,
    "name": "Kottappady Forest Section",
    "created_date": "2024-09-02",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 101
  },
  {
    "id": 269,
    "name": "Mundakai Forest Section",
    "created_date": "2024-09-03",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 101
  },
  {
    "id": 270,
    "name": "Muttil Forest Section",
    "created_date": "2024-09-04",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 101
  },
  {
    "id": 271,
    "name": "Vythiri Forest Section",
    "created_date": "2024-09-05",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 101
  },
  {
    "id": 272,
    "name": "Kumbhavurutty Forest Station",
    "created_date": "2024-09-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 49
  },
  {
    "id": 273,
    "name": "Aramba Forest Section",
    "created_date": "2024-09-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 78
  },
  {
    "id": 274,
    "name": "Thenmala Forest Section",
    "created_date": "2024-09-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 78
  },
  {
    "id": 275,
    "name": "Alappady Forest Section",
    "created_date": "2024-09-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 79
  },
  {
    "id": 276,
    "name": "Kanayar Forest Section",
    "created_date": "2024-09-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 79
  },
  {
    "id": 277,
    "name": "Mangala Forest Section",
    "created_date": "2024-09-11",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 79
  },
  {
    "id": 279,
    "name": "North Kumaramperoor Forest Station",
    "created_date": "2024-09-12",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 42
  },
  {
    "id": 280,
    "name": "South Kumaramperoor Forest Station",
    "created_date": "2024-09-13",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 42
  },
  {
    "id": 281,
    "name": "Chembala Forest Station",
    "created_date": "2024-09-14",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 46
  },
  {
    "id": 282,
    "name": "Mullumala Forest Station",
    "created_date": "2024-09-15",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 46
  },
  {
    "id": 283,
    "name": "Karippanthodu Forest Station",
    "created_date": "2024-09-16",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 47
  },
  {
    "id": 284,
    "name": "Manneera Forest Station",
    "created_date": "2024-09-17",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 47
  },
  {
    "id": 286,
    "name": "Padam Forest Station",
    "created_date": "2024-09-18",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 47
  },
  {
    "id": 287,
    "name": "Ayiranalloor Forest Section",
    "created_date": "2024-09-19",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 43
  },
  {
    "id": 288,
    "name": "Chithara Forest Section",
    "created_date": "2024-09-20",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 43
  },
  {
    "id": 289,
    "name": "Kalamkunnu Forest Section",
    "created_date": "2024-09-21",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 43
  },
  {
    "id": 290,
    "name": "Karavaloor Forest Section",
    "created_date": "2024-09-22",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 43
  },
  {
    "id": 291,
    "name": "Kulathupuzha Forest Section",
    "created_date": "2024-09-23",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 43
  },
  {
    "id": 292,
    "name": "Madathara Forest Section",
    "created_date": "2024-09-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 43
  },
  {
    "id": 293,
    "name": "Meenkulam Forest Section",
    "created_date": "2024-09-25",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 43
  },
  {
    "id": 294,
    "name": "Yeroor Forest Section",
    "created_date": "2024-09-26",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 43
  },
  {
    "id": 295,
    "name": "Ambanar Forest Section",
    "created_date": "2024-09-27",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 44
  },
  {
    "id": 296,
    "name": "Kadakkamon Forest Section",
    "created_date": "2024-09-28",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 44
  },
  {
    "id": 297,
    "name": "Kadasseri Forest Section",
    "created_date": "2024-09-29",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 44
  },
  {
    "id": 298,
    "name": "Mukkadavu Forest Section",
    "created_date": "2024-09-30",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 44
  },
  {
    "id": 299,
    "name": "Piravanthoor Forest Section",
    "created_date": "2024-10-01",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 44
  },
  {
    "id": 300,
    "name": "Vellamthetty Forest Section",
    "created_date": "2024-10-02",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 44
  },
  {
    "id": 301,
    "name": "Kochukoickal Forest Station",
    "created_date": "2024-10-03",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 80
  },
  {
    "id": 302,
    "name": "Pachakanam Forest Station",
    "created_date": "2024-10-04",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 80
  },
  {
    "id": 303,
    "name": "Plappally Forest Station",
    "created_date": "2024-10-05",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 80
  },
  {
    "id": 304,
    "name": "Kanamala Forest Station",
    "created_date": "2024-10-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 1
  },
  {
    "id": 305,
    "name": "Karikulam Forest Station",
    "created_date": "2024-10-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 1
  },
  {
    "id": 307,
    "name": "Rajampara Forest Station",
    "created_date": "2024-10-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 1
  },
  {
    "id": 308,
    "name": "Chittar Forest Station",
    "created_date": "2024-10-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 81
  },
  {
    "id": 309,
    "name": "Gurunathanmannu Forest Station",
    "created_date": "2024-10-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 81
  },
  {
    "id": 310,
    "name": "Thannithodu Forest Station",
    "created_date": "2024-10-11",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 81
  },
  {
    "id": 312,
    "name": "Edapalayam Forest Section",
    "created_date": "2024-10-12",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 50
  },
  {
    "id": 314,
    "name": "Thalappara Forest Section",
    "created_date": "2024-10-13",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 50
  },
  {
    "id": 315,
    "name": "Edamon Forest Section",
    "created_date": "2024-10-14",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 51
  },
  {
    "id": 316,
    "name": "Kalluvarambu Forest Section",
    "created_date": "2024-10-15",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 51
  },
  {
    "id": 318,
    "name": "Thenmala Forest Section",
    "created_date": "2024-10-16",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 51
  },
  {
    "id": 319,
    "name": "Chittar North Forest Section",
    "created_date": "2024-10-17",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 45
  },
  {
    "id": 320,
    "name": "Chittar South Forest Section",
    "created_date": "2024-10-18",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 45
  },
  {
    "id": 321,
    "name": "Mylamoodu Forest Section",
    "created_date": "2024-10-19",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 45
  },
  {
    "id": 322,
    "name": "Ponmudi Forest Section",
    "created_date": "2024-10-20",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 45
  },
  {
    "id": 323,
    "name": "Sankily Forest Section",
    "created_date": "2024-10-21",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 45
  },
  {
    "id": 324,
    "name": "Bharathannoor Forest Section",
    "created_date": "2024-10-22",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 82
  },
  {
    "id": 325,
    "name": "Chekkonam Forest Section",
    "created_date": "2024-10-23",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 82
  },
  {
    "id": 326,
    "name": "Kallar Forest Section",
    "created_date": "2024-10-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 82
  },
  {
    "id": 327,
    "name": "Pachamala Forest Section",
    "created_date": "2024-10-25",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 82
  },
  {
    "id": 328,
    "name": "Peringamala Forest Section",
    "created_date": "2024-10-26",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 82
  },
  {
    "id": 329,
    "name": "Aryanadu Palode Forest Section",
    "created_date": "2024-10-27",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 84
  },
  {
    "id": 330,
    "name": "Chooliyamala Forest Section",
    "created_date": "2024-10-28",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 84
  },
  {
    "id": 331,
    "name": "Vithura Forest Section",
    "created_date": "2024-10-29",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 84
  },
  {
    "id": 332,
    "name": "Aralam Forest Section",
    "created_date": "2024-10-30",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 37
  },
  {
    "id": 333,
    "name": "Narikkadavu Forest Station",
    "created_date": "2024-10-31",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 37
  },
  {
    "id": 334,
    "name": "Kottiyoor Wildlife Sanctuary",
    "created_date": "2024-11-01",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 37
  },
  {
    "id": 335,
    "name": "Karimala Forest Section",
    "created_date": "2024-11-02",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 69
  },
  {
    "id": 336,
    "name": "Kothala Forest Section",
    "created_date": "2024-11-03",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 69
  },
  {
    "id": 337,
    "name": "Kottayal Forest Section",
    "created_date": "2024-11-04",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 69
  },
  {
    "id": 338,
    "name": "Poopara Forest Section",
    "created_date": "2024-11-05",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 69
  },
  {
    "id": 339,
    "name": "Muthuvarachal Forest Section",
    "created_date": "2024-11-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 70
  },
  {
    "id": 340,
    "name": "Pulikkal Forest Section",
    "created_date": "2024-11-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 70
  },
  {
    "id": 341,
    "name": "Thellikkal Forest Section",
    "created_date": "2024-11-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 70
  },
  {
    "id": 342,
    "name": "Parambiar Forest Section",
    "created_date": "2024-11-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 67
  },
  {
    "id": 343,
    "name": "Vengoli Forest Section",
    "created_date": "2024-11-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 67
  },
  {
    "id": 344,
    "name": "Anappady Forest Section",
    "created_date": "2024-11-11",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 68
  },
  {
    "id": 345,
    "name": "Chettivara Forest Section",
    "created_date": "2024-11-12",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 68
  },
  {
    "id": 346,
    "name": "Elathodu Forest Section",
    "created_date": "2024-11-13",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 68
  },
  {
    "id": 347,
    "name": "Peruvari Forest Section",
    "created_date": "2024-11-14",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 68
  },
  {
    "id": 348,
    "name": "Chimmony Forest Station",
    "created_date": "2024-11-15",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 93
  },
  {
    "id": 349,
    "name": "Kavala Forest Station",
    "created_date": "2024-11-16",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 93
  },
  {
    "id": 351,
    "name": "Peechi Forest Station",
    "created_date": "2024-11-17",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 62
  },
  {
    "id": 352,
    "name": "Choolanur Peafowl Sanctuary",
    "created_date": "2024-11-18",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 62
  },
  {
    "id": 353,
    "name": "Olakara Forest Station",
    "created_date": "2024-11-19",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 62
  },
  {
    "id": 354,
    "name": "Vaniyampara Forest Station",
    "created_date": "2024-11-20",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 62
  },
  {
    "id": 355,
    "name": "Anavai Forest Station",
    "created_date": "2024-11-21",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 74
  },
  {
    "id": 356,
    "name": "Thudukki Forest Station",
    "created_date": "2024-11-22",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 74
  },
  {
    "id": 357,
    "name": "Sairandhry Forest Section",
    "created_date": "2024-11-23",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 59
  },
  {
    "id": 358,
    "name": "Poochippara Core Forest Section",
    "created_date": "2024-11-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 59
  },
  {
    "id": 359,
    "name": "Walakkad Forest Section",
    "created_date": "2024-11-25",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 59
  },
  {
    "id": 360,
    "name": "Neelikkal Forest Section",
    "created_date": "2024-11-26",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 59
  },
  {
    "id": 361,
    "name": "Poochippara Buffer Forest Section",
    "created_date": "2024-11-27",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 59
  },
  {
    "id": 362,
    "name": "Walakkad Buffer Forest Section",
    "created_date": "2024-11-28",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 59
  },
  {
    "id": 364,
    "name": "Kuppadi Forest Station",
    "created_date": "2024-11-29",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 102
  },
  {
    "id": 365,
    "name": "Thathoor Forest Section",
    "created_date": "2024-11-30",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 102
  },
  {
    "id": 366,
    "name": "Vandikadavu Forest Station",
    "created_date": "2024-12-01",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 102
  },
  {
    "id": 367,
    "name": "Muthanga Forest Station",
    "created_date": "2024-12-02",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 104
  },
  {
    "id": 370,
    "name": "Thottamoola Forest Station",
    "created_date": "2024-12-03",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 104
  },
  {
    "id": 395,
    "name": "Thulumala Section",
    "created_date": "2024-12-10",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 71
  },
  {
    "id": 396,
    "name": "Mukkuzhy Forest Station",
    "created_date": "2026-10-24",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 35
  },
  {
    "id": 371,
    "name": "Naikkatty Forest Station",
    "created_date": "2024-12-04",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 103
  },
  {
    "id": 372,
    "name": "Ottipara Forest Section",
    "created_date": "2024-12-05",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 103
  },
  {
    "id": 373,
    "name": "Ponkuzhi Forest Section",
    "created_date": "2024-12-06",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 103
  },
  {
    "id": 374,
    "name": "Bavali Forest Section",
    "created_date": "2024-12-07",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 375,
    "name": "Dasanakatta Forest Section",
    "created_date": "2024-12-08",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 376,
    "name": "Tholpetty Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 377,
    "name": "Punnala Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 378,
    "name": "Ezhamkulam Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 379,
    "name": "Konnakkuzhi Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 380,
    "name": "Chaippankuzhy Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 381,
    "name": "Irulam Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 382,
    "name": "Pulppalli Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 383,
    "name": "Vythiri Mundakkai Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 384,
    "name": "Peruvanamoozhi Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 385,
    "name": "Mannarkkad Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 386,
    "name": "Varandarapilli Section",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 387,
    "name": "Bodimettu Section",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 388,
    "name": "Koompanpara Section",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 389,
    "name": "Perinjamkutty Section",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 390,
    "name": "Mekkapala Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 391,
    "name": "Puthuseri South",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 392,
    "name": "Puthuseri North",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 393,
    "name": "Kadamanpara Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
  {
    "id": 394,
    "name": "Anakkampoyil Forest Station",
    "created_date": "2024-12-09",
    "is_delete": "False",
    "geom": "NULL",
    "range_id": 99
  },
],
talukaData:[
  {
    "id": 1,
    "taluka_name": "Vaithiry",
    "taluka_name_malayalam": "വൈത്തിരി",
    "dist_id": 12
  },
  {
    "id": 2,
    "taluka_name": "Trissur",
    "taluka_name_malayalam": "തൃശൂർ",
    "dist_id": 8
  },
  {
    "id": 3,
    "taluka_name": "Kasaragod",
    "taluka_name_malayalam": "കാസർഗോഡ്",
    "dist_id": 14
  },
  {
    "id": 4,
    "taluka_name": "Kollam",
    "taluka_name_malayalam": "കൊല്ലം",
    "dist_id": 2
  },
  {
    "id": 5,
    "taluka_name": "Karunagapalli",
    "taluka_name_malayalam": "കരുനാഗപ്പള്ളി",
    "dist_id": 2
  },
  {
    "id": 6,
    "taluka_name": "Kottayam",
    "taluka_name_malayalam": "കോട്ടയം",
    "dist_id": 5
  },
  {
    "id": 7,
    "taluka_name": "Adur",
    "taluka_name_malayalam": "അടൂർ",
    "dist_id": 3
  },
  {
    "id": 8,
    "taluka_name": "Mannarkkad",
    "taluka_name_malayalam": "മണ്ണാർക്കാട്",
    "dist_id": 9
  },
  {
    "id": 9,
    "taluka_name": "Kunnattunad",
    "taluka_name_malayalam": "കുന്നത്തുനാട്",
    "dist_id": 7
  },
  {
    "id": 10,
    "taluka_name": "Hosdurg",
    "taluka_name_malayalam": "ഹൊസ്ദുർഗ്",
    "dist_id": 14
  },
  {
    "id": 11,
    "taluka_name": "Nilambur",
    "taluka_name_malayalam": "നിലമ്പൂർ",
    "dist_id": 10
  },
  {
    "id": 12,
    "taluka_name": "Kunnamkulam",
    "taluka_name_malayalam": "കുന്നംകുളം",
    "dist_id": 8
  },
  {
    "id": 13,
    "taluka_name": "Palakkad",
    "taluka_name_malayalam": "പാലക്കാട്",
    "dist_id": 9
  },
  {
    "id": 14,
    "taluka_name": "Chengannur",
    "taluka_name_malayalam": "ചെങ്ങന്നൂർ",
    "dist_id": 4
  },
  {
    "id": 15,
    "taluka_name": "Mukundapuram",
    "taluka_name_malayalam": "മുകുന്ദപുരം",
    "dist_id": 8
  },
  {
    "id": 16,
    "taluka_name": "Taliparamba",
    "taluka_name_malayalam": "തളിപ്പറമ്പ്",
    "dist_id": 13
  },
  {
    "id": 17,
    "taluka_name": "Todupuzha",
    "taluka_name_malayalam": "തൊടുപുഴ",
    "dist_id": 6
  },
  {
    "id": 18,
    "taluka_name": "Chirayinkeezhu",
    "taluka_name_malayalam": "ചിറയിൻകീഴ്",
    "dist_id": 1
  },
  {
    "id": 19,
    "taluka_name": "Paravur",
    "taluka_name_malayalam": "പറവൂർ",
    "dist_id": 7
  },
  {
    "id": 20,
    "taluka_name": "Ponnani",
    "taluka_name_malayalam": "പൊന്നാനി",
    "dist_id": 10
  },
  {
    "id": 21,
    "taluka_name": "Payyannur",
    "taluka_name_malayalam": "പയ്യന്നൂർ",
    "dist_id": 13
  },
  {
    "id": 22,
    "taluka_name": "Ambalapuzha",
    "taluka_name_malayalam": "അമ്പലപ്പുഴ",
    "dist_id": 4
  },
  {
    "id": 23,
    "taluka_name": "Alattur",
    "taluka_name_malayalam": "ആലത്തൂർ",
    "dist_id": 9
  },
  {
    "id": 24,
    "taluka_name": "Chalakkudi",
    "taluka_name_malayalam": "ചാലക്കുടി",
    "dist_id": 8
  },
  {
    "id": 25,
    "taluka_name": "Punalur",
    "taluka_name_malayalam": "പുനലൂർ",
    "dist_id": 2
  },
  {
    "id": 26,
    "taluka_name": "Perintalmanna",
    "taluka_name_malayalam": "പെരിന്തൽമണ്ണ",
    "dist_id": 10
  },
  {
    "id": 27,
    "taluka_name": "Aluva",
    "taluka_name_malayalam": "ആലുവ",
    "dist_id": 7
  },
  {
    "id": 28,
    "taluka_name": "Ottappalam",
    "taluka_name_malayalam": "ഒറ്റപ്പാലം",
    "dist_id": 9
  },
  {
    "id": 29,
    "taluka_name": "Sultan Battery",
    "taluka_name_malayalam": "സുൽത്താൻ ബാറ്ററി",
    "dist_id": 12
  },
  {
    "id": 30,
    "taluka_name": "Kanayannur",
    "taluka_name_malayalam": "കണയന്നൂർ",
    "dist_id": 7
  },
  {
    "id": 31,
    "taluka_name": "Kattakkada",
    "taluka_name_malayalam": "കാട്ടാക്കട",
    "dist_id": 1
  },
  {
    "id": 32,
    "taluka_name": "Nedumangad",
    "taluka_name_malayalam": "നെടുമങ്ങാട്",
    "dist_id": 1
  },
  {
    "id": 33,
    "taluka_name": "Udumbanchola",
    "taluka_name_malayalam": "ഉടുമ്പൻചോല",
    "dist_id": 6
  },
  {
    "id": 34,
    "taluka_name": "Pattambi",
    "taluka_name_malayalam": "പട്ടാമ്പി",
    "dist_id": 9
  },
  {
    "id": 35,
    "taluka_name": "Ernad",
    "taluka_name_malayalam": "ഏറനാട്",
    "dist_id": 10
  },
  {
    "id": 36,
    "taluka_name": "Tirur",
    "taluka_name_malayalam": "തിരൂർ",
    "dist_id": 10
  },
  {
    "id": 37,
    "taluka_name": "Devikulam",
    "taluka_name_malayalam": "ദേവികുളം",
    "dist_id": 6
  },
  {
    "id": 38,
    "taluka_name": "Peermed",
    "taluka_name_malayalam": "ഉറ്റുനോക്കി",
    "dist_id": 6
  },
  {
    "id": 39,
    "taluka_name": "Neyyattinkara",
    "taluka_name_malayalam": "നെയ്യാറ്റിൻകര",
    "dist_id": 1
  },
  {
    "id": 40,
    "taluka_name": "Kannur",
    "taluka_name_malayalam": "കണ്ണൂർ",
    "dist_id": 13
  },
  {
    "id": 41,
    "taluka_name": "Thiruvananthapuram",
    "taluka_name_malayalam": "തിരുവനന്തപുരം",
    "dist_id": 1
  },
  {
    "id": 42,
    "taluka_name": "Ranni",
    "taluka_name_malayalam": "റാന്നി",
    "dist_id": 3
  },
  {
    "id": 43,
    "taluka_name": "Adur",
    "taluka_name_malayalam": "അഡൂർ",
    "dist_id": 3
  },
  {
    "id": 44,
    "taluka_name": "Manjeshvar",
    "taluka_name_malayalam": "മഞ്ചേശ്വരം",
    "dist_id": 14
  },
  {
    "id": 45,
    "taluka_name": "Mallappalli",
    "taluka_name_malayalam": "മല്ലപ്പള്ളി",
    "dist_id": 3
  },
  {
    "id": 46,
    "taluka_name": "Manantavadi",
    "taluka_name_malayalam": "മാനന്തവാടി",
    "dist_id": 12
  },
  {
    "id": 47,
    "taluka_name": "Muvattupuzha",
    "taluka_name_malayalam": "മൂവാറ്റുപുഴ",
    "dist_id": 7
  },
  {
    "id": 48,
    "taluka_name": "Iritty",
    "taluka_name_malayalam": "ഇരിട്ടി",
    "dist_id": 13
  },
  {
    "id": 49,
    "taluka_name": "Talappalli",
    "taluka_name_malayalam": "തലപ്പള്ളി",
    "dist_id": 8
  },
  {
    "id": 50,
    "taluka_name": "Kozhancheri",
    "taluka_name_malayalam": "കോഴഞ്ചേരി",
    "dist_id": 3
  },
  {
    "id": 51,
    "taluka_name": "Kartikapalli",
    "taluka_name_malayalam": "കാർത്തികപ്പള്ളി",
    "dist_id": 4
  },
  {
    "id": 52,
    "taluka_name": "Koyilandi",
    "taluka_name_malayalam": "കൊയിലാണ്ടി",
    "dist_id": 11
  },
  {
    "id": 53,
    "taluka_name": "Tirurangadi",
    "taluka_name_malayalam": "തിരൂരങ്ങാടി",
    "dist_id": 10
  },
  {
    "id": 54,
    "taluka_name": "Cherttala",
    "taluka_name_malayalam": "ചേർത്തല",
    "dist_id": 4
  },
  {
    "id": 55,
    "taluka_name": "Konni",
    "taluka_name_malayalam": "കോന്നി",
    "dist_id": 3
  },
  {
    "id": 56,
    "taluka_name": "Chittur",
    "taluka_name_malayalam": "ചിറ്റൂർ",
    "dist_id": 9
  },
  {
    "id": 57,
    "taluka_name": "Vadakara",
    "taluka_name_malayalam": "വടകര",
    "dist_id": 11
  },
  {
    "id": 58,
    "taluka_name": "Varkala",
    "taluka_name_malayalam": "വർക്കല",
    "dist_id": 1
  },
  {
    "id": 59,
    "taluka_name": "Idukki",
    "taluka_name_malayalam": "ഇടുക്കി",
    "dist_id": 6
  },
  {
    "id": 60,
    "taluka_name": "Vellarikundu",
    "taluka_name_malayalam": "വെള്ളരിക്കുണ്ട്",
    "dist_id": 14
  },
  {
    "id": 61,
    "taluka_name": "Kozhikode",
    "taluka_name_malayalam": "കോഴിക്കോട്",
    "dist_id": 11
  },
  {
    "id": 62,
    "taluka_name": "Meenachil",
    "taluka_name_malayalam": "മീനച്ചിൽ",
    "dist_id": 5
  },
  {
    "id": 63,
    "taluka_name": "Mavelikara",
    "taluka_name_malayalam": "മാവേലിക്കര",
    "dist_id": 4
  },
  {
    "id": 64,
    "taluka_name": "Kottarakara",
    "taluka_name_malayalam": "കൊട്ടാരക്കര",
    "dist_id": 2
  },
  {
    "id": 65,
    "taluka_name": "Kuttanad",
    "taluka_name_malayalam": "കുട്ടനാട്",
    "dist_id": 4
  },
  {
    "id": 66,
    "taluka_name": "Changanasseri",
    "taluka_name_malayalam": "ചങ്ങനാശ്ശേരി",
    "dist_id": 5
  },
  {
    "id": 67,
    "taluka_name": "Kondotty",
    "taluka_name_malayalam": "കൊണ്ടോട്ടി",
    "dist_id": 10
  },
  {
    "id": 68,
    "taluka_name": "Kochi",
    "taluka_name_malayalam": "കൊച്ചി",
    "dist_id": 7
  },
  {
    "id": 69,
    "taluka_name": "Vaikam",
    "taluka_name_malayalam": "വൈക്കം",
    "dist_id": 5
  },
  {
    "id": 70,
    "taluka_name": "Kanjirapalli",
    "taluka_name_malayalam": "കാഞ്ഞിരപ്പള്ളി",
    "dist_id": 5
  },
  {
    "id": 71,
    "taluka_name": "Talasseri",
    "taluka_name_malayalam": "തലശ്ശേരി",
    "dist_id": 13
  },
  {
    "id": 72,
    "taluka_name": "Tamarasserry",
    "taluka_name_malayalam": "താമരശ്ശേരി",
    "dist_id": 11
  },
  {
    "id": 73,
    "taluka_name": "Kotamangalam",
    "taluka_name_malayalam": "കോതമംഗലം",
    "dist_id": 7
  },
  {
    "id": 74,
    "taluka_name": "Tiruvalla",
    "taluka_name_malayalam": "തിരുവല്ല",
    "dist_id": 3
  },
  {
    "id": 75,
    "taluka_name": "Kunnattur",
    "taluka_name_malayalam": "കുന്നത്തൂർ",
    "dist_id": 2
  },
  {
    "id": 76,
    "taluka_name": "Pattanapuram",
    "taluka_name_malayalam": "പട്ടണപുരം",
    "dist_id": 2
  },
  {
    "id": 77,
    "taluka_name": "Thamarasseri",
    "taluka_name_malayalam": "താമരശ്ശേരി",
    "dist_id": 11
  },
  {
    "id": 78,
    "taluka_name": "Kothamangalam",
    "taluka_name_malayalam": "കോതമംഗലം",
    "dist_id": 7
  },
  {
    "id": 79,
    "taluka_name": "Attappadi Tribal Taluk",
    "taluka_name_malayalam": "അട്ടപ്പാടി ട്രൈബൽ താലൂക്ക്",
    "dist_id": 9
  },
  {
    "id": 80,
    "taluka_name": "Chavakkad",
    "taluka_name_malayalam": "ചാവക്കാട്",
    "dist_id": 8
  },

],       
villageData:[
  {
    "id": 1,
    "village_name": "Achooranam",
    "village_name_malayalam": "അച്ചൂരണം",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 2,
    "village_name": "Adat",
    "village_name_malayalam": "അദാത്ത്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 3,
    "village_name": "Adhur",
    "village_name_malayalam": "അധൂർ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 4,
    "village_name": "Adichanallur",
    "village_name_malayalam": "ആദിച്ചനല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 5,
    "village_name": "Adinadu",
    "village_name_malayalam": "ആദിനാട്",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 6,
    "village_name": "Athirampuzha",
    "village_name_malayalam": "അതിരമ്പുഴ",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 7,
    "village_name": "Adkathbayal",
    "village_name_malayalam": "അദ്കത്ബയൽ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 8,
    "village_name": "Adoor",
    "village_name_malayalam": "അടൂർ",
    "is_notified": "False",
    "taluka_id": 7
  },
  {
    "id": 9,
    "village_name": "Adoor",
    "village_name_malayalam": "അടൂർ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 10,
    "village_name": "Akalakkunnam",
    "village_name_malayalam": "അകലക്കുന്നം",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 11,
    "village_name": "Agali",
    "village_name_malayalam": "അഗളി",
    "is_notified": "True",
    "taluka_id": 8
  },
  {
    "id": 12,
    "village_name": "Aikaranad North",
    "village_name_malayalam": "ഐക്കരനാട് നോർത്ത്",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 13,
    "village_name": "Aikaranad South",
    "village_name_malayalam": "ഐക്കരനാട് സൗത്ത്",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 14,
    "village_name": "Aymanam",
    "village_name_malayalam": "അയ്മനം",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 15,
    "village_name": "Irapuram",
    "village_name_malayalam": "ഐരാപുരം",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 16,
    "village_name": "Ajanur",
    "village_name_malayalam": "അജാനൂർ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 17,
    "village_name": "Akampadam",
    "village_name_malayalam": "അകമ്പാടം",
    "is_notified": "True",
    "taluka_id": 11
  },
  {
    "id": 18,
    "village_name": "Akathiyoor",
    "village_name_malayalam": "അകത്തിയൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 19,
    "village_name": "Akathethara",
    "village_name_malayalam": "അകത്തേത്തറ",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 20,
    "village_name": "Ala",
    "village_name_malayalam": "അല",
    "is_notified": "False",
    "taluka_id": 14
  },
  {
    "id": 21,
    "village_name": "Aala",
    "village_name_malayalam": "ആലാ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 22,
    "village_name": "Alakode",
    "village_name_malayalam": "ആലക്കോട്",
    "is_notified": "True",
    "taluka_id": 16
  },
  {
    "id": 23,
    "village_name": "Alakkode",
    "village_name_malayalam": "ആലക്കോട്",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 24,
    "village_name": "Alamcode",
    "village_name_malayalam": "ആലംകോട്",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 25,
    "village_name": "Alanallur 1",
    "village_name_malayalam": "അലനല്ലൂർ 1",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 26,
    "village_name": "Alanallur 2",
    "village_name_malayalam": "അലനല്ലൂർ 2",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 27,
    "village_name": "Alanallur 3",
    "village_name_malayalam": "അലനല്ലൂർ 3",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 28,
    "village_name": "Alangad",
    "village_name_malayalam": "ആലങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 29,
    "village_name": "Alamcode",
    "village_name_malayalam": "ആലംകോട്",
    "is_notified": "False",
    "taluka_id": 20
  },
  {
    "id": 30,
    "village_name": "Alappad",
    "village_name_malayalam": "ആലപ്പാട്",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 31,
    "village_name": "Alappad",
    "village_name_malayalam": "ആലപ്പാട്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 32,
    "village_name": "Alappadamba",
    "village_name_malayalam": "ആലപ്പടമ്പ",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 33,
    "village_name": "Alappuzha",
    "village_name_malayalam": "ആലപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 34,
    "village_name": "Alappuzha West",
    "village_name_malayalam": "ആലപ്പുഴ വെസ്റ്റ്",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 35,
    "village_name": "Alathur",
    "village_name_malayalam": "ആലത്തൂർ",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 36,
    "village_name": "Alathur",
    "village_name_malayalam": "ആലത്തൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 37,
    "village_name": "Alayamon",
    "village_name_malayalam": "അലയമൺ",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 38,
    "village_name": "Aliparamba",
    "village_name_malayalam": "ആലിപ്പറമ്പ്",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 39,
    "village_name": "Aloor",
    "village_name_malayalam": "ആളൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 40,
    "village_name": "Aaloor",
    "village_name_malayalam": "ആളൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 41,
    "village_name": "Aluva",
    "village_name_malayalam": "ആലുവ",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 42,
    "village_name": "Aluva East",
    "village_name_malayalam": "ആലുവ ഈസ്റ്റ്",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 43,
    "village_name": "Aluva West",
    "village_name_malayalam": "ആലുവ വെസ്റ്റ്",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 44,
    "village_name": "Amarambalam",
    "village_name_malayalam": "അമരമ്പലം",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 45,
    "village_name": "Ambalappara 1",
    "village_name_malayalam": "അമ്പലപ്പാറ 1",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 46,
    "village_name": "Ambalappara 2",
    "village_name_malayalam": "അമ്പലപ്പാറ 2",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 47,
    "village_name": "Ambalappuzha",
    "village_name_malayalam": "അമ്പലപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 48,
    "village_name": "Ambalathara",
    "village_name_malayalam": "അമ്പലത്തറ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 49,
    "village_name": "Ambalavayal",
    "village_name_malayalam": "അമ്പലവയൽ",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 50,
    "village_name": "Amballoor",
    "village_name_malayalam": "ആമ്പല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 51,
    "village_name": "Amballur",
    "village_name_malayalam": "ആമ്പല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 52,
    "village_name": "Amboori",
    "village_name_malayalam": "അമ്പൂരി",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 53,
    "village_name": "Anad",
    "village_name_malayalam": "ആനാട്",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 54,
    "village_name": "Anakkara",
    "village_name_malayalam": "അണക്കര",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 55,
    "village_name": "Anakkara",
    "village_name_malayalam": "അണക്കര",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 56,
    "village_name": "Anakkayam",
    "village_name_malayalam": "ആനക്കയം",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 57,
    "village_name": "Anamangad",
    "village_name_malayalam": "ആനമങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 58,
    "village_name": "Anandapuram",
    "village_name_malayalam": "ആനന്ദപുരം",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 59,
    "village_name": "Ananganadi",
    "village_name_malayalam": "അനങ്ങനടി",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 60,
    "village_name": "Ananthavoor",
    "village_name_malayalam": "അനന്താവൂർ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 61,
    "village_name": "Anaviratty",
    "village_name_malayalam": "ആനവിരാട്ടി",
    "is_notified": "False",
    "taluka_id": 37
  },
  {
    "id": 62,
    "village_name": "Anavilasom",
    "village_name_malayalam": "ആനവിലാസം",
    "is_notified": "False",
    "taluka_id": 38
  },
  {
    "id": 63,
    "village_name": "Anavoor",
    "village_name_malayalam": "ആനാവൂർ",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 64,
    "village_name": "Anchal",
    "village_name_malayalam": "അഞ്ചൽ",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 65,
    "village_name": "Anjarakandy",
    "village_name_malayalam": "അഞ്ചരക്കണ്ടി",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 66,
    "village_name": "Anthoor",
    "village_name_malayalam": "ആന്തൂർ",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 67,
    "village_name": "Andoorkonam",
    "village_name_malayalam": "അണ്ടൂർക്കോണം",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 68,
    "village_name": "Ranni Angadi",
    "village_name_malayalam": "റാന്നി അങ്ങാടി",
    "is_notified": "False",
    "taluka_id": 42
  },
  {
    "id": 69,
    "village_name": "Angadickal",
    "village_name_malayalam": "അങ്ങാടിക്കൽ",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 70,
    "village_name": "Angadimogaru",
    "village_name_malayalam": "അംഗഡിമൊഗരു",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 71,
    "village_name": "Angadippuram",
    "village_name_malayalam": "അങ്ങാടിപ്പുറം",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 72,
    "village_name": "Angamaly",
    "village_name_malayalam": "അങ്കമാലി",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 73,
    "village_name": "Anickadu",
    "village_name_malayalam": "ആനിക്കാട്",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 74,
    "village_name": "Anicadu",
    "village_name_malayalam": "ആനിക്കാട്",
    "is_notified": "False",
    "taluka_id": 45
  },
  {
    "id": 75,
    "village_name": "Anjukunnu",
    "village_name_malayalam": "അഞ്ചുകുന്ന്",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 76,
    "village_name": "Anjur",
    "village_name_malayalam": "അഞ്ഞൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 77,
    "village_name": "Anjur",
    "village_name_malayalam": "അഞ്ഞൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 78,
    "village_name": "Annakara",
    "village_name_malayalam": "അന്നകര",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 79,
    "village_name": "Annallur",
    "village_name_malayalam": "അന്നല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 80,
    "village_name": "Anthicad",
    "village_name_malayalam": "അന്തിക്കാട്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 81,
    "village_name": "Arakkal",
    "village_name_malayalam": "അറക്കൽ",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 82,
    "village_name": "Arakapady",
    "village_name_malayalam": "അരക്കപ്പടി",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 83,
    "village_name": "Arakkulam",
    "village_name_malayalam": "അറക്കുളം",
    "is_notified": "True",
    "taluka_id": 17
  },
  {
    "id": 84,
    "village_name": "Arakkuparamba",
    "village_name_malayalam": "അറക്കുപറമ്പ്",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 85,
    "village_name": "Arakuzha",
    "village_name_malayalam": "ആരക്കുഴ",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 86,
    "village_name": "Aralam",
    "village_name_malayalam": "ആറളം",
    "is_notified": "True",
    "taluka_id": 48
  },
  {
    "id": 87,
    "village_name": "Aranattukara-Pullazhi",
    "village_name_malayalam": "അരണാട്ടുകര-പുല്ലഴി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 88,
    "village_name": "Arangottukara",
    "village_name_malayalam": "ആറങ്ങോട്ടുകര",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 89,
    "village_name": "Aranmula",
    "village_name_malayalam": "ആറന്മുള",
    "is_notified": "False",
    "taluka_id": 50
  },
  {
    "id": 90,
    "village_name": "Arattupuzha",
    "village_name_malayalam": "ആറാട്ടുപുഴ",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 91,
    "village_name": "Arattupuzha",
    "village_name_malayalam": "ആറാട്ടുപുഴ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 92,
    "village_name": "Areacode",
    "village_name_malayalam": "ഏരിയകോഡ്",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 93,
    "village_name": "Ariyankavu",
    "village_name_malayalam": "അരിയങ്കാവ്",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 94,
    "village_name": "Arikkady",
    "village_name_malayalam": "ആരിക്കാടി",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 95,
    "village_name": "Arikkulam",
    "village_name_malayalam": "അരിക്കുളം",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 96,
    "village_name": "Aryad South",
    "village_name_malayalam": "ആര്യാട് സൗത്ത്",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 97,
    "village_name": "Ariyallur",
    "village_name_malayalam": "അരിയല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 98,
    "village_name": "Arppookkara",
    "village_name_malayalam": "ആർപ്പൂക്കര",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 99,
    "village_name": "Arthat",
    "village_name_malayalam": "ആർത്താറ്റ്",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 100,
    "village_name": "Arookkutty",
    "village_name_malayalam": "അരൂക്കുറ്റി",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 101,
    "village_name": "Aroor",
    "village_name_malayalam": "അരൂർ",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 102,
    "village_name": "Aruvappulam",
    "village_name_malayalam": "അരുവാപ്പലും",
    "is_notified": "True",
    "taluka_id": 55
  },
  {
    "id": 103,
    "village_name": "Aruvikkara",
    "village_name_malayalam": "അരുവിക്കര",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 104,
    "village_name": "Aryanad",
    "village_name_malayalam": "ആര്യനാട്",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 105,
    "village_name": "Asamannoor",
    "village_name_malayalam": "അശമന്നൂർ",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 106,
    "village_name": "Athavanad",
    "village_name_malayalam": "ആതവനാട്",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 107,
    "village_name": "Athikayam",
    "village_name_malayalam": "അത്തിക്കയം",
    "is_notified": "False",
    "taluka_id": 42
  },
  {
    "id": 108,
    "village_name": "Athiyannoor",
    "village_name_malayalam": "അതിയന്നൂർ",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 109,
    "village_name": "Attappadi",
    "village_name_malayalam": "അട്ടപ്പാടി",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 110,
    "village_name": "Attingal",
    "village_name_malayalam": "ആറ്റിങ്ങൽ",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 111,
    "village_name": "Attipra",
    "village_name_malayalam": "ആറ്റിപ്ര",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 112,
    "village_name": "Atholi",
    "village_name_malayalam": "അത്തോളി",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 113,
    "village_name": "Attur",
    "village_name_malayalam": "ആറ്റൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 114,
    "village_name": "Avinissery",
    "village_name_malayalam": "അവിണിശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 115,
    "village_name": "Avidanallur",
    "village_name_malayalam": "അവിടനല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 116,
    "village_name": "Ayilur",
    "village_name_malayalam": "അയിലൂർ",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 117,
    "village_name": "Ayanchery",
    "village_name_malayalam": "ആയഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 118,
    "village_name": "Ayanivelikulangara",
    "village_name_malayalam": "അയണിവേലികുളങ്ങര",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 119,
    "village_name": "Ayarkkunnam",
    "village_name_malayalam": "അയർക്കുന്നം",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 120,
    "village_name": "Ayiranalloor",
    "village_name_malayalam": "ആയിരനല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 121,
    "village_name": "Ayiroopara",
    "village_name_malayalam": "അയിരൂപ്പാറ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 122,
    "village_name": "Ayiroor",
    "village_name_malayalam": "അയിരൂർ",
    "is_notified": "False",
    "taluka_id": 58
  },
  {
    "id": 123,
    "village_name": "Ayroor",
    "village_name_malayalam": "അയിരൂർ",
    "is_notified": "False",
    "taluka_id": 42
  },
  {
    "id": 124,
    "village_name": "Ayyankunnu",
    "village_name_malayalam": "അയ്യൻകുന്ന്",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 125,
    "village_name": "Ayyappancoil",
    "village_name_malayalam": "അയ്യപ്പൻകോവിൽ",
    "is_notified": "False",
    "taluka_id": 59
  },
  {
    "id": 126,
    "village_name": "Azhikode North",
    "village_name_malayalam": "അഴീക്കോട് നോർത്ത്",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 127,
    "village_name": "Azhikode South",
    "village_name_malayalam": "അഴീക്കോട് സൗത്ത്",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 128,
    "village_name": "Azhikode",
    "village_name_malayalam": "അഴീക്കോട്",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 129,
    "village_name": "Azhiyur",
    "village_name_malayalam": "അഴിയൂർ",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 130,
    "village_name": "Azhoor",
    "village_name_malayalam": "അഴൂർ",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 131,
    "village_name": "Badaje",
    "village_name_malayalam": "ബഡാജെ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 132,
    "village_name": "Badiadukka",
    "village_name_malayalam": "ബദിയടുക്ക",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 133,
    "village_name": "Badoor",
    "village_name_malayalam": "ബദൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 134,
    "village_name": "Balal",
    "village_name_malayalam": "ബലാൽ",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 135,
    "village_name": "Balaramapuram",
    "village_name_malayalam": "ബാലരാമപുരം",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 136,
    "village_name": "Balla",
    "village_name_malayalam": "ബല്ല",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 137,
    "village_name": "Balussery",
    "village_name_malayalam": "ബാലുശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 138,
    "village_name": "Bandaduka",
    "village_name_malayalam": "ബന്തടുക്ക",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 139,
    "village_name": "Bare",
    "village_name_malayalam": "നഗ്നമായ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 140,
    "village_name": "Bayar",
    "village_name_malayalam": "ബായാർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 141,
    "village_name": "Bedadukka",
    "village_name_malayalam": "ബേഡഡുക്ക",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 142,
    "village_name": "Bekkur",
    "village_name_malayalam": "ബേക്കൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 143,
    "village_name": "Bela",
    "village_name_malayalam": "ബേല",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 144,
    "village_name": "Bellur",
    "village_name_malayalam": "ബെള്ളൂർ",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 145,
    "village_name": "Beypore",
    "village_name_malayalam": "ബേപ്പൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 146,
    "village_name": "Bharananganam",
    "village_name_malayalam": "ഭരണങ്ങാനം",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 147,
    "village_name": "Bharanikkavu",
    "village_name_malayalam": "ഭരണിക്കാവ്",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 148,
    "village_name": "Bheemanady",
    "village_name_malayalam": "ഭീമനടി",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 149,
    "village_name": "Bysonvalley",
    "village_name_malayalam": "ബൈസൺവാലി",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 150,
    "village_name": "Bambrana",
    "village_name_malayalam": "ബംബ്രാണ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 151,
    "village_name": "Brahmakulam",
    "village_name_malayalam": "ബ്രഹ്മകുളം",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 152,
    "village_name": "Chakkittappara",
    "village_name_malayalam": "ചക്കിട്ടപ്പാറ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 153,
    "village_name": "Chakkupallam",
    "village_name_malayalam": "ചക്കുപള്ളം",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 154,
    "village_name": "Chakkuvarakkal",
    "village_name_malayalam": "ചക്കുവരക്കൽ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 155,
    "village_name": "Chalakkal",
    "village_name_malayalam": "ചാലക്കൽ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 156,
    "village_name": "Chalissery",
    "village_name_malayalam": "ചാലിശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 157,
    "village_name": "Chemnad",
    "village_name_malayalam": "ചെമനാട്",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 158,
    "village_name": "Champakkulam",
    "village_name_malayalam": "ചമ്പക്കുളം",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 159,
    "village_name": "Chendrapinni",
    "village_name_malayalam": "ചെന്ത്രാപ്പിന്നി",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 160,
    "village_name": "Chengala",
    "village_name_malayalam": "ചെങ്കള",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 161,
    "village_name": "Changanacherry",
    "village_name_malayalam": "ചങ്ങനാശേരി",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 162,
    "village_name": "Changaroth",
    "village_name_malayalam": "ചങ്ങരോത്ത്",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 163,
    "village_name": "Channapetta",
    "village_name_malayalam": "ചണ്ണപ്പേട്ട",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 164,
    "village_name": "Chadayamangalam",
    "village_name_malayalam": "ചടയമംഗലം",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 165,
    "village_name": "Chathurangappara",
    "village_name_malayalam": "ചതുരംഗപ്പാറ",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 166,
    "village_name": "Chavakkad",
    "village_name_malayalam": "ചാവക്കാട്",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 167,
    "village_name": "Chavara",
    "village_name_malayalam": "ചവറ",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 168,
    "village_name": "Chavassery",
    "village_name_malayalam": "ചാവശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 169,
    "village_name": "Chazhoor",
    "village_name_malayalam": "ചാഴൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 170,
    "village_name": "Cheemeni",
    "village_name_malayalam": "ചീമേനി",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 171,
    "village_name": "Cheemeni-II",
    "village_name_malayalam": "ചീമേനി-II",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 172,
    "village_name": "Cheeral",
    "village_name_malayalam": "ചീരൽ",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 173,
    "village_name": "Chekkiad",
    "village_name_malayalam": "ചെക്കിയാട്",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 174,
    "village_name": "Chelakkara",
    "village_name_malayalam": "ചേലക്കര",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 175,
    "village_name": "Chelakkode",
    "village_name_malayalam": "ചേലക്കോട്",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 176,
    "village_name": "Chelamattom",
    "village_name_malayalam": "ചേലമറ്റം",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 177,
    "village_name": "Chelembra",
    "village_name_malayalam": "ചേലേമ്പ്ര",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 178,
    "village_name": "Chelannur",
    "village_name_malayalam": "ചേളന്നൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 179,
    "village_name": "Chelavur",
    "village_name_malayalam": "ചെലവൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 180,
    "village_name": "Cheleri",
    "village_name_malayalam": "ചേലേരി",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 181,
    "village_name": "Chellanam",
    "village_name_malayalam": "ചെല്ലാനം",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 182,
    "village_name": "Chelora",
    "village_name_malayalam": "ചേലോറ",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 183,
    "village_name": "Chempanoda",
    "village_name_malayalam": "ചെമ്പനോട",
    "is_notified": "True",
    "taluka_id": 52
  },
  {
    "id": 184,
    "village_name": "Chembrassery",
    "village_name_malayalam": "ചെമ്പ്രശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 185,
    "village_name": "Chembilode",
    "village_name_malayalam": "ചെമ്പിലോട്",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 186,
    "village_name": "Chempu",
    "village_name_malayalam": "ചെമ്പു",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 187,
    "village_name": "Chembukavu",
    "village_name_malayalam": "ചെമ്പുകാവ്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 188,
    "village_name": "Chemmanthitta",
    "village_name_malayalam": "ചെമ്മന്തിട്ട",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 189,
    "village_name": "Chemmaruthi",
    "village_name_malayalam": "ചെമ്മരുതി",
    "is_notified": "False",
    "taluka_id": 58
  },
  {
    "id": 190,
    "village_name": "Chemancheri",
    "village_name_malayalam": "ചേമഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 191,
    "village_name": "Chengalam East",
    "village_name_malayalam": "ചെങ്ങളം ഈസ്റ്റ്",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 192,
    "village_name": "Chengalam South",
    "village_name_malayalam": "ചെങ്ങളം സൗത്ത്",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 193,
    "village_name": "Chengalayi",
    "village_name_malayalam": "ചെങ്ങളായി",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 194,
    "village_name": "Chengalur",
    "village_name_malayalam": "ചെങ്ങാലൂർ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 195,
    "village_name": "Chengamanad",
    "village_name_malayalam": "ചെങ്ങമനാട്",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 196,
    "village_name": "Chengannur",
    "village_name_malayalam": "ചെങ്ങന്നൂർ",
    "is_notified": "False",
    "taluka_id": 14
  },
  {
    "id": 197,
    "village_name": "Chengottukavu",
    "village_name_malayalam": "ചെങ്ങോട്ടുകാവ്",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 198,
    "village_name": "Cheni",
    "village_name_malayalam": "ചെനി",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 199,
    "village_name": "Chenkal",
    "village_name_malayalam": "ചെങ്കൽ",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 200,
    "village_name": "Chendamangalam",
    "village_name_malayalam": "ചേന്ദമംഗലം",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 201,
    "village_name": "Chenneerkara",
    "village_name_malayalam": "ചെന്നീർക്കര",
    "is_notified": "False",
    "taluka_id": 50
  },
  {
    "id": 202,
    "village_name": "Chennithala",
    "village_name_malayalam": "ചെന്നിത്തല",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 203,
    "village_name": "Cheppad",
    "village_name_malayalam": "ചേപ്പാട്",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 204,
    "village_name": "Cheranallur",
    "village_name_malayalam": "ചേരാനല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 205,
    "village_name": "Cheriyamundam",
    "village_name_malayalam": "ചെറിയമുണ്ടം",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 206,
    "village_name": "Cheriyanad",
    "village_name_malayalam": "ചെറിയനാട്",
    "is_notified": "False",
    "taluka_id": 14
  },
  {
    "id": 207,
    "village_name": "Cherpu",
    "village_name_malayalam": "ചേർപ്പ്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 208,
    "village_name": "Cherthala North",
    "village_name_malayalam": "ചേർത്തല നോർത്ത്",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 209,
    "village_name": "Cherthala South",
    "village_name_malayalam": "ചേർത്തല സൗത്ത്",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 210,
    "village_name": "Cherukattoor",
    "village_name_malayalam": "ചെറുകാട്ടൂർ",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 211,
    "village_name": "Cherukavu",
    "village_name_malayalam": "ചെറുകാവ്",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 212,
    "village_name": "Cherukole",
    "village_name_malayalam": "ചെറുകോൽ",
    "is_notified": "False",
    "taluka_id": 42
  },
  {
    "id": 213,
    "village_name": "Cherukunnu",
    "village_name_malayalam": "ചെറുകുന്ന്",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 214,
    "village_name": "Cherunniyur",
    "village_name_malayalam": "ചെറുന്നിയൂർ",
    "is_notified": "False",
    "taluka_id": 58
  },
  {
    "id": 215,
    "village_name": "Cherpulasseri",
    "village_name_malayalam": "ചെർപ്പുളശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 216,
    "village_name": "Cheruthana",
    "village_name_malayalam": "ചെറുതന",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 217,
    "village_name": "Cheruthazham",
    "village_name_malayalam": "ചെറുതാഴം",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 218,
    "village_name": "Cheruthuruthy",
    "village_name_malayalam": "ചെറുതുരുത്തി",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 219,
    "village_name": "Cheruvally",
    "village_name_malayalam": "ചെറുവള്ളി",
    "is_notified": "False",
    "taluka_id": 70
  },
  {
    "id": 220,
    "village_name": "Cheruvanchery",
    "village_name_malayalam": "ചെറുവാഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 221,
    "village_name": "Cheruvannur",
    "village_name_malayalam": "ചെറുവണ്ണൂർ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 222,
    "village_name": "Cheruvannur",
    "village_name_malayalam": "ചെറുവണ്ണൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 223,
    "village_name": "Cheruvathur",
    "village_name_malayalam": "ചെറുവത്തൂർ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 224,
    "village_name": "Cheruvakkal",
    "village_name_malayalam": "ചെറുവക്കൽ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 225,
    "village_name": "Chetakkal",
    "village_name_malayalam": "ചേതക്കൽ",
    "is_notified": "False",
    "taluka_id": 42
  },
  {
    "id": 226,
    "village_name": "Chathamangalam",
    "village_name_malayalam": "ചാത്തമംഗലം",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 227,
    "village_name": "Chethippuzha",
    "village_name_malayalam": "ചെത്തിപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 228,
    "village_name": "Chevayur",
    "village_name_malayalam": "ചേവായൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 229,
    "village_name": "Cheekode",
    "village_name_malayalam": "ചീക്കോട്",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 230,
    "village_name": "Chingoli",
    "village_name_malayalam": "ചിങ്ങോലി",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 231,
    "village_name": "Chinnakanal",
    "village_name_malayalam": "ചിന്നക്കനാൽ",
    "is_notified": "False",
    "taluka_id": 37
  },
  {
    "id": 232,
    "village_name": "Chirakkadavu",
    "village_name_malayalam": "ചിറക്കടവ്",
    "is_notified": "False",
    "taluka_id": 70
  },
  {
    "id": 233,
    "village_name": "Chirakkal",
    "village_name_malayalam": "ചിറക്കൽ",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 234,
    "village_name": "Chirakkara",
    "village_name_malayalam": "ചിറക്കര",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 235,
    "village_name": "Chiramanangad",
    "village_name_malayalam": "ചിറമണങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 236,
    "village_name": "Chiranellur",
    "village_name_malayalam": "ചിറനെല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 237,
    "village_name": "Chirayinkeezhu",
    "village_name_malayalam": "ചിറയിൻകീഴ്",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 238,
    "village_name": "Chithara",
    "village_name_malayalam": "ചിതറ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 239,
    "village_name": "Chittanda",
    "village_name_malayalam": "ചിറ്റണ്ട",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 240,
    "village_name": "Chittar",
    "village_name_malayalam": "ചിറ്റാർ",
    "is_notified": "True",
    "taluka_id": 55
  },
  {
    "id": 241,
    "village_name": "Chithari",
    "village_name_malayalam": "ചിത്താരി",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 242,
    "village_name": "Chittarikkal",
    "village_name_malayalam": "ചിറ്റാരിക്കാൽ",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 243,
    "village_name": "Chittilappilly",
    "village_name_malayalam": "ചിറ്റിലപ്പിള്ളി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 244,
    "village_name": "Chittur",
    "village_name_malayalam": "ചിറ്റൂർ",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 245,
    "village_name": "Chiyyaram",
    "village_name_malayalam": "ചിയ്യാരം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 246,
    "village_name": "Chokkad",
    "village_name_malayalam": "ചോക്കാട്",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 247,
    "village_name": "Chokli",
    "village_name_malayalam": "ചൊക്ലി",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 248,
    "village_name": "Chorode",
    "village_name_malayalam": "ചോറോട്",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 249,
    "village_name": "Chowannur",
    "village_name_malayalam": "ചൊവ്വന്നൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 250,
    "village_name": "Chowara",
    "village_name_malayalam": "ചൊവ്വര",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 251,
    "village_name": "Chevvur",
    "village_name_malayalam": "ചെവ്വൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 252,
    "village_name": "Chulissery",
    "village_name_malayalam": "ചുളിശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 253,
    "village_name": "Chunakkara",
    "village_name_malayalam": "ചുനക്കര",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 254,
    "village_name": "Choondal",
    "village_name_malayalam": "ചൂണ്ടൽ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 255,
    "village_name": "Chungathara",
    "village_name_malayalam": "ചുങ്കത്തറ",
    "is_notified": "True",
    "taluka_id": 11
  },
  {
    "id": 256,
    "village_name": "Chuzhali",
    "village_name_malayalam": "ചുഴലി",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 257,
    "village_name": "Delampady",
    "village_name_malayalam": "ദേലംപാടി",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 258,
    "village_name": "Desamangalam",
    "village_name_malayalam": "ദേശമംഗലം",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 259,
    "village_name": "Devikulam",
    "village_name_malayalam": "ദേവികുളം",
    "is_notified": "False",
    "taluka_id": 37
  },
  {
    "id": 260,
    "village_name": "Dharmadam",
    "village_name_malayalam": "ധർമ്മടം",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 261,
    "village_name": "East Kallada",
    "village_name_malayalam": "കിഴക്കേ കല്ലട",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 262,
    "village_name": "Edacheri",
    "village_name_malayalam": "എടച്ചേരി",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 263,
    "village_name": "Edakkalathur",
    "village_name_malayalam": "എടക്കളത്തൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 264,
    "village_name": "Edakkad",
    "village_name_malayalam": "എടക്കാട്",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 265,
    "village_name": "Edakkanam Desam",
    "village_name_malayalam": "എടക്കാനം ദേശം",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 266,
    "village_name": "Edakkara",
    "village_name_malayalam": "എടക്കര",
    "is_notified": "True",
    "taluka_id": 11
  },
  {
    "id": 267,
    "village_name": "Edakkattuvayal",
    "village_name_malayalam": "എടയ്ക്കാട്ടുവയൽ",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 268,
    "village_name": "Edakkazhiyur",
    "village_name_malayalam": "എടക്കഴിയൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 269,
    "village_name": "Edakode",
    "village_name_malayalam": "എടക്കോട്",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 270,
    "village_name": "Edakkunnam",
    "village_name_malayalam": "എടക്കുന്നം",
    "is_notified": "False",
    "taluka_id": 70
  },
  {
    "id": 271,
    "village_name": "Edakkunni",
    "village_name_malayalam": "എടക്കുന്നി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 272,
    "village_name": "Edakochi",
    "village_name_malayalam": "ഇടക്കൊച്ചി",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 273,
    "village_name": "Edamon",
    "village_name_malayalam": "ഇടമൺ",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 274,
    "village_name": "Edappal",
    "village_name_malayalam": "എടപ്പാൾ",
    "is_notified": "False",
    "taluka_id": 20
  },
  {
    "id": 275,
    "village_name": "Edappally North",
    "village_name_malayalam": "ഇടപ്പള്ളി നോർത്ത്",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 276,
    "village_name": "Edappally South",
    "village_name_malayalam": "ഇടപ്പള്ളി സൗത്ത്",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 277,
    "village_name": "Edapatta",
    "village_name_malayalam": "എടപ്പറ്റ",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 278,
    "village_name": "Edathirinji",
    "village_name_malayalam": "എടതിരിഞ്ഞി",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 279,
    "village_name": "Edathuva",
    "village_name_malayalam": "എടത്വ",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 280,
    "village_name": "Edathiruthy",
    "village_name_malayalam": "എടത്തിരുത്തി",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 281,
    "village_name": "Edavaka",
    "village_name_malayalam": "എടവക",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 282,
    "village_name": "Edavanakkad",
    "village_name_malayalam": "എടവനക്കാട്",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 283,
    "village_name": "Edavanna",
    "village_name_malayalam": "എടവണ്ണ",
    "is_notified": "True",
    "taluka_id": 35
  },
  {
    "id": 284,
    "village_name": "Edavilangu",
    "village_name_malayalam": "എടവിലങ്ങ്",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 285,
    "village_name": "Edayur",
    "village_name_malayalam": "എടയൂർ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 286,
    "village_name": "Elackadu",
    "village_name_malayalam": "ഏലക്കാട്",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 287,
    "village_name": "Elamad",
    "village_name_malayalam": "ഇളമദ്",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 288,
    "village_name": "Elamkulam",
    "village_name_malayalam": "ഏലംകുളം",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 289,
    "village_name": "Elangulam",
    "village_name_malayalam": "ഇളങ്ങുളം",
    "is_notified": "False",
    "taluka_id": 70
  },
  {
    "id": 290,
    "village_name": "Elamkulam",
    "village_name_malayalam": "ഏലംകുളം",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 291,
    "village_name": "Elanad",
    "village_name_malayalam": "എളനാട്",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 292,
    "village_name": "Elanji",
    "village_name_malayalam": "ഇലഞ്ഞി",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 293,
    "village_name": "Elamkunnapuzha",
    "village_name_malayalam": "എളംകുന്നപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 294,
    "village_name": "Elankur",
    "village_name_malayalam": "എളങ്കൂർ",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 295,
    "village_name": "Elappally",
    "village_name_malayalam": "ഇലപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 296,
    "village_name": "Elappara",
    "village_name_malayalam": "ഏലപ്പാറ",
    "is_notified": "False",
    "taluka_id": 38
  },
  {
    "id": 297,
    "village_name": "Elappully 1",
    "village_name_malayalam": "എലപ്പുള്ളി 1",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 298,
    "village_name": "Elappully 2",
    "village_name_malayalam": "എലപ്പുള്ളി 2",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 299,
    "village_name": "Elappulli-III",
    "village_name_malayalam": "എലപ്പുള്ളി-III",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 300,
    "village_name": "Elathur",
    "village_name_malayalam": "എലത്തൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 301,
    "village_name": "Elavally",
    "village_name_malayalam": "എളവള്ളി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 302,
    "village_name": "Elavanchery",
    "village_name_malayalam": "എലവഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 303,
    "village_name": "Elayavoor",
    "village_name_malayalam": "എളയാവൂർ",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 304,
    "village_name": "West Eleri",
    "village_name_malayalam": "വെസ്റ്റ് എളേരി",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 305,
    "village_name": "Elikkulam",
    "village_name_malayalam": "എലിക്കുളം",
    "is_notified": "False",
    "taluka_id": 70
  },
  {
    "id": 306,
    "village_name": "Elinjipra",
    "village_name_malayalam": "എലിഞ്ഞിപ്ര",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 307,
    "village_name": "Eloor",
    "village_name_malayalam": "ഏലൂർ",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 308,
    "village_name": "Enadimangalam",
    "village_name_malayalam": "ഏനാദിമംഗലം",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 309,
    "village_name": "Enanalloor",
    "village_name_malayalam": "ഏനാനല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 310,
    "village_name": "Enathu",
    "village_name_malayalam": "ഏനാതു",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 311,
    "village_name": "Enkakkad",
    "village_name_malayalam": "എങ്കക്കാട്",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 312,
    "village_name": "Engandiyur",
    "village_name_malayalam": "ഏങ്ങണ്ടിയൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 313,
    "village_name": "Ennakkad",
    "village_name_malayalam": "എണ്ണക്കാട്",
    "is_notified": "False",
    "taluka_id": 14
  },
  {
    "id": 314,
    "village_name": "Eramala",
    "village_name_malayalam": "ഏറാമല",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 315,
    "village_name": "Eramam",
    "village_name_malayalam": "എരമം",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 316,
    "village_name": "Eranellur",
    "village_name_malayalam": "എരനെല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 317,
    "village_name": "Eranholi",
    "village_name_malayalam": "എരൻഹോളി",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 318,
    "village_name": "Erathu",
    "village_name_malayalam": "ഏറത്ത്",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 319,
    "village_name": "Erattupetta",
    "village_name_malayalam": "ഈരാറ്റുപേട്ട",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 320,
    "village_name": "Eravu",
    "village_name_malayalam": "എറവ്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 321,
    "village_name": "Eravattur",
    "village_name_malayalam": "എരവട്ടൂർ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 322,
    "village_name": "Erimayur1",
    "village_name_malayalam": "എരിമയൂർ1",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 323,
    "village_name": "Erimayur2",
    "village_name_malayalam": "എരിമയൂർ2",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 324,
    "village_name": "Eriyad",
    "village_name_malayalam": "എറിയാട്",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 325,
    "village_name": "Ernakulam",
    "village_name_malayalam": "എറണാകുളം",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 326,
    "village_name": "Erumeli North",
    "village_name_malayalam": "എരുമേലി നോർത്ത്",
    "is_notified": "True",
    "taluka_id": 70
  },
  {
    "id": 327,
    "village_name": "Erumeli South",
    "village_name_malayalam": "എരുമേലി സൗത്ത്",
    "is_notified": "True",
    "taluka_id": 70
  },
  {
    "id": 328,
    "village_name": "Yeroor",
    "village_name_malayalam": "യെരൂർ",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 329,
    "village_name": "Eruthempathy",
    "village_name_malayalam": "എരുത്തേമ്പതി",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 330,
    "village_name": "Eruvessy",
    "village_name_malayalam": "എരുവെസ്സി",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 331,
    "village_name": "Eruvatty",
    "village_name_malayalam": "എരുവട്ടി",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 332,
    "village_name": "Ettumanoor",
    "village_name_malayalam": "ഏറ്റുമാനൂർ",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 333,
    "village_name": "Eyyal",
    "village_name_malayalam": "ഇയ്യാൽ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 334,
    "village_name": "Ezhamkulam",
    "village_name_malayalam": "ഏഴംകുളം",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 335,
    "village_name": "Ezhikkara",
    "village_name_malayalam": "ഏഴിക്കര",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 336,
    "village_name": "Ezhom",
    "village_name_malayalam": "എഴോം",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 337,
    "village_name": "Ezhukone",
    "village_name_malayalam": "എഴുകോൺ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 338,
    "village_name": "Ezhumattoor",
    "village_name_malayalam": "എഴുമറ്റൂർ",
    "is_notified": "False",
    "taluka_id": 45
  },
  {
    "id": 339,
    "village_name": "Ezhupunna",
    "village_name_malayalam": "എഴുപുന്ന",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 340,
    "village_name": "Feroke",
    "village_name_malayalam": "ഫെറോക്ക്",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 341,
    "village_name": "Fort Kochi",
    "village_name_malayalam": "ഫോർട്ട് കൊച്ചി",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 342,
    "village_name": "Kanthippara",
    "village_name_malayalam": "കാന്തിപ്പാറ",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 343,
    "village_name": "Guruvayur",
    "village_name_malayalam": "ഗുരുവായൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 344,
    "village_name": "Harippad",
    "village_name_malayalam": "ഹരിപ്പാട്",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 345,
    "village_name": "Herur",
    "village_name_malayalam": "ഹേരൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 346,
    "village_name": "Hosabettu",
    "village_name_malayalam": "ഹൊസബെട്ടു",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 347,
    "village_name": "Hosabettu (Ct)",
    "village_name_malayalam": "ഹൊസബെട്ടു (Ct)",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 348,
    "village_name": "Hosdurg",
    "village_name_malayalam": "ഹൊസ്ദുർഗ്",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 349,
    "village_name": "Ichilampadi",
    "village_name_malayalam": "ഇച്ചിലമ്പാടി",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 350,
    "village_name": "Ichilangod",
    "village_name_malayalam": "ഇച്ചിലങ്കോട്",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 351,
    "village_name": "Edamulakkal",
    "village_name_malayalam": "ഇടമുളയ്ക്കൽ",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 352,
    "village_name": "Edava",
    "village_name_malayalam": "ഇടവ",
    "is_notified": "False",
    "taluka_id": 58
  },
  {
    "id": 353,
    "village_name": "Idukki",
    "village_name_malayalam": "ഇടുക്കി",
    "is_notified": "True",
    "taluka_id": 59
  },
  {
    "id": 354,
    "village_name": "Elamba",
    "village_name_malayalam": "എലംബ",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 355,
    "village_name": "Elampallur",
    "village_name_malayalam": "ഇളമ്പള്ളൂർ",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 356,
    "village_name": "Elanthoor",
    "village_name_malayalam": "എളന്തൂർ",
    "is_notified": "False",
    "taluka_id": 50
  },
  {
    "id": 357,
    "village_name": "Inchamudi",
    "village_name_malayalam": "ഇഞ്ചമുടി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 358,
    "village_name": "Eangapuzha",
    "village_name_malayalam": "ഈങ്ങാപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 359,
    "village_name": "Eramalloor",
    "village_name_malayalam": "എരമല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 73
  },
  {
    "id": 360,
    "village_name": "Eraviperoor",
    "village_name_malayalam": "ഇരവിപേരൂർ",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 361,
    "village_name": "Eravipuram",
    "village_name_malayalam": "ഇരവിപുരം",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 362,
    "village_name": "Irikkur",
    "village_name_malayalam": "ഇരിക്കൂർ",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 363,
    "village_name": "Irimbiliyam",
    "village_name_malayalam": "ഇരിമ്പിളിയം",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 364,
    "village_name": "Irimbranellur",
    "village_name_malayalam": "ഇരിമ്പ്രനെല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 365,
    "village_name": "Iringal",
    "village_name_malayalam": "ഇരിങ്ങൽ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 366,
    "village_name": "Iringapram",
    "village_name_malayalam": "ഇരിങ്ങപ്രം",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 367,
    "village_name": "Irinjalakuda",
    "village_name_malayalam": "ഇരിങ്ങാലക്കുട",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 368,
    "village_name": "Iriveri",
    "village_name_malayalam": "ഇരിവേരി",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 369,
    "village_name": "Irulam",
    "village_name_malayalam": "ഇരുളം",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 370,
    "village_name": "Ittiva",
    "village_name_malayalam": "ഇട്ടിവ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 371,
    "village_name": "Ezhavathuruhy",
    "village_name_malayalam": "ഈഴവതുരുഹ്",
    "is_notified": "False",
    "taluka_id": 20
  },
  {
    "id": 372,
    "village_name": "Kachery",
    "village_name_malayalam": "കച്ചേരി",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 373,
    "village_name": "Kadakampally",
    "village_name_malayalam": "കടകംപള്ളി",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 374,
    "village_name": "Kadakkal",
    "village_name_malayalam": "കടയ്ക്കൽ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 375,
    "village_name": "Kadakkarappally",
    "village_name_malayalam": "കടക്കരപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 376,
    "village_name": "Kadakkavur",
    "village_name_malayalam": "കടയ്ക്കാവൂർ",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 377,
    "village_name": "Kadalundi",
    "village_name_malayalam": "കടലുണ്ടി",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 378,
    "village_name": "Kadamakkudy",
    "village_name_malayalam": "കടമക്കുടി",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 379,
    "village_name": "Kadambanad",
    "village_name_malayalam": "കടമ്പനാട്",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 380,
    "village_name": "Kadambar",
    "village_name_malayalam": "കദംബരം",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 381,
    "village_name": "Kadambazhipuram 1",
    "village_name_malayalam": "കടമ്പഴിപ്പുറം 1",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 382,
    "village_name": "Kadambazhipuram 2",
    "village_name_malayalam": "കടമ്പഴിപ്പുറം 2",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 383,
    "village_name": "Kadambur",
    "village_name_malayalam": "കടമ്പൂർ",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 384,
    "village_name": "Kadanadu",
    "village_name_malayalam": "കടനാട്",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 385,
    "village_name": "Kadannappally",
    "village_name_malayalam": "കടന്നപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 386,
    "village_name": "Kadappuram",
    "village_name_malayalam": "കടപ്പുറം",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 387,
    "village_name": "Kadapra",
    "village_name_malayalam": "കടപ്ര",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 388,
    "village_name": "Kedavoor",
    "village_name_malayalam": "കെടവൂർ",
    "is_notified": "False",
    "taluka_id": 73
  },
  {
    "id": 389,
    "village_name": "Kadikkad",
    "village_name_malayalam": "കടിക്കാട്",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 390,
    "village_name": "Kadinamkulam",
    "village_name_malayalam": "കഠിനംകുളം",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 391,
    "village_name": "Kathirur",
    "village_name_malayalam": "കതിരൂർ",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 392,
    "village_name": "Kadungalloor",
    "village_name_malayalam": "കടുങ്ങല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 393,
    "village_name": "Kadangode",
    "village_name_malayalam": "കടങ്ങോട്",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 394,
    "village_name": "Kaduppassery",
    "village_name_malayalam": "കടുപ്പശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 395,
    "village_name": "Kaduthuruthy",
    "village_name_malayalam": "കടുത്തുരുത്തി",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 396,
    "village_name": "Kainakary North",
    "village_name_malayalam": "കൈനകരി നോർത്ത്",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 397,
    "village_name": "Kainoor",
    "village_name_malayalam": "കൈനൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 398,
    "village_name": "Kaipamangalam",
    "village_name_malayalam": "കൈപ്പമംഗലം",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 399,
    "village_name": "Kaiparambu",
    "village_name_malayalam": "കൈപ്പറമ്പ്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 400,
    "village_name": "Kaippattur",
    "village_name_malayalam": "കൈപ്പട്ടൂർ",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 401,
    "village_name": "Kaippuzha",
    "village_name_malayalam": "കൈപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 402,
    "village_name": "Kairady",
    "village_name_malayalam": "കൈരാടി",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 403,
    "village_name": "Kayyar",
    "village_name_malayalam": "കയ്യാർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 404,
    "village_name": "Kakkad",
    "village_name_malayalam": "കക്കാട്",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 405,
    "village_name": "Kakkanad",
    "village_name_malayalam": "കാക്കനാട്",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 406,
    "village_name": "Kakkodi",
    "village_name_malayalam": "കക്കോടി",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 407,
    "village_name": "Kakkulissery",
    "village_name_malayalam": "കക്കുളിശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 408,
    "village_name": "Kakkur",
    "village_name_malayalam": "കാക്കൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 409,
    "village_name": "Kalady",
    "village_name_malayalam": "കാലടി",
    "is_notified": "False",
    "taluka_id": 20
  },
  {
    "id": 410,
    "village_name": "Kalady",
    "village_name_malayalam": "കാലടി",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 411,
    "village_name": "Kalanad",
    "village_name_malayalam": "കളനാട്",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 412,
    "village_name": "Kalanjoor",
    "village_name_malayalam": "കലഞ്ഞൂർ",
    "is_notified": "False",
    "taluka_id": 55
  },
  {
    "id": 413,
    "village_name": "Kalavoor",
    "village_name_malayalam": "കലവൂർ",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 414,
    "village_name": "Kalayapuram",
    "village_name_malayalam": "കലയപുരം",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 415,
    "village_name": "Kalikavu",
    "village_name_malayalam": "കാളികാവ്",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 416,
    "village_name": "Kaliyoor",
    "village_name_malayalam": "കാളിയൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 417,
    "village_name": "Kalkoonthal",
    "village_name_malayalam": "കൽക്കൂന്തൽ",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 418,
    "village_name": "Kallamala",
    "village_name_malayalam": "കല്ലമല",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 419,
    "village_name": "Kallar",
    "village_name_malayalam": "കല്ലാർ",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 420,
    "village_name": "Kallara",
    "village_name_malayalam": "കല്ലറ",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 421,
    "village_name": "Kallara",
    "village_name_malayalam": "കല്ലറ",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 422,
    "village_name": "Kallelibhagom",
    "village_name_malayalam": "കല്ലേലിഭാഗം",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 423,
    "village_name": "Kallettumkara",
    "village_name_malayalam": "കല്ലേറ്റുംകര",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 424,
    "village_name": "Kallikkad",
    "village_name_malayalam": "കള്ളിക്കാട്",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 425,
    "village_name": "Kalliad",
    "village_name_malayalam": "കള്ളിയാട്",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 426,
    "village_name": "Kalliyoor",
    "village_name_malayalam": "കല്ലിയൂർ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 427,
    "village_name": "Kallooppara",
    "village_name_malayalam": "കല്ലൂപ്പാറ",
    "is_notified": "False",
    "taluka_id": 45
  },
  {
    "id": 428,
    "village_name": "Kallur",
    "village_name_malayalam": "കല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 429,
    "village_name": "Kallur Thekkummuri",
    "village_name_malayalam": "കല്ലൂർ തെക്കുംമുറി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 430,
    "village_name": "Kallur Vadakkumuri",
    "village_name_malayalam": "കല്ലൂർ വടക്കുമുറി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 431,
    "village_name": "Kalloorkkad",
    "village_name_malayalam": "കല്ലൂർക്കാട്",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 432,
    "village_name": "Kalluvathukkal",
    "village_name_malayalam": "കല്ലുവാതുക്കൽ",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 433,
    "village_name": "Kalpakanchery",
    "village_name_malayalam": "കൽപകഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 434,
    "village_name": "Kalpetta",
    "village_name_malayalam": "കൽപ്പറ്റ",
    "is_notified": "True",
    "taluka_id": 1
  },
  {
    "id": 435,
    "village_name": "Kalliasseri",
    "village_name_malayalam": "കല്ല്യാശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 436,
    "village_name": "Kanakkari",
    "village_name_malayalam": "കാണക്കാരി",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 437,
    "village_name": "Kandalloor",
    "village_name_malayalam": "കണ്ടല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 438,
    "village_name": "Kanthalloor",
    "village_name_malayalam": "കാന്തല്ലൂർ",
    "is_notified": "True",
    "taluka_id": 37
  },
  {
    "id": 439,
    "village_name": "Kandanissery",
    "village_name_malayalam": "കണ്ടാണിശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 440,
    "village_name": "Kandamkunnu",
    "village_name_malayalam": "കണ്ടംകുന്ന്",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 441,
    "village_name": "Kangazha",
    "village_name_malayalam": "കങ്ങഴ",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 442,
    "village_name": "Kanhangad",
    "village_name_malayalam": "കാഞ്ഞങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 443,
    "village_name": "Kanhirode",
    "village_name_malayalam": "കാഞ്ഞിരോട്",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 444,
    "village_name": "Kanichar",
    "village_name_malayalam": "കണിച്ചാർ",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 445,
    "village_name": "Kanimangalam",
    "village_name_malayalam": "കണിമംഗലം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 446,
    "village_name": "Kanipayyoor",
    "village_name_malayalam": "കാണിപ്പയ്യൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 447,
    "village_name": "Kaniyambetta",
    "village_name_malayalam": "കണിയാമ്പറ്റ",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 448,
    "village_name": "Kaniyarkode",
    "village_name_malayalam": "കണിയാർകോട്",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 449,
    "village_name": "Kanjikkuzhi",
    "village_name_malayalam": "കഞ്ഞിക്കുഴി",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 450,
    "village_name": "Kanjikuzhy",
    "village_name_malayalam": "കഞ്ഞിക്കുഴി",
    "is_notified": "False",
    "taluka_id": 59
  },
  {
    "id": 451,
    "village_name": "Kanjirakkode",
    "village_name_malayalam": "കാഞ്ഞിരക്കോട്",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 452,
    "village_name": "Kanjiramkulam",
    "village_name_malayalam": "കാഞ്ഞിരംകുളം",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 453,
    "village_name": "Kanjirangad",
    "village_name_malayalam": "കാഞ്ഞിരങ്ങാട്",
    "is_notified": "True",
    "taluka_id": 46
  },
  {
    "id": 454,
    "village_name": "Kanjirappally",
    "village_name_malayalam": "കാഞ്ഞിരപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 70
  },
  {
    "id": 455,
    "village_name": "Kankol",
    "village_name_malayalam": "കാങ്കോൽ",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 456,
    "village_name": "Kannadi 1",
    "village_name_malayalam": "കണ്ണാടി 1",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 457,
    "village_name": "Kannadi 2",
    "village_name_malayalam": "കണ്ണാടി 2",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 458,
    "village_name": "Kannadiparamba",
    "village_name_malayalam": "കണ്ണാടിപ്പറമ്പ്",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 459,
    "village_name": "Kannamangalam",
    "village_name_malayalam": "കണ്ണമംഗലം",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 460,
    "village_name": "Kannamangalam",
    "village_name_malayalam": "കണ്ണമംഗലം",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 461,
    "village_name": "Kannambra-I",
    "village_name_malayalam": "കണ്ണമ്പ്ര-ഐ",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 462,
    "village_name": "Kannanbra-2",
    "village_name_malayalam": "കണ്ണൻബ്ര-2",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 463,
    "village_name": "Kannapuram",
    "village_name_malayalam": "കണ്ണപുരം",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 464,
    "village_name": "Kannavam",
    "village_name_malayalam": "കണ്ണവം",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 465,
    "village_name": "Kannur-I",
    "village_name_malayalam": "കണ്ണൂർ-ഐ",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 466,
    "village_name": "Kannur-II",
    "village_name_malayalam": "കണ്ണൂർ-രണ്ട്",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 467,
    "village_name": "Kannur",
    "village_name_malayalam": "കണ്ണൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 468,
    "village_name": "Kanthalad",
    "village_name_malayalam": "കാന്തലാട്",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 469,
    "village_name": "Kappur",
    "village_name_malayalam": "കപ്പൂർ",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 470,
    "village_name": "Karadka",
    "village_name_malayalam": "കാരഡ്ക",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 471,
    "village_name": "Karakunnu",
    "village_name_malayalam": "കാരക്കുന്ന്",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 472,
    "village_name": "Karakurussi",
    "village_name_malayalam": "കാരാകുറുശ്ശി",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 473,
    "village_name": "Karakulam",
    "village_name_malayalam": "കരകുളം",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 474,
    "village_name": "Kaaralam",
    "village_name_malayalam": "കാറളം",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 475,
    "village_name": "Karamukk",
    "village_name_malayalam": "കാരമുക്ക്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 476,
    "village_name": "Karavaloor",
    "village_name_malayalam": "കരവാളൂർ",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 477,
    "village_name": "Karavaram",
    "village_name_malayalam": "കരവാരം",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 478,
    "village_name": "Karikkad",
    "village_name_malayalam": "കരിക്കാട്",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 479,
    "village_name": "Karikkode",
    "village_name_malayalam": "കാരിക്കോട്",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 480,
    "village_name": "Karimannoor",
    "village_name_malayalam": "കരിമണ്ണൂർ",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 481,
    "village_name": "Karimba 1",
    "village_name_malayalam": "കരിമ്പ 1",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 482,
    "village_name": "Karimba 2",
    "village_name_malayalam": "കരിമ്പ 2",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 483,
    "village_name": "Karimpuzha 1",
    "village_name_malayalam": "കരിമ്പുഴ 1",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 484,
    "village_name": "Karimpuzha 2",
    "village_name_malayalam": "കരിമ്പുഴ 2",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 485,
    "village_name": "Karimkunnam",
    "village_name_malayalam": "കരിംകുന്നം",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 486,
    "village_name": "Karinthalam",
    "village_name_malayalam": "കരിന്തളം",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 487,
    "village_name": "Kareepra",
    "village_name_malayalam": "കരീപ്ര",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 488,
    "village_name": "Karivedakam",
    "village_name_malayalam": "കരിവേടകം",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 489,
    "village_name": "Karivellur",
    "village_name_malayalam": "കരിവെള്ളൂർ",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 490,
    "village_name": "Kariyannur",
    "village_name_malayalam": "കരിയന്നൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 491,
    "village_name": "Karode",
    "village_name_malayalam": "കരോഡ്",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 492,
    "village_name": "Karthikappally",
    "village_name_malayalam": "കാർത്തികപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 493,
    "village_name": "Karukachal",
    "village_name_malayalam": "കറുകച്ചാൽ",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 494,
    "village_name": "Karukutty",
    "village_name_malayalam": "കറുകുറ്റി",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 495,
    "village_name": "Karulai",
    "village_name_malayalam": "കരുളായി",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 496,
    "village_name": "Karumady",
    "village_name_malayalam": "കരുമാടി",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 497,
    "village_name": "Karumalloor",
    "village_name_malayalam": "കരുമാല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 498,
    "village_name": "Karumathra",
    "village_name_malayalam": "കരുമത്ര",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 499,
    "village_name": "Karumathra",
    "village_name_malayalam": "കരുമത്ര",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 500,
    "village_name": "Karumkulam",
    "village_name_malayalam": "കരുംകുളം",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 501,
    "village_name": "Karunagappally",
    "village_name_malayalam": "കരുനാഗപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 502,
    "village_name": "Karunapuram",
    "village_name_malayalam": "കരുണാപുരം",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 503,
    "village_name": "Karippur",
    "village_name_malayalam": "കരിപ്പൂർ",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 504,
    "village_name": "Kuruvambalam",
    "village_name_malayalam": "കുരുവമ്പലം",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 505,
    "village_name": "Karuvanthiruthi",
    "village_name_malayalam": "കരുവൻതിരുത്തി",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 506,
    "village_name": "Karuvarakundu",
    "village_name_malayalam": "കരുവാരക്കുണ്ട്",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 507,
    "village_name": "Karuvatta",
    "village_name_malayalam": "കരുവാറ്റ",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 508,
    "village_name": "Karyavattom",
    "village_name_malayalam": "കാര്യവട്ടം",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 509,
    "village_name": "Kasaragod Group",
    "village_name_malayalam": "കാസർഗോഡ് ഗ്രൂപ്പ്",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 510,
    "village_name": "Kadavallur",
    "village_name_malayalam": "കടവല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 511,
    "village_name": "Kattakampal",
    "village_name_malayalam": "കാട്ടകാമ്പാൽ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 512,
    "village_name": "Kattakkada",
    "village_name_malayalam": "കാട്ടാക്കട",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 513,
    "village_name": "Kattanam",
    "village_name_malayalam": "കറ്റാനം",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 514,
    "village_name": "Kattappana",
    "village_name_malayalam": "കട്ടപ്പന",
    "is_notified": "False",
    "taluka_id": 59
  },
  {
    "id": 515,
    "village_name": "Kattipparuthy",
    "village_name_malayalam": "കട്ടിപ്പരുത്തി",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 516,
    "village_name": "Kattukukke",
    "village_name_malayalam": "കാട്ടുകുക്കെ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 517,
    "village_name": "Kattur",
    "village_name_malayalam": "കാട്ടൂർ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 518,
    "village_name": "Kavalam",
    "village_name_malayalam": "കാവാലം",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 519,
    "village_name": "Kavanur",
    "village_name_malayalam": "കാവനൂർ",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 520,
    "village_name": "Kavasseri-I",
    "village_name_malayalam": "കാവശ്ശേരി-ഐ",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 521,
    "village_name": "Kavasseri-II",
    "village_name_malayalam": "കാവശ്ശേരി-II",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 522,
    "village_name": "Kavilumpara",
    "village_name_malayalam": "കാവിലുംപാറ",
    "is_notified": "True",
    "taluka_id": 57
  },
  {
    "id": 523,
    "village_name": "Kaviyoor",
    "village_name_malayalam": "കവിയൂർ",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 524,
    "village_name": "Kowdiar",
    "village_name_malayalam": "കവടിയാർ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 525,
    "village_name": "Kavumbhagom",
    "village_name_malayalam": "കാവുംഭാഗം",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 526,
    "village_name": "Kavumannam",
    "village_name_malayalam": "കാവുമന്നം",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 527,
    "village_name": "Kayakkodi",
    "village_name_malayalam": "കായക്കൊടി",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 528,
    "village_name": "Kayamkulam",
    "village_name_malayalam": "കായംകുളം",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 529,
    "village_name": "Kayanna",
    "village_name_malayalam": "കായണ്ണ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 530,
    "village_name": "Kayaralam",
    "village_name_malayalam": "കയറളം",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 531,
    "village_name": "Kayyur",
    "village_name_malayalam": "കയ്യൂർ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 532,
    "village_name": "Kazhakoottam",
    "village_name_malayalam": "കഴക്കൂട്ടം",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 533,
    "village_name": "Kedavoor",
    "village_name_malayalam": "കെടവൂർ",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 534,
    "village_name": "Keekan",
    "village_name_malayalam": "കീകൻ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 535,
    "village_name": "Keezhanthoor",
    "village_name_malayalam": "കീഴാന്തൂർ",
    "is_notified": "False",
    "taluka_id": 37
  },
  {
    "id": 536,
    "village_name": "Keezhariyur",
    "village_name_malayalam": "കീഴരിയൂർ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 537,
    "village_name": "Keezhallur",
    "village_name_malayalam": "കീഴല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 538,
    "village_name": "Keezharoor",
    "village_name_malayalam": "കീഴാറൂർ",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 539,
    "village_name": "Keezhattingal",
    "village_name_malayalam": "കീഴാറ്റിങ്ങൽ",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 540,
    "village_name": "Keezhuparamba",
    "village_name_malayalam": "കീഴുപറമ്പ്",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 541,
    "village_name": "Keezhur",
    "village_name_malayalam": "കീഴൂർ",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 542,
    "village_name": "Kizhuvilam",
    "village_name_malayalam": "കിഴുവിലം",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 543,
    "village_name": "Keezhattur",
    "village_name_malayalam": "കീഴാറ്റൂർ",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 544,
    "village_name": "Kelakam",
    "village_name_malayalam": "കേളകം",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 545,
    "village_name": "Kerala Estate",
    "village_name_malayalam": "കേരള എസ്റ്റേറ്റ്",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 546,
    "village_name": "Keralassery",
    "village_name_malayalam": "കേരളശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 547,
    "village_name": "Kidanganad",
    "village_name_malayalam": "കിടങ്ങനാട്",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 548,
    "village_name": "Kidangannur",
    "village_name_malayalam": "കിടങ്ങന്നൂർ",
    "is_notified": "False",
    "taluka_id": 50
  },
  {
    "id": 549,
    "village_name": "Kidangoor",
    "village_name_malayalam": "കിടങ്ങൂർ",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 550,
    "village_name": "Kidhur",
    "village_name_malayalam": "കിധൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 551,
    "village_name": "Kilikollur",
    "village_name_malayalam": "കിളികൊല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 552,
    "village_name": "Kilimanoor",
    "village_name_malayalam": "കിളിമാനൂർ",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 553,
    "village_name": "Killannur",
    "village_name_malayalam": "കിളന്നൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 554,
    "village_name": "Killimangalam",
    "village_name_malayalam": "കിള്ളിമംഗലം",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 555,
    "village_name": "Kinaloor",
    "village_name_malayalam": "കിനാലൂർ",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 556,
    "village_name": "Kinanoor",
    "village_name_malayalam": "കിനാനൂർ",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 557,
    "village_name": "Kiralur",
    "village_name_malayalam": "കിരാലൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 558,
    "village_name": "Kizhakkancheri",
    "village_name_malayalam": "കിഴക്കഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 559,
    "village_name": "Kizhakkenchery 1",
    "village_name_malayalam": "കിഴക്കഞ്ചേരി 1",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 560,
    "village_name": "Kizhkkenchery 2",
    "village_name_malayalam": "കിഴക്കഞ്ചേരി 2",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 561,
    "village_name": "Kizhakke Chalakudy",
    "village_name_malayalam": "കിഴക്കേ ചാലക്കുടി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 562,
    "village_name": "Kizhakkummuri",
    "village_name_malayalam": "കിഴക്കുംമുറി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 563,
    "village_name": "Kizhakkoth",
    "village_name_malayalam": "കിഴക്കോത്ത്",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 564,
    "village_name": "Kizhakkumbhagom",
    "village_name_malayalam": "കിഴക്കുംഭാഗം",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 565,
    "village_name": "Kizhakkummuri",
    "village_name_malayalam": "കിഴക്കുംമുറി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 566,
    "village_name": "Keezhthonnakkal",
    "village_name_malayalam": "കീഴ്തോന്നക്കൽ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 567,
    "village_name": "Kizhuppillikkara",
    "village_name_malayalam": "കിഴുപ്പിള്ളിക്കര",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 568,
    "village_name": "Clappana",
    "village_name_malayalam": "ക്ലപ്പാന",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 569,
    "village_name": "Klayikode",
    "village_name_malayalam": "ക്ലായിക്കോട്",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 570,
    "village_name": "Kollengode 1",
    "village_name_malayalam": "കൊല്ലങ്കോട് 1",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 571,
    "village_name": "Kodakara",
    "village_name_malayalam": "കൊടകര",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 572,
    "village_name": "Kodakkad",
    "village_name_malayalam": "കൊടക്കാട്",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 573,
    "village_name": "Kodanad",
    "village_name_malayalam": "കോടനാട്",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 574,
    "village_name": "Kodanchery",
    "village_name_malayalam": "കോടഞ്ചേരി",
    "is_notified": "True",
    "taluka_id": 52
  },
  {
    "id": 575,
    "village_name": "Kodamthuruthu",
    "village_name_malayalam": "കോടംതുരുത്ത്",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 576,
    "village_name": "Kodannur",
    "village_name_malayalam": "കോടന്നൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 577,
    "village_name": "Kodassery",
    "village_name_malayalam": "കോടശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 578,
    "village_name": "Kodibayal",
    "village_name_malayalam": "കൊടിബയൽ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 579,
    "village_name": "Kodikkulam",
    "village_name_malayalam": "കോടിക്കുളം",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 580,
    "village_name": "Kodiyathur",
    "village_name_malayalam": "കൊടിയത്തൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 581,
    "village_name": "Kodiyeri",
    "village_name_malayalam": "കോടിയേരി",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 582,
    "village_name": "Kodlamogaru",
    "village_name_malayalam": "കൊഡ്ലമൊഗരു",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 583,
    "village_name": "Kodoth",
    "village_name_malayalam": "കോടോത്ത്",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 584,
    "village_name": "Kodumon",
    "village_name_malayalam": "കൊടുമൺ",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 585,
    "village_name": "Kodumba",
    "village_name_malayalam": "കൊടുമ്പ",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 586,
    "village_name": "Kodur",
    "village_name_malayalam": "കോഡൂർ",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 587,
    "village_name": "Koduvally",
    "village_name_malayalam": "കൊടുവള്ളി",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 588,
    "village_name": "Koduvayur",
    "village_name_malayalam": "കൊടുവായൂർ",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 589,
    "village_name": "Koduvayur 1",
    "village_name_malayalam": "കൊടുവായൂർ 1",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 590,
    "village_name": "Koduvayur 2",
    "village_name_malayalam": "കൊടുവായൂർ 2",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 591,
    "village_name": "Koduvazhanoor",
    "village_name_malayalam": "കൊടുവഴന്നൂർ",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 592,
    "village_name": "Koipady",
    "village_name_malayalam": "കോയിപ്പാടി",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 593,
    "village_name": "Kokkayar",
    "village_name_malayalam": "കൊക്കയാർ",
    "is_notified": "False",
    "taluka_id": 38
  },
  {
    "id": 594,
    "village_name": "Kokkothamangalam",
    "village_name_malayalam": "കൊക്കോതമംഗലം",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 595,
    "village_name": "Kolachery",
    "village_name_malayalam": "കൊളച്ചേരി",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 596,
    "village_name": "Kolari",
    "village_name_malayalam": "കോളാരി",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 597,
    "village_name": "Kolathur",
    "village_name_malayalam": "കൊളത്തൂർ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 598,
    "village_name": "Kolavallur",
    "village_name_malayalam": "കൊളവല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 599,
    "village_name": "Kolayad",
    "village_name_malayalam": "കോളയാട്",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 600,
    "village_name": "Kolazhy",
    "village_name_malayalam": "കോലഴി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 601,
    "village_name": "Koliyacode",
    "village_name_malayalam": "കോലിയക്കോട്",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 602,
    "village_name": "Koliyoor",
    "village_name_malayalam": "കോളിയൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 603,
    "village_name": "Kollam",
    "village_name_malayalam": "കൊല്ലം",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 604,
    "village_name": "Kollamula",
    "village_name_malayalam": "കൊല്ലമുള",
    "is_notified": "True",
    "taluka_id": 42
  },
  {
    "id": 605,
    "village_name": "Kollengode 2",
    "village_name_malayalam": "കൊല്ലങ്കോട് 2",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 606,
    "village_name": "Kollayil",
    "village_name_malayalam": "കൊല്ലയിൽ",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 607,
    "village_name": "Komalapuram",
    "village_name_malayalam": "കോമളപുരം",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 608,
    "village_name": "Kombanad",
    "village_name_malayalam": "കൊമ്പനാട്",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 609,
    "village_name": "Kondazhy-Mayannur",
    "village_name_malayalam": "കൊണ്ടാഴി-മായന്നൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 610,
    "village_name": "Kondotty",
    "village_name_malayalam": "കൊണ്ടോട്ടി",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 611,
    "village_name": "Kondur",
    "village_name_malayalam": "കൊണ്ടൂർ",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 612,
    "village_name": "Kongad 2",
    "village_name_malayalam": "കോങ്ങാട് 2",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 613,
    "village_name": "Kongad 1",
    "village_name_malayalam": "കോങ്ങാട് 1",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 614,
    "village_name": "Konnithazham",
    "village_name_malayalam": "കോന്നിത്താഴം",
    "is_notified": "False",
    "taluka_id": 55
  },
  {
    "id": 615,
    "village_name": "Konnathady",
    "village_name_malayalam": "കൊന്നത്തടി",
    "is_notified": "False",
    "taluka_id": 59
  },
  {
    "id": 616,
    "village_name": "Konni",
    "village_name_malayalam": "കോന്നി",
    "is_notified": "False",
    "taluka_id": 55
  },
  {
    "id": 617,
    "village_name": "Koothattukulam",
    "village_name_malayalam": "കൂത്താട്ടുകുളം",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 618,
    "village_name": "Koppam",
    "village_name_malayalam": "കൊപ്പം",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 619,
    "village_name": "Korom",
    "village_name_malayalam": "കോറോം",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 620,
    "village_name": "Kothanallor",
    "village_name_malayalam": "കോതനല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 621,
    "village_name": "Kothamangalam",
    "village_name_malayalam": "കോതമംഗലം",
    "is_notified": "False",
    "taluka_id": 73
  },
  {
    "id": 622,
    "village_name": "Kottakkal",
    "village_name_malayalam": "കോട്ടക്കൽ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 623,
    "village_name": "Kottakomboor",
    "village_name_malayalam": "കൊട്ടക്കൊമ്പൂർ",
    "is_notified": "False",
    "taluka_id": 37
  },
  {
    "id": 624,
    "village_name": "Kottanellur",
    "village_name_malayalam": "കൊറ്റനെല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 625,
    "village_name": "Kottangal",
    "village_name_malayalam": "കോട്ടാങ്ങൽ",
    "is_notified": "False",
    "taluka_id": 45
  },
  {
    "id": 626,
    "village_name": "Kottamkara",
    "village_name_malayalam": "കൊറ്റംകര",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 627,
    "village_name": "Kottappadi",
    "village_name_malayalam": "കോട്ടപ്പടി",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 628,
    "village_name": "Kottappally",
    "village_name_malayalam": "കോട്ടപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 629,
    "village_name": "Kottapuram",
    "village_name_malayalam": "കോട്ടപ്പുറം",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 630,
    "village_name": "Kottappuram",
    "village_name_malayalam": "കോട്ടപ്പുറം",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 631,
    "village_name": "Kottarakkara",
    "village_name_malayalam": "കൊട്ടാരക്കര",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 632,
    "village_name": "Kottathara",
    "village_name_malayalam": "കോട്ടത്തറ",
    "is_notified": "True",
    "taluka_id": 8
  },
  {
    "id": 633,
    "village_name": "Kottathara",
    "village_name_malayalam": "കോട്ടത്തറ",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 634,
    "village_name": "Kottayam",
    "village_name_malayalam": "കോട്ടയം",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 635,
    "village_name": "Kottayam",
    "village_name_malayalam": "കോട്ടയം",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 636,
    "village_name": "Kottayi 1",
    "village_name_malayalam": "കോട്ടായി 1",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 637,
    "village_name": "Kottayi 2",
    "village_name_malayalam": "കോട്ടായി 2",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 638,
    "village_name": "Kottiyoor",
    "village_name_malayalam": "കൊട്ടിയൂർ",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 639,
    "village_name": "Kottoppadam 1",
    "village_name_malayalam": "കോട്ടോപ്പാടം 1",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 640,
    "village_name": "Kottoppadam 2",
    "village_name_malayalam": "കോട്ടോപ്പാടം 2",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 641,
    "village_name": "Kottoppadam 3",
    "village_name_malayalam": "കോട്ടോപ്പാടം 3",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 642,
    "village_name": "Kottukkal",
    "village_name_malayalam": "കോട്ടുക്കൽ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 643,
    "village_name": "Kottukal",
    "village_name_malayalam": "കോട്ടുകാൽ",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 644,
    "village_name": "Kottooli",
    "village_name_malayalam": "കോട്ടൂളി",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 645,
    "village_name": "Kottur",
    "village_name_malayalam": "കോറ്റൂർ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 646,
    "village_name": "Kottuvally",
    "village_name_malayalam": "കോട്ടുവള്ളി",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 647,
    "village_name": "Koipuram",
    "village_name_malayalam": "കോയിപ്പുറം",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 648,
    "village_name": "Kozhenchery",
    "village_name_malayalam": "കോഴഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 50
  },
  {
    "id": 649,
    "village_name": "Kozhikode",
    "village_name_malayalam": "കോഴിക്കോട്",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 650,
    "village_name": "Kozhinjampara",
    "village_name_malayalam": "കൊഴിഞ്ഞാമ്പാറ",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 651,
    "village_name": "Kozhipathy",
    "village_name_malayalam": "കോഴിപ്പതി",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 652,
    "village_name": "Kozhukkallur",
    "village_name_malayalam": "കൊഴുക്കല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 653,
    "village_name": "Kozhukully",
    "village_name_malayalam": "കൊഴുക്കുള്ളി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 654,
    "village_name": "Krishnagiri",
    "village_name_malayalam": "കൃഷ്ണഗിരി",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 655,
    "village_name": "Krishnapuram",
    "village_name_malayalam": "കൃഷ്ണപുരം",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 656,
    "village_name": "Kubannur",
    "village_name_malayalam": "കുബണ്ണൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 657,
    "village_name": "Koodal",
    "village_name_malayalam": "കൂടൽ",
    "is_notified": "False",
    "taluka_id": 55
  },
  {
    "id": 658,
    "village_name": "Koodali",
    "village_name_malayalam": "കൂടാളി",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 659,
    "village_name": "Kudalmerkala",
    "village_name_malayalam": "കുടൽമേർക്കള",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 660,
    "village_name": "Kudappanakunnu",
    "village_name_malayalam": "കുടപ്പനക്കുന്ന്",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 661,
    "village_name": "Koodaranhi",
    "village_name_malayalam": "കൂടരൻഹി",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 662,
    "village_name": "Koodathai",
    "village_name_malayalam": "കൂടത്തായി",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 663,
    "village_name": "Kudavoor",
    "village_name_malayalam": "കുടവൂർ",
    "is_notified": "False",
    "taluka_id": 58
  },
  {
    "id": 664,
    "village_name": "Kudayathoor",
    "village_name_malayalam": "കുടയത്തൂർ",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 665,
    "village_name": "Kudlu",
    "village_name_malayalam": "കുഡ്‌ലു",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 666,
    "village_name": "Kulakkada",
    "village_name_malayalam": "കുളക്കട",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 667,
    "village_name": "Kulanada",
    "village_name_malayalam": "കുളനട",
    "is_notified": "False",
    "taluka_id": 50
  },
  {
    "id": 668,
    "village_name": "Kulasekharamangalam",
    "village_name_malayalam": "കുലശേഖരമംഗലം",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 669,
    "village_name": "Kulasekharapuram",
    "village_name_malayalam": "കുലശേഖരപുരം",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 670,
    "village_name": "Kulathupuzha",
    "village_name_malayalam": "കുളത്തൂപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 671,
    "village_name": "Kulathoor",
    "village_name_malayalam": "കുളത്തൂർ",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 672,
    "village_name": "Koolimuttom",
    "village_name_malayalam": "കൂളിമുട്ടം",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 673,
    "village_name": "Kulukkallur",
    "village_name_malayalam": "കുലുക്കല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 674,
    "village_name": "Kuloor",
    "village_name_malayalam": "കുളൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 675,
    "village_name": "Kumarakom",
    "village_name_malayalam": "കുമരകം",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 676,
    "village_name": "Kumaramangalam",
    "village_name_malayalam": "കുമാരമംഗലം",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 677,
    "village_name": "Kumaramputhur",
    "village_name_malayalam": "കുമരംപുത്തൂർ",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 678,
    "village_name": "Kumaranallur",
    "village_name_malayalam": "കുമാരനല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 679,
    "village_name": "Kumaranellur",
    "village_name_malayalam": "കുമരനെല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 680,
    "village_name": "Kumarapuram",
    "village_name_malayalam": "കുമാരപുരം",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 681,
    "village_name": "Kumbadaje",
    "village_name_malayalam": "കുംബഡാജെ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 682,
    "village_name": "Kumbalam",
    "village_name_malayalam": "കുമ്പളം",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 683,
    "village_name": "Kumbalangy",
    "village_name_malayalam": "കുമ്പളങ്ങി",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 684,
    "village_name": "Kumily",
    "village_name_malayalam": "കുമളി",
    "is_notified": "False",
    "taluka_id": 38
  },
  {
    "id": 685,
    "village_name": "Kummil",
    "village_name_malayalam": "കുമ്മിൾ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 686,
    "village_name": "Kundaliyur",
    "village_name_malayalam": "കുണ്ടലിയൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 687,
    "village_name": "Kunjhimangalam",
    "village_name_malayalam": "കുഞ്ഞിമംഗലം",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 688,
    "village_name": "Kunjathur",
    "village_name_malayalam": "കുഞ്ചത്തൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 689,
    "village_name": "Kunjithanny",
    "village_name_malayalam": "കുഞ്ഞിത്തണ്ണി",
    "is_notified": "False",
    "taluka_id": 37
  },
  {
    "id": 690,
    "village_name": "Kunnamangalam",
    "village_name_malayalam": "കുന്നമംഗലം",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 691,
    "village_name": "Kunnamkulam",
    "village_name_malayalam": "കുന്നംകുളം",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 692,
    "village_name": "Kunnamthanam",
    "village_name_malayalam": "കുന്നംതാനം",
    "is_notified": "False",
    "taluka_id": 45
  },
  {
    "id": 693,
    "village_name": "Kunnathur",
    "village_name_malayalam": "കുന്നത്തൂർ",
    "is_notified": "False",
    "taluka_id": 75
  },
  {
    "id": 694,
    "village_name": "Kunnatnad",
    "village_name_malayalam": "കുന്നത്ത്നാട്",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 695,
    "village_name": "Kunnathidavaka",
    "village_name_malayalam": "കുന്നത്തിടവക",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 696,
    "village_name": "Kunnathukal",
    "village_name_malayalam": "കുന്നത്തുകാൽ",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 697,
    "village_name": "Kunnathunad",
    "village_name_malayalam": "കുന്നത്തുനാട്",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 698,
    "village_name": "Kunnukara",
    "village_name_malayalam": "കുന്നുകര",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 699,
    "village_name": "Kunnumma",
    "village_name_malayalam": "കുന്നുമ്മ",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 700,
    "village_name": "Kunnummal",
    "village_name_malayalam": "കുന്നുമ്മൽ",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 701,
    "village_name": "Kuppadi",
    "village_name_malayalam": "കുപ്പാടി",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 702,
    "village_name": "Kuppadithara",
    "village_name_malayalam": "കുപ്പാടിത്തറ",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 703,
    "village_name": "Koorachundu",
    "village_name_malayalam": "കൂരാച്ചുണ്ട്",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 704,
    "village_name": "Kurampala",
    "village_name_malayalam": "കുരമ്പാല",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 705,
    "village_name": "Kurattissery",
    "village_name_malayalam": "കുരട്ടിശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 14
  },
  {
    "id": 706,
    "village_name": "Kuravilangadu",
    "village_name_malayalam": "കുറവിലങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 707,
    "village_name": "Keerampara",
    "village_name_malayalam": "കീരംപാറ",
    "is_notified": "False",
    "taluka_id": 73
  },
  {
    "id": 708,
    "village_name": "Kurichy",
    "village_name_malayalam": "കുറിച്ചി",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 709,
    "village_name": "Kurichikkara",
    "village_name_malayalam": "കുറിച്ചിക്കര",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 710,
    "village_name": "Kurichithanam",
    "village_name_malayalam": "കുറിച്ചിത്താനം",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 711,
    "village_name": "Keerikkad",
    "village_name_malayalam": "കീരിക്കാട്",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 712,
    "village_name": "Kureekkad",
    "village_name_malayalam": "കുരീക്കാട്",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 713,
    "village_name": "Kooroppada",
    "village_name_malayalam": "കൂരോപ്പട",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 714,
    "village_name": "Koorkkanchery",
    "village_name_malayalam": "കൂർക്കഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 715,
    "village_name": "Kurumala",
    "village_name_malayalam": "കുറുമല",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 716,
    "village_name": "Kurumathur",
    "village_name_malayalam": "കുറുമാത്തൂർ",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 717,
    "village_name": "Kurumbalangode",
    "village_name_malayalam": "കുറുമ്പലങ്ങോട്",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 718,
    "village_name": "Kurumbathoor",
    "village_name_malayalam": "കുറുമ്പത്തൂർ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 719,
    "village_name": "Kurunpilavu",
    "village_name_malayalam": "കുറുന്പിലാവ്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 720,
    "village_name": "Kurupuzha",
    "village_name_malayalam": "കുറുപുഴ",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 721,
    "village_name": "Kuruva",
    "village_name_malayalam": "കുറുവ",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 722,
    "village_name": "Kuruvattoor",
    "village_name_malayalam": "കുറുവട്ടൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 723,
    "village_name": "Kuruvilassery",
    "village_name_malayalam": "കുരുവിലശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 724,
    "village_name": "Koothali",
    "village_name_malayalam": "കൂത്താളി",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 725,
    "village_name": "Kuttamangalam",
    "village_name_malayalam": "കുട്ടമംഗലം",
    "is_notified": "False",
    "taluka_id": 73
  },
  {
    "id": 726,
    "village_name": "Kuttampuzha",
    "village_name_malayalam": "കുട്ടമ്പുഴ",
    "is_notified": "True",
    "taluka_id": 73
  },
  {
    "id": 727,
    "village_name": "Kuttanad",
    "village_name_malayalam": "കുട്ടനാട്",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 728,
    "village_name": "Kuthanur-II",
    "village_name_malayalam": "കുത്തനൂർ-രണ്ടാം",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 729,
    "village_name": "Kuthannur-I",
    "village_name_malayalam": "കുത്തന്നൂർ-ഐ",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 730,
    "village_name": "Kuttapuzha",
    "village_name_malayalam": "കുറ്റപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 731,
    "village_name": "Kuttichira",
    "village_name_malayalam": "കുറ്റിച്ചിറ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 732,
    "village_name": "Koottickal",
    "village_name_malayalam": "കൂട്ടിക്കൽ",
    "is_notified": "False",
    "taluka_id": 70
  },
  {
    "id": 733,
    "village_name": "Kuttikkattoor",
    "village_name_malayalam": "കുറ്റിക്കാട്ടൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 734,
    "village_name": "Kuttikol",
    "village_name_malayalam": "കുറ്റിക്കോൽ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 735,
    "village_name": "Koottilangadi",
    "village_name_malayalam": "കൂട്ടിലങ്ങാടി",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 736,
    "village_name": "Kuttippuram",
    "village_name_malayalam": "കുറ്റിപ്പുറം",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 737,
    "village_name": "Kuttiady",
    "village_name_malayalam": "കുറ്റ്യാടി",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 738,
    "village_name": "Kuthiathodu",
    "village_name_malayalam": "കുത്തിയതോട്",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 739,
    "village_name": "Kuttyattur",
    "village_name_malayalam": "കുറ്റ്യാട്ടൂർ",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 740,
    "village_name": "Kuttiyeri",
    "village_name_malayalam": "കുറ്റിയേരി",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 741,
    "village_name": "Kuttoor",
    "village_name_malayalam": "കുറ്റൂർ",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 742,
    "village_name": "Kuthuparamba",
    "village_name_malayalam": "കുത്തുപറമ്പ്",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 743,
    "village_name": "Kuttoor",
    "village_name_malayalam": "കുറ്റൂർ",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 744,
    "village_name": "Kuttoor",
    "village_name_malayalam": "കുറ്റൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 745,
    "village_name": "Koovappady",
    "village_name_malayalam": "കൂവപ്പടി",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 746,
    "village_name": "Koovappally",
    "village_name_malayalam": "കൂവപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 70
  },
  {
    "id": 747,
    "village_name": "Koovery",
    "village_name_malayalam": "കൂവേരി",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 748,
    "village_name": "Kuzhalmandam 2",
    "village_name_malayalam": "കുഴൽമന്ദം 2",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 749,
    "village_name": "Kuzhalmandam 1",
    "village_name_malayalam": "കുഴൽമന്ദം 1",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 750,
    "village_name": "Kuzhimanna",
    "village_name_malayalam": "കുഴിമണ്ണ",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 751,
    "village_name": "Kuzhuppilly",
    "village_name_malayalam": "കുഴുപ്പിള്ളി",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 752,
    "village_name": "Kuzhupilly Bit1",
    "village_name_malayalam": "കുഴുപ്പിള്ളി ബിറ്റ്1",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 753,
    "village_name": "Lakkadiperoor 1",
    "village_name_malayalam": "ലക്കടിപേരൂർ 1",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 754,
    "village_name": "Lakkadiperoor 2",
    "village_name_malayalam": "ലക്കടിപേരൂർ 2",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 755,
    "village_name": "Lalam",
    "village_name_malayalam": "ലാലം",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 756,
    "village_name": "Lokamaleswaram",
    "village_name_malayalam": "ലോകമലേശ്വരം",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 757,
    "village_name": "Madakkathara",
    "village_name_malayalam": "മടക്കത്തറ",
    "is_notified": "True",
    "taluka_id": 2
  },
  {
    "id": 758,
    "village_name": "Madappally",
    "village_name_malayalam": "മടപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 759,
    "village_name": "Madathumpady",
    "village_name_malayalam": "മാടത്തുംപടി",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 760,
    "village_name": "Madavur",
    "village_name_malayalam": "മടവൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 761,
    "village_name": "Madavoor",
    "village_name_malayalam": "മടവൂർ",
    "is_notified": "False",
    "taluka_id": 58
  },
  {
    "id": 762,
    "village_name": "Madayi",
    "village_name_malayalam": "മാടായി",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 763,
    "village_name": "Madhur",
    "village_name_malayalam": "മധുര",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 764,
    "village_name": "Madikkai",
    "village_name_malayalam": "മടിക്കൈ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 765,
    "village_name": "Mylom",
    "village_name_malayalam": "മൈലോം",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 766,
    "village_name": "Mynagappally",
    "village_name_malayalam": "മൈനാഗപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 75
  },
  {
    "id": 767,
    "village_name": "Majibayal",
    "village_name_malayalam": "മജിബയൽ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 768,
    "village_name": "Makreri",
    "village_name_malayalam": "മക്രേരി",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 769,
    "village_name": "Malampuzha-I",
    "village_name_malayalam": "മലമ്പുഴ-ഐ",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 770,
    "village_name": "Malampuzha-II",
    "village_name_malayalam": "മലമ്പുഴ-II",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 771,
    "village_name": "Malappattam",
    "village_name_malayalam": "മലപ്പട്ടം",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 772,
    "village_name": "Malappuram",
    "village_name_malayalam": "മലപ്പുറം",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 773,
    "village_name": "Malayalapuzha",
    "village_name_malayalam": "മലയാലപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 55
  },
  {
    "id": 774,
    "village_name": "Malayattoor",
    "village_name_malayalam": "മലയാറ്റൂർ",
    "is_notified": "True",
    "taluka_id": 27
  },
  {
    "id": 775,
    "village_name": "Malayinkeezh",
    "village_name_malayalam": "മലയിൻകീഴ്",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 776,
    "village_name": "Mallapally",
    "village_name_malayalam": "മല്ലപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 45
  },
  {
    "id": 777,
    "village_name": "Mallapuzhasserry",
    "village_name_malayalam": "മല്ലപ്പുഴശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 50
  },
  {
    "id": 778,
    "village_name": "Malmuri",
    "village_name_malayalam": "മാൽമുറി",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 779,
    "village_name": "Maloth",
    "village_name_malayalam": "മാലോത്ത്",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 780,
    "village_name": "Mampad",
    "village_name_malayalam": "മമ്പാട്",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 781,
    "village_name": "Manakkad",
    "village_name_malayalam": "മണക്കാട്",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 782,
    "village_name": "Manacaud",
    "village_name_malayalam": "മണക്കാട്",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 783,
    "village_name": "Manakkodi",
    "village_name_malayalam": "മനക്കൊടി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 784,
    "village_name": "Manakunnam",
    "village_name_malayalam": "മണകുന്നം",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 785,
    "village_name": "Manalithara",
    "village_name_malayalam": "മണലിത്തറ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 786,
    "village_name": "Manalur",
    "village_name_malayalam": "മണലൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 787,
    "village_name": "Manamboor",
    "village_name_malayalam": "മണമ്പൂർ",
    "is_notified": "False",
    "taluka_id": 58
  },
  {
    "id": 788,
    "village_name": "Manantheri",
    "village_name_malayalam": "മാനന്തേരി",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 789,
    "village_name": "Mananthavady",
    "village_name_malayalam": "മാനന്തവാടി",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 790,
    "village_name": "Manarcadu",
    "village_name_malayalam": "മണർകാട്",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 791,
    "village_name": "Manathala",
    "village_name_malayalam": "മണത്തല",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 792,
    "village_name": "Manathana",
    "village_name_malayalam": "മണത്തണ",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 793,
    "village_name": "Manavalassery",
    "village_name_malayalam": "മണവാളശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 794,
    "village_name": "Mangad",
    "village_name_malayalam": "മങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 795,
    "village_name": "Mangad",
    "village_name_malayalam": "മങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 796,
    "village_name": "Mangalam",
    "village_name_malayalam": "മംഗളം",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 797,
    "village_name": "Mangalamdam",
    "village_name_malayalam": "മംഗലംഡാം",
    "is_notified": "True",
    "taluka_id": 23
  },
  {
    "id": 798,
    "village_name": "Mangalpady",
    "village_name_malayalam": "മംഗൽപാടി",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 799,
    "village_name": "Mangattidam",
    "village_name_malayalam": "മാങ്ങാട്ടിടം",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 800,
    "village_name": "Mankode",
    "village_name_malayalam": "മാങ്കോട്",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 801,
    "village_name": "Mankulam",
    "village_name_malayalam": "മാങ്കുളം",
    "is_notified": "True",
    "taluka_id": 37
  },
  {
    "id": 802,
    "village_name": "Maneed",
    "village_name_malayalam": "മനീദ്",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 803,
    "village_name": "Manikkal",
    "village_name_malayalam": "മാണിക്കൽ",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 804,
    "village_name": "Manimala",
    "village_name_malayalam": "മണിമല",
    "is_notified": "False",
    "taluka_id": 70
  },
  {
    "id": 805,
    "village_name": "Maniyat",
    "village_name_malayalam": "മാണിയാട്ട്",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 806,
    "village_name": "Maniyoor",
    "village_name_malayalam": "മണിയൂർ",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 807,
    "village_name": "Maniyur",
    "village_name_malayalam": "മണിയൂർ",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 808,
    "village_name": "Manjalloor",
    "village_name_malayalam": "മഞ്ഞള്ളൂർ",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 809,
    "village_name": "Manchumala",
    "village_name_malayalam": "മഞ്ചുമല",
    "is_notified": "False",
    "taluka_id": 38
  },
  {
    "id": 810,
    "village_name": "Manjapra",
    "village_name_malayalam": "മഞ്ഞപ്ര",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 811,
    "village_name": "Manjeri",
    "village_name_malayalam": "മഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 812,
    "village_name": "Bangramanjeshwar",
    "village_name_malayalam": "ബംഗ്‌രാമഞ്ചേശ്വരം",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 813,
    "village_name": "Manjoor",
    "village_name_malayalam": "മഞ്ചൂർ",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 814,
    "village_name": "Mankada",
    "village_name_malayalam": "മങ്കട",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 815,
    "village_name": "Mankara",
    "village_name_malayalam": "മങ്കര",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 816,
    "village_name": "Mannamangalam",
    "village_name_malayalam": "മണ്ണമംഗലം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 817,
    "village_name": "Mannancherry",
    "village_name_malayalam": "മണ്ണഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 818,
    "village_name": "Mannamkandam",
    "village_name_malayalam": "മണ്ണാംകണ്ടം",
    "is_notified": "False",
    "taluka_id": 37
  },
  {
    "id": 819,
    "village_name": "Mannar",
    "village_name_malayalam": "മാന്നാർ",
    "is_notified": "False",
    "taluka_id": 14
  },
  {
    "id": 820,
    "village_name": "Mannarkkad",
    "village_name_malayalam": "മണ്ണാർക്കാട്",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 821,
    "village_name": "Mannoorkkara",
    "village_name_malayalam": "മണ്ണൂർക്കര",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 822,
    "village_name": "Mannur",
    "village_name_malayalam": "മണ്ണൂർ",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 823,
    "village_name": "Marady",
    "village_name_malayalam": "മാറാടി",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 824,
    "village_name": "Maradu",
    "village_name_malayalam": "മരട്",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 825,
    "village_name": "Marakkara",
    "village_name_malayalam": "മാറാക്കര",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 826,
    "village_name": "Marampilly",
    "village_name_malayalam": "മാറമ്പിള്ളി",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 827,
    "village_name": "Maranallur",
    "village_name_malayalam": "മാറനല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 828,
    "village_name": "Marancheri",
    "village_name_malayalam": "മാറഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 20
  },
  {
    "id": 829,
    "village_name": "Mararikulam North",
    "village_name_malayalam": "മാരാരിക്കുളം നോർത്ത്",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 830,
    "village_name": "Marathakkara",
    "village_name_malayalam": "മരത്താക്കര",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 831,
    "village_name": "Marayoor",
    "village_name_malayalam": "മറയൂർ",
    "is_notified": "True",
    "taluka_id": 37
  },
  {
    "id": 832,
    "village_name": "Maruthuroad",
    "village_name_malayalam": "മരുതുറോഡ്",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 833,
    "village_name": "Maruthonkara",
    "village_name_malayalam": "മരുതോങ്കര",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 834,
    "village_name": "Madayikkonam",
    "village_name_malayalam": "മാടായിക്കോണം",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 835,
    "village_name": "Mattancherry",
    "village_name_malayalam": "മട്ടാഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 836,
    "village_name": "Mattathur",
    "village_name_malayalam": "മറ്റത്തൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 837,
    "village_name": "Mattool",
    "village_name_malayalam": "മാട്ടൂൽ",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 838,
    "village_name": "Mattoor",
    "village_name_malayalam": "മറ്റൂർ",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 839,
    "village_name": "Mathur-1",
    "village_name_malayalam": "മാത്തൂർ-1",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 840,
    "village_name": "Mathur-2",
    "village_name_malayalam": "മാത്തൂർ-2",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 841,
    "village_name": "Mavelikkara",
    "village_name_malayalam": "മാവേലിക്കര",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 842,
    "village_name": "Mavilayi",
    "village_name_malayalam": "മാവിലായി",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 843,
    "village_name": "Mavoor",
    "village_name_malayalam": "മാവൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 844,
    "village_name": "Maayannur",
    "village_name_malayalam": "മായന്നൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 845,
    "village_name": "Mayyanad",
    "village_name_malayalam": "മയ്യനാട്",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 846,
    "village_name": "Mayyil",
    "village_name_malayalam": "മയ്യിൽ",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 847,
    "village_name": "Mazhuvannoor",
    "village_name_malayalam": "മഴുവന്നൂർ",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 848,
    "village_name": "Meenachil",
    "village_name_malayalam": "മീനച്ചിൽ",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 849,
    "village_name": "Meenad",
    "village_name_malayalam": "മീനാട്",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 850,
    "village_name": "Meenadom",
    "village_name_malayalam": "മീനടം",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 851,
    "village_name": "Meenja",
    "village_name_malayalam": "മീഞ്ച",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 852,
    "village_name": "Melarcode",
    "village_name_malayalam": "മേലാർകോഡ്",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 853,
    "village_name": "Melattur",
    "village_name_malayalam": "മേലാറ്റൂർ",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 854,
    "village_name": "Melthonnakkal",
    "village_name_malayalam": "മേൽതോന്നക്കൽ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 855,
    "village_name": "Melila",
    "village_name_malayalam": "മെലീല",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 856,
    "village_name": "Melmuri",
    "village_name_malayalam": "മേൽമുറി",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 857,
    "village_name": "Melukavu",
    "village_name_malayalam": "മേലുകാവ്",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 858,
    "village_name": "Melur",
    "village_name_malayalam": "മേലൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 859,
    "village_name": "Menhanyam",
    "village_name_malayalam": "മെൻഹന്യം",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 860,
    "village_name": "Memmury",
    "village_name_malayalam": "മെമ്മൂറി",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 861,
    "village_name": "Meppayyur",
    "village_name_malayalam": "മേപ്പയ്യൂർ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 862,
    "village_name": "Methala",
    "village_name_malayalam": "മേത്തല",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 863,
    "village_name": "Mezhuveli",
    "village_name_malayalam": "മെഴുവേലി",
    "is_notified": "False",
    "taluka_id": 50
  },
  {
    "id": 864,
    "village_name": "Minalur",
    "village_name_malayalam": "മിണാലൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 865,
    "village_name": "Mlappara",
    "village_name_malayalam": "മ്ലാപ്പാറ",
    "is_notified": "False",
    "taluka_id": 38
  },
  {
    "id": 866,
    "village_name": "Mogral",
    "village_name_malayalam": "മൊഗ്രാൽ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 867,
    "village_name": "Monippally",
    "village_name_malayalam": "മോനിപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 868,
    "village_name": "Morayur",
    "village_name_malayalam": "മൊറയൂർ",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 869,
    "village_name": "Morazha",
    "village_name_malayalam": "മൊറാഴ",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 870,
    "village_name": "Moodadi",
    "village_name_malayalam": "മൂടാടി",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 871,
    "village_name": "Moodambayal",
    "village_name_malayalam": "മൂടമ്പയൽ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 872,
    "village_name": "Mugu",
    "village_name_malayalam": "മുഗു",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 873,
    "village_name": "Mookkannoor",
    "village_name_malayalam": "മൂക്കന്നൂർ",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 874,
    "village_name": "Mulakkuzha",
    "village_name_malayalam": "മുളക്കുഴ",
    "is_notified": "False",
    "taluka_id": 14
  },
  {
    "id": 875,
    "village_name": "Mulakkulam",
    "village_name_malayalam": "മുളക്കുളം",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 876,
    "village_name": "Mulamthuruthy",
    "village_name_malayalam": "മുളംതുരുത്തി",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 877,
    "village_name": "Moolathara",
    "village_name_malayalam": "മൂലത്തറ",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 878,
    "village_name": "Mulavana",
    "village_name_malayalam": "മുളവന",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 879,
    "village_name": "Mulavukad",
    "village_name_malayalam": "മുളവുകാട്",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 880,
    "village_name": "Mulavoor",
    "village_name_malayalam": "മുളവൂർ",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 881,
    "village_name": "Mulayam",
    "village_name_malayalam": "മുലായം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 882,
    "village_name": "Muliyar",
    "village_name_malayalam": "മുളിയാർ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 883,
    "village_name": "Mullackal",
    "village_name_malayalam": "മുല്ലക്കൽ",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 884,
    "village_name": "Mullassery Annakara",
    "village_name_malayalam": "മുല്ലശ്ശേരി അന്നകര",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 885,
    "village_name": "Mullurkara",
    "village_name_malayalam": "മുള്ളൂർക്കര",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 886,
    "village_name": "Mundakkal",
    "village_name_malayalam": "മുണ്ടയ്ക്കൽ",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 887,
    "village_name": "Mundakkayam",
    "village_name_malayalam": "മുണ്ടക്കയം",
    "is_notified": "False",
    "taluka_id": 70
  },
  {
    "id": 888,
    "village_name": "Mundathikode",
    "village_name_malayalam": "മുണ്ടത്തിക്കോട്",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 889,
    "village_name": "Munderi",
    "village_name_malayalam": "മുണ്ടേരി",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 890,
    "village_name": "Mundur 1",
    "village_name_malayalam": "മുണ്ടൂർ 1",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 891,
    "village_name": "Mundur 2",
    "village_name_malayalam": "മുണ്ടൂർ 2",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 892,
    "village_name": "Munnad",
    "village_name_malayalam": "മുന്നാട്",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 893,
    "village_name": "Moonnilavu",
    "village_name_malayalam": "മൂന്നിലാവ്",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 894,
    "village_name": "Moonniyur",
    "village_name_malayalam": "മൂണ്ണിയൂർ",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 895,
    "village_name": "Mandrothuruth",
    "village_name_malayalam": "മൺട്രോതുരുത്ത്",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 896,
    "village_name": "Muppainad",
    "village_name_malayalam": "മുപ്പൈനാട്",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 897,
    "village_name": "Muppiliyam",
    "village_name_malayalam": "മുപ്പിലിയം",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 898,
    "village_name": "Muringoor Thekkummuri",
    "village_name_malayalam": "മുരിങ്ങൂർ തെക്കുംമുറി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 899,
    "village_name": "Muringoor Vadakkummuri",
    "village_name_malayalam": "മുരിങ്ങൂർ വടക്കുംമുറി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 900,
    "village_name": "Muriyad",
    "village_name_malayalam": "മുരിയാട്",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 901,
    "village_name": "Moorkkanad",
    "village_name_malayalam": "മൂർക്കനാട്",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 902,
    "village_name": "Muthalamada-I",
    "village_name_malayalam": "മുതലമട-ഐ",
    "is_notified": "True",
    "taluka_id": 56
  },
  {
    "id": 903,
    "village_name": "Muthalamada-II",
    "village_name_malayalam": "മുതലമട-II",
    "is_notified": "True",
    "taluka_id": 56
  },
  {
    "id": 904,
    "village_name": "Muthuthala",
    "village_name_malayalam": "മുതുതല",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 905,
    "village_name": "Muthuvallur",
    "village_name_malayalam": "മുതുവല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 906,
    "village_name": "Moothakunnam",
    "village_name_malayalam": "മൂത്തകുന്നം",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 907,
    "village_name": "Muttom",
    "village_name_malayalam": "മുട്ടം",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 908,
    "village_name": "Muttar",
    "village_name_malayalam": "മുട്ടാർ",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 909,
    "village_name": "Muttathodi",
    "village_name_malayalam": "മുട്ടത്തൊടി",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 910,
    "village_name": "Muttathara",
    "village_name_malayalam": "മുട്ടത്തറ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 911,
    "village_name": "Muttatupara",
    "village_name_malayalam": "മുട്ടറ്റുപാറ",
    "is_notified": "False",
    "taluka_id": 73
  },
  {
    "id": 912,
    "village_name": "Muttil North",
    "village_name_malayalam": "മുട്ടിൽ വടക്ക്",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 913,
    "village_name": "Muttil South",
    "village_name_malayalam": "മുട്ടിൽ തെക്ക്",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 914,
    "village_name": "Muttuchira",
    "village_name_malayalam": "മുട്ടുചിറ",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 915,
    "village_name": "Muthukulam",
    "village_name_malayalam": "മുതുകുളം",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 916,
    "village_name": "Muvattupuzha",
    "village_name_malayalam": "മൂവാറ്റുപുഴ",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 917,
    "village_name": "Muzhakkunnu",
    "village_name_malayalam": "മുഴക്കുന്ന്",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 918,
    "village_name": "Muzhappilangad",
    "village_name_malayalam": "മുഴപ്പിലങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 919,
    "village_name": "Mylapra",
    "village_name_malayalam": "മൈലപ്ര",
    "is_notified": "False",
    "taluka_id": 55
  },
  {
    "id": 920,
    "village_name": "Nadakkuthazha",
    "village_name_malayalam": "നടക്കുതാഴ",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 921,
    "village_name": "Nadama",
    "village_name_malayalam": "നദാമ",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 922,
    "village_name": "Nadapuram",
    "village_name_malayalam": "നാദാപുരം",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 923,
    "village_name": "Nadathara",
    "village_name_malayalam": "നടത്തറ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 924,
    "village_name": "Nadavayal",
    "village_name_malayalam": "നടവയൽ",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 925,
    "village_name": "Naduvannur",
    "village_name_malayalam": "നടുവണ്ണൂർ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 926,
    "village_name": "Naduvattom",
    "village_name_malayalam": "നടുവട്ടം",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 927,
    "village_name": "New Naduvil",
    "village_name_malayalam": "പുതിയ നടുവിൽ",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 928,
    "village_name": "Naduvile",
    "village_name_malayalam": "നടുവിലെ",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 929,
    "village_name": "Nagalasserry",
    "village_name_malayalam": "നാഗലശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 930,
    "village_name": "Nagaram",
    "village_name_malayalam": "നഗരം",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 931,
    "village_name": "Nagaroor",
    "village_name_malayalam": "നഗരൂർ",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 932,
    "village_name": "Nellanad",
    "village_name_malayalam": "നെല്ലനാട്",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 933,
    "village_name": "Nalleppilly",
    "village_name_malayalam": "നല്ലേപ്പിള്ളി",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 934,
    "village_name": "Nallurnad",
    "village_name_malayalam": "നല്ലൂർനാട്",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 935,
    "village_name": "Nandipulam",
    "village_name_malayalam": "നന്ദിപുലം",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 936,
    "village_name": "Nannambra",
    "village_name_malayalam": "നന്നമ്പ്ര",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 937,
    "village_name": "Nannamukku",
    "village_name_malayalam": "നന്നംമുക്ക്",
    "is_notified": "False",
    "taluka_id": 20
  },
  {
    "id": 938,
    "village_name": "Naranganam",
    "village_name_malayalam": "നാരങ്ങാനം",
    "is_notified": "False",
    "taluka_id": 50
  },
  {
    "id": 939,
    "village_name": "Narath",
    "village_name_malayalam": "നാരത്ത്",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 940,
    "village_name": "Narikkuni",
    "village_name_malayalam": "നരിക്കുനി",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 941,
    "village_name": "Narippatta",
    "village_name_malayalam": "നരിപ്പറ്റ",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 942,
    "village_name": "Narukara",
    "village_name_malayalam": "നറുകര",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 943,
    "village_name": "Nattakom",
    "village_name_malayalam": "നാട്ടകം",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 944,
    "village_name": "Nattika",
    "village_name_malayalam": "നാട്ടിക",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 945,
    "village_name": "Navaikulam",
    "village_name_malayalam": "നാവായിക്കുളം",
    "is_notified": "False",
    "taluka_id": 58
  },
  {
    "id": 946,
    "village_name": "Nayarambalam",
    "village_name_malayalam": "നായരമ്പലം",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 947,
    "village_name": "Neerchal",
    "village_name_malayalam": "നീർച്ചാൽ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 948,
    "village_name": "Nediyiruppu",
    "village_name_malayalam": "നെടിയിരുപ്പ്",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 949,
    "village_name": "Nedumangad",
    "village_name_malayalam": "നെടുമങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 950,
    "village_name": "Nedumbassery",
    "village_name_malayalam": "നെടുമ്പാശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 951,
    "village_name": "Nedumkunnam",
    "village_name_malayalam": "നെടുംകുന്നം",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 952,
    "village_name": "Nedumpana",
    "village_name_malayalam": "നെടുമ്പന",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 953,
    "village_name": "Nedumpura",
    "village_name_malayalam": "നെടുമ്പുര",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 954,
    "village_name": "Nedumpram",
    "village_name_malayalam": "നെടുമ്പ്രം",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 955,
    "village_name": "Nedumudy",
    "village_name_malayalam": "നെടുമുടി",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 956,
    "village_name": "Neduvathur",
    "village_name_malayalam": "നെടുവത്തൂർ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 957,
    "village_name": "Neelamperur",
    "village_name_malayalam": "നീലംപേരൂർ",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 958,
    "village_name": "Neeleswaram",
    "village_name_malayalam": "നീലേശ്വരം",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 959,
    "village_name": "Njeezhoor",
    "village_name_malayalam": "ഞീഴൂർ",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 960,
    "village_name": "Nekraje",
    "village_name_malayalam": "നെക്രാജെ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 961,
    "village_name": "Nellaya",
    "village_name_malayalam": "നെല്ലായ",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 962,
    "village_name": "Nellayi",
    "village_name_malayalam": "നെല്ലായി",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 963,
    "village_name": "Nellikode",
    "village_name_malayalam": "നെല്ലിക്കോട്",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 964,
    "village_name": "Nellipoyil",
    "village_name_malayalam": "നെല്ലിപ്പൊയിൽ",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 965,
    "village_name": "Nelliyampathy",
    "village_name_malayalam": "നെല്ലിയാമ്പതി",
    "is_notified": "True",
    "taluka_id": 56
  },
  {
    "id": 966,
    "village_name": "Nelluvai",
    "village_name_malayalam": "നെല്ലുവായ്",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 967,
    "village_name": "Nemom",
    "village_name_malayalam": "നേമം",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 968,
    "village_name": "Nenmara",
    "village_name_malayalam": "നെന്മാറ",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 969,
    "village_name": "Nenmini",
    "village_name_malayalam": "നെൻമിനി",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 970,
    "village_name": "Nanminda",
    "village_name_malayalam": "നന്മിൻദാ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 971,
    "village_name": "Nenmanikkara",
    "village_name_malayalam": "നെന്മണിക്കര",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 972,
    "village_name": "Nenmeni",
    "village_name_malayalam": "നെന്മേനി",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 973,
    "village_name": "Neriamangalam",
    "village_name_malayalam": "നേര്യമംഗലം",
    "is_notified": "True",
    "taluka_id": 73
  },
  {
    "id": 974,
    "village_name": "Nettanige",
    "village_name_malayalam": "നെട്ടനിഗെ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 975,
    "village_name": "Nettanige II",
    "village_name_malayalam": "നെട്ടനിഗെ II",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 976,
    "village_name": "Nettissery",
    "village_name_malayalam": "നെട്ടിശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 977,
    "village_name": "Neduva",
    "village_name_malayalam": "നെടുവ",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 978,
    "village_name": "Neyyasserry",
    "village_name_malayalam": "നെയ്യശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 979,
    "village_name": "Neyyattinkara",
    "village_name_malayalam": "നെയ്യാറ്റിൻകര",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 980,
    "village_name": "Nidiyenga",
    "village_name_malayalam": "നിടിയേങ്ക",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 981,
    "village_name": "Nilambur",
    "village_name_malayalam": "നിലമ്പൂർ",
    "is_notified": "True",
    "taluka_id": 11
  },
  {
    "id": 982,
    "village_name": "Nilamel",
    "village_name_malayalam": "നിലമേൽ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 983,
    "village_name": "Nileswaram",
    "village_name_malayalam": "നീലേശ്വരം",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 984,
    "village_name": "Niramaruthur",
    "village_name_malayalam": "നിറമരുതൂർ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 985,
    "village_name": "Niranam",
    "village_name_malayalam": "നിരണം",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 986,
    "village_name": "Njarackal",
    "village_name_malayalam": "ഞാറക്കൽ",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 987,
    "village_name": "Nochad",
    "village_name_malayalam": "നൊച്ചാദ്",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 988,
    "village_name": "Nooranad",
    "village_name_malayalam": "നൂറനാട്",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 989,
    "village_name": "Nuchiad",
    "village_name_malayalam": "നുചിഅദ്",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 990,
    "village_name": "Noolpuzha",
    "village_name_malayalam": "നൂൽപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 991,
    "village_name": "Ochira",
    "village_name_malayalam": "ഓച്ചിറ",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 992,
    "village_name": "Odanavattom",
    "village_name_malayalam": "ഓടനാവട്ടം",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 993,
    "village_name": "Olavanna",
    "village_name_malayalam": "ഒളവണ്ണ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 994,
    "village_name": "Olavattur",
    "village_name_malayalam": "ഒളവട്ടൂർ",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 995,
    "village_name": "Ollukkara",
    "village_name_malayalam": "ഒല്ലൂക്കര",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 996,
    "village_name": "Ollur",
    "village_name_malayalam": "ഒല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 997,
    "village_name": "Omallur",
    "village_name_malayalam": "ഓമല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 50
  },
  {
    "id": 998,
    "village_name": "Onakkoor",
    "village_name_malayalam": "ഓണക്കൂർ",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 999,
    "village_name": "Onamthuruth",
    "village_name_malayalam": "ഓണംതുരുത്ത്",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 1000,
    "village_name": "Onchiyam",
    "village_name_malayalam": "ഒഞ്ചിയം",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1001,
    "village_name": "Ongallur 1",
    "village_name_malayalam": "ഓങ്ങല്ലൂർ 1",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 1002,
    "village_name": "Ongallur 2",
    "village_name_malayalam": "ഓങ്ങല്ലൂർ 2",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 1003,
    "village_name": "Orumanayoor",
    "village_name_malayalam": "ഒരുമനയൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1004,
    "village_name": "Othukungal",
    "village_name_malayalam": "ഒതുക്കുങ്ങൽ",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 1005,
    "village_name": "Ottappalam",
    "village_name_malayalam": "ഒറ്റപ്പാലം",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 1006,
    "village_name": "Ottappalam-I",
    "village_name_malayalam": "ഒറ്റപ്പാലം-ഐ",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 1007,
    "village_name": "Ottappalam-II",
    "village_name_malayalam": "ഒറ്റപ്പാലം-രണ്ട്",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 1008,
    "village_name": "Ottasekharamangalam",
    "village_name_malayalam": "ഒറ്റശേഖരമംഗലം",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 1009,
    "village_name": "Ottoor",
    "village_name_malayalam": "ഒറ്റൂർ",
    "is_notified": "False",
    "taluka_id": 58
  },
  {
    "id": 1010,
    "village_name": "Ozhalapathy",
    "village_name_malayalam": "ഒഴലപ്പതി",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1011,
    "village_name": "Ozhur",
    "village_name_malayalam": "ഒഴൂർ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1012,
    "village_name": "Padne",
    "village_name_malayalam": "പദ്നെ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1013,
    "village_name": "Padavayal",
    "village_name_malayalam": "പടവയൽ",
    "is_notified": "True",
    "taluka_id": 8
  },
  {
    "id": 1014,
    "village_name": "Pathaikkara",
    "village_name_malayalam": "പാതായ്ക്കര",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 1015,
    "village_name": "Padi Group",
    "village_name_malayalam": "പാഡി ഗ്രൂപ്പ്",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 1016,
    "village_name": "Padichira",
    "village_name_malayalam": "പാടിച്ചിറ",
    "is_notified": "True",
    "taluka_id": 29
  },
  {
    "id": 1017,
    "village_name": "Padinjharathara",
    "village_name_malayalam": "പടിഞ്ഞാറത്തറ",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 1018,
    "village_name": "Padinjare Chalakudi",
    "village_name_malayalam": "പടിഞ്ഞാറെ ചാലക്കുടി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1019,
    "village_name": "Padinjare Vemballur",
    "village_name_malayalam": "പടിഞ്ഞാറെ വെമ്പല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1020,
    "village_name": "Pathiriyad",
    "village_name_malayalam": "പാതിരിയാട്",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1021,
    "village_name": "Padiyam",
    "village_name_malayalam": "പടിയം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1022,
    "village_name": "Padiyoor",
    "village_name_malayalam": "പടിയൂർ",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 1023,
    "village_name": "Padiyoor",
    "village_name_malayalam": "പടിയൂർ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1024,
    "village_name": "Padre",
    "village_name_malayalam": "പാദ്രെ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1025,
    "village_name": "Pathur",
    "village_name_malayalam": "പാത്തൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1026,
    "village_name": "Paduvilayi",
    "village_name_malayalam": "പടുവിലായി",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1027,
    "village_name": "Paimkulam",
    "village_name_malayalam": "പൈംകുളം",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1028,
    "village_name": "Paivalike",
    "village_name_malayalam": "പൈവളികെ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1029,
    "village_name": "Paivalike II",
    "village_name_malayalam": "പൈവളികെ II",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1030,
    "village_name": "Palakkad",
    "village_name_malayalam": "പാലക്കാട്",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1031,
    "village_name": "Palakkayam",
    "village_name_malayalam": "പാലക്കയം",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 1032,
    "village_name": "Palakuzha",
    "village_name_malayalam": "പാലക്കുഴ",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 1033,
    "village_name": "Palamel",
    "village_name_malayalam": "പാലമേൽ",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 1034,
    "village_name": "Palavayal",
    "village_name_malayalam": "പാലാവയൽ",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 1035,
    "village_name": "Palayad",
    "village_name_malayalam": "പാലയാട്",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1036,
    "village_name": "Paleri",
    "village_name_malayalam": "പാലേരി",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 1037,
    "village_name": "Palissery",
    "village_name_malayalam": "പാലിശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1038,
    "village_name": "Pallasaana",
    "village_name_malayalam": "പല്ലസാന",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1039,
    "village_name": "Pallichal",
    "village_name_malayalam": "പള്ളിച്ചൽ",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 1040,
    "village_name": "Pallikkal",
    "village_name_malayalam": "പള്ളിക്കൽ",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 1041,
    "village_name": "Pallickal",
    "village_name_malayalam": "പള്ളിക്കൽ",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 1042,
    "village_name": "Pallikkal",
    "village_name_malayalam": "പള്ളിക്കൽ",
    "is_notified": "False",
    "taluka_id": 58
  },
  {
    "id": 1043,
    "village_name": "Pallikkara-I",
    "village_name_malayalam": "പള്ളിക്കര-ഐ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1044,
    "village_name": "Pallikkara-II",
    "village_name_malayalam": "പള്ളിക്കര-രണ്ടാം",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1045,
    "village_name": "Pallikkunnu",
    "village_name_malayalam": "പള്ളിക്കുന്ന്",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 1046,
    "village_name": "Pallimon",
    "village_name_malayalam": "പള്ളിമൺ",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 1047,
    "village_name": "Pallippad",
    "village_name_malayalam": "പള്ളിപ്പാട്",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 1048,
    "village_name": "Pallippuram",
    "village_name_malayalam": "പള്ളിപ്പുറം",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 1049,
    "village_name": "Pallippuram",
    "village_name_malayalam": "പള്ളിപ്പുറം",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 1050,
    "village_name": "Pallipuram",
    "village_name_malayalam": "പള്ളിപ്പുറം",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1051,
    "village_name": "Pallipuram",
    "village_name_malayalam": "പള്ളിപ്പുറം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1052,
    "village_name": "Pallivasal",
    "village_name_malayalam": "പള്ളിവാസൽ",
    "is_notified": "True",
    "taluka_id": 37
  },
  {
    "id": 1053,
    "village_name": "Palluruthy",
    "village_name_malayalam": "പള്ളുരുത്തി",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 1054,
    "village_name": "Palode",
    "village_name_malayalam": "പാലോട്",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1055,
    "village_name": "Pallur",
    "village_name_malayalam": "പള്ളൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1056,
    "village_name": "Pampady",
    "village_name_malayalam": "പാമ്പാടി",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 1057,
    "village_name": "Pampadumpara",
    "village_name_malayalam": "പാമ്പാടുംപാറ",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 1058,
    "village_name": "Pampady",
    "village_name_malayalam": "പാമ്പാടി",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1059,
    "village_name": "Panachikkadu",
    "village_name_malayalam": "പനച്ചിക്കാട്",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 1060,
    "village_name": "Panakkad",
    "village_name_malayalam": "പാണക്കാട്",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 1061,
    "village_name": "Panamaram",
    "village_name_malayalam": "പനമരം",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 1062,
    "village_name": "Pananchery",
    "village_name_malayalam": "പാണഞ്ചേരി",
    "is_notified": "True",
    "taluka_id": 2
  },
  {
    "id": 1063,
    "village_name": "Panangad",
    "village_name_malayalam": "പനങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 1064,
    "village_name": "Panangad",
    "village_name_malayalam": "പനങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1065,
    "village_name": "Panappuzha",
    "village_name_malayalam": "പാണപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 1066,
    "village_name": "Panathady",
    "village_name_malayalam": "പനത്തടി",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 1067,
    "village_name": "Panavally",
    "village_name_malayalam": "പാണാവള്ളി",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 1068,
    "village_name": "Panavoor",
    "village_name_malayalam": "പനവൂർ",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1069,
    "village_name": "Panayam",
    "village_name_malayalam": "പനയം",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 1070,
    "village_name": "Pandalam",
    "village_name_malayalam": "പന്തളം",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 1071,
    "village_name": "Pandalam Thekkekara",
    "village_name_malayalam": "പന്തളം തെക്കേക്കര",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 1072,
    "village_name": "Pandallur",
    "village_name_malayalam": "പന്തല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 1073,
    "village_name": "Pandanad",
    "village_name_malayalam": "പാണ്ടനാട്",
    "is_notified": "False",
    "taluka_id": 14
  },
  {
    "id": 1074,
    "village_name": "Pandikkad",
    "village_name_malayalam": "പാണ്ടിക്കാട്",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 1075,
    "village_name": "Pangapara",
    "village_name_malayalam": "പാങ്ങപ്പാറ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1076,
    "village_name": "Pangarappilly",
    "village_name_malayalam": "പങ്ങാരപ്പിള്ളി",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1077,
    "village_name": "Pangode",
    "village_name_malayalam": "പാങ്ങോട്",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1078,
    "village_name": "Panayal",
    "village_name_malayalam": "പനയാൽ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1079,
    "village_name": "Panjal",
    "village_name_malayalam": "പാഞ്ജൽ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1080,
    "village_name": "Panmana",
    "village_name_malayalam": "പന്മന",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 1081,
    "village_name": "Panniyankara",
    "village_name_malayalam": "പന്നിയങ്കര",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 1082,
    "village_name": "Panniyoor",
    "village_name_malayalam": "പന്നിയൂർ",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 1083,
    "village_name": "Panthalayani",
    "village_name_malayalam": "പന്തലായനി",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 1084,
    "village_name": "Pantheerankavu",
    "village_name_malayalam": "പന്തീരാങ്കാവ്",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 1085,
    "village_name": "Panoor",
    "village_name_malayalam": "പാനൂർ",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1086,
    "village_name": "Pappinisseri",
    "village_name_malayalam": "പാപ്പിനിശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 1087,
    "village_name": "Pappinivattom",
    "village_name_malayalam": "പാപ്പിനിവട്ടം",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1088,
    "village_name": "Parakkad",
    "village_name_malayalam": "പാറക്കാട്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1089,
    "village_name": "Parakkadavu",
    "village_name_malayalam": "പാറക്കടവ്",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 1090,
    "village_name": "Parali-I",
    "village_name_malayalam": "പറളി-ഐ",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1091,
    "village_name": "Parali-2",
    "village_name_malayalam": "പറളി-2",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1092,
    "village_name": "Parappa",
    "village_name_malayalam": "പരപ്പ",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 1093,
    "village_name": "Parappanangadi",
    "village_name_malayalam": "പരപ്പനങ്ങാടി",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 1094,
    "village_name": "Parappukara",
    "village_name_malayalam": "പരപ്പുകര",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1095,
    "village_name": "Parappur",
    "village_name_malayalam": "പറപ്പൂർ",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 1096,
    "village_name": "Parassala",
    "village_name_malayalam": "പാറശ്ശാല",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 1097,
    "village_name": "Parasuvaikkal",
    "village_name_malayalam": "പരശുവയ്ക്കൽ",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 1098,
    "village_name": "Parathode",
    "village_name_malayalam": "പാറത്തോട്",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 1099,
    "village_name": "Paravoor",
    "village_name_malayalam": "പറവൂർ",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 1100,
    "village_name": "Paravur",
    "village_name_malayalam": "പറവൂർ",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 1101,
    "village_name": "Paravoor",
    "village_name_malayalam": "പറവൂർ",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 1102,
    "village_name": "Parippally",
    "village_name_malayalam": "പാരിപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 1103,
    "village_name": "Pariyapuram",
    "village_name_malayalam": "പരിയാപുരം",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1104,
    "village_name": "Pariyaram",
    "village_name_malayalam": "പരിയാരം",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 1105,
    "village_name": "Pariyaram",
    "village_name_malayalam": "പരിയാരം",
    "is_notified": "True",
    "taluka_id": 24
  },
  {
    "id": 1106,
    "village_name": "Paralam",
    "village_name_malayalam": "പരളം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1107,
    "village_name": "Parlikad",
    "village_name_malayalam": "പാർളിക്കാട്",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1108,
    "village_name": "Paruthur",
    "village_name_malayalam": "പരുതൂർ",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 1109,
    "village_name": "Pathanapuram",
    "village_name_malayalam": "പത്തനാപുരം",
    "is_notified": "False",
    "taluka_id": 76
  },
  {
    "id": 1110,
    "village_name": "Pathirappally",
    "village_name_malayalam": "പാതിരപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 1111,
    "village_name": "Patla",
    "village_name_malayalam": "പട്‌ല",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 1112,
    "village_name": "Pattom",
    "village_name_malayalam": "പട്ടം",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1113,
    "village_name": "Pattambi",
    "village_name_malayalam": "പട്ടാമ്പി",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 1114,
    "village_name": "Pattanakkad",
    "village_name_malayalam": "പട്ടണക്കാട്",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 1115,
    "village_name": "Pathanamthitta",
    "village_name_malayalam": "പത്തനംതിട്ട",
    "is_notified": "False",
    "taluka_id": 50
  },
  {
    "id": 1116,
    "village_name": "Pattanchery",
    "village_name_malayalam": "പട്ടഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1117,
    "village_name": "Pattanur",
    "village_name_malayalam": "പട്ടാന്നൂർ",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1118,
    "village_name": "Pattazhy",
    "village_name_malayalam": "പട്ടാഴി",
    "is_notified": "False",
    "taluka_id": 76
  },
  {
    "id": 1119,
    "village_name": "Pattazhy Vadakkekkara",
    "village_name_malayalam": "പട്ടാഴി വടക്കേക്കര",
    "is_notified": "False",
    "taluka_id": 76
  },
  {
    "id": 1120,
    "village_name": "Pattimattom",
    "village_name_malayalam": "പട്ടിമറ്റം",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 1121,
    "village_name": "Pattithara",
    "village_name_malayalam": "പട്ടിത്തറ",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 1122,
    "village_name": "Pathiyur",
    "village_name_malayalam": "പത്തിയൂർ",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 1123,
    "village_name": "Pattuvam",
    "village_name_malayalam": "പട്ടുവം",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 1124,
    "village_name": "Pattiam",
    "village_name_malayalam": "പട്ട്യം",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1125,
    "village_name": "Pavaratty",
    "village_name_malayalam": "പാവറട്ടി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1126,
    "village_name": "Pavithreswaram",
    "village_name_malayalam": "പവിത്രേശ്വരം",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 1127,
    "village_name": "Pavumba",
    "village_name_malayalam": "പാവുമ്പ",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 1128,
    "village_name": "Pavoor",
    "village_name_malayalam": "പാവൂർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1129,
    "village_name": "Payam",
    "village_name_malayalam": "പായം",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 1130,
    "village_name": "Paippadu",
    "village_name_malayalam": "പായിപ്പാട്",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 1131,
    "village_name": "Payyampally",
    "village_name_malayalam": "പയ്യമ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 1132,
    "village_name": "Payyanad",
    "village_name_malayalam": "പയ്യനാട്",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 1133,
    "village_name": "Payyanedam",
    "village_name_malayalam": "പയ്യനെടം",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 1134,
    "village_name": "Payyannur",
    "village_name_malayalam": "പയ്യന്നൂർ",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 1135,
    "village_name": "Payyavoor",
    "village_name_malayalam": "പയ്യാവൂർ",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 1136,
    "village_name": "Payyoli",
    "village_name_malayalam": "പയ്യോളി",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 1137,
    "village_name": "Pazhanji",
    "village_name_malayalam": "പഴഞ്ഞി",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 1138,
    "village_name": "Pazhassi",
    "village_name_malayalam": "പഴശ്ശി",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 1139,
    "village_name": "Ranni Pazhavangadi",
    "village_name_malayalam": "റാന്നി പഴവങ്ങാടി",
    "is_notified": "False",
    "taluka_id": 42
  },
  {
    "id": 1140,
    "village_name": "Pazhaveedu",
    "village_name_malayalam": "പഴവീട്",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 1141,
    "village_name": "Pazhayakunnummel",
    "village_name_malayalam": "പഴയകുന്നുമ്മേൽ",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 1142,
    "village_name": "Pazhayannur",
    "village_name_malayalam": "പഴയന്നൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1143,
    "village_name": "Peechi",
    "village_name_malayalam": "പീച്ചി",
    "is_notified": "True",
    "taluka_id": 2
  },
  {
    "id": 1144,
    "village_name": "Peermade",
    "village_name_malayalam": "പീരുമേട്",
    "is_notified": "False",
    "taluka_id": 38
  },
  {
    "id": 1145,
    "village_name": "Perakam",
    "village_name_malayalam": "പേരകം",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1146,
    "village_name": "Perakamanna",
    "village_name_malayalam": "പേരകമണ്ണ",
    "is_notified": "True",
    "taluka_id": 35
  },
  {
    "id": 1147,
    "village_name": "Peralam",
    "village_name_malayalam": "പെരളം",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 1148,
    "village_name": "Peramangalam",
    "village_name_malayalam": "പേരാമംഗലം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1149,
    "village_name": "Perumbala",
    "village_name_malayalam": "പെരുമ്പള",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 1150,
    "village_name": "Perambra",
    "village_name_malayalam": "പേരാമ്പ്ര",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 1151,
    "village_name": "Perambra",
    "village_name_malayalam": "പേരാമ്പ്ര",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1152,
    "village_name": "Perinad",
    "village_name_malayalam": "പെരിനാട്",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 1153,
    "village_name": "Peringammala",
    "village_name_malayalam": "പെരിങ്ങമ്മല",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1154,
    "village_name": "Peringanadu",
    "village_name_malayalam": "പെരിങ്ങനാട്",
    "is_notified": "False",
    "taluka_id": 43
  },
  {
    "id": 1155,
    "village_name": "Peringandoor",
    "village_name_malayalam": "പെരിങ്ങണ്ടൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1156,
    "village_name": "Peringathur",
    "village_name_malayalam": "പെരിങ്ങത്തൂർ",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1157,
    "village_name": "Peringavu",
    "village_name_malayalam": "പെരിങ്ങാവ്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1158,
    "village_name": "Peringom",
    "village_name_malayalam": "പെരിങ്ങോം",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 1159,
    "village_name": "Peringottukurussy-I",
    "village_name_malayalam": "പെരിങ്ങോട്ടുകുറുശ്ശി-ഐ",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1160,
    "village_name": "Peringottukurussy-II",
    "village_name_malayalam": "പെരിങ്ങോട്ടുകുറുശ്ശി-രണ്ടാം",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1161,
    "village_name": "Perinjanam",
    "village_name_malayalam": "പെരിഞ്ഞനം",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1162,
    "village_name": "Perintalmanna",
    "village_name_malayalam": "പെരിന്തൽമണ്ണ",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 1163,
    "village_name": "Perinthatta",
    "village_name_malayalam": "പെരിന്തട്ട",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 1164,
    "village_name": "Periye",
    "village_name_malayalam": "പെരിയേ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1165,
    "village_name": "Peria",
    "village_name_malayalam": "പെരിയ",
    "is_notified": "True",
    "taluka_id": 46
  },
  {
    "id": 1166,
    "village_name": "Periyar",
    "village_name_malayalam": "പെരിയാർ",
    "is_notified": "False",
    "taluka_id": 38
  },
  {
    "id": 1167,
    "village_name": "Perole",
    "village_name_malayalam": "പെറോൾ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1168,
    "village_name": "Perumanna",
    "village_name_malayalam": "പെരുമണ്ണ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 1169,
    "village_name": "Perumanna",
    "village_name_malayalam": "പെരുമണ്ണ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1170,
    "village_name": "Perumatty",
    "village_name_malayalam": "പെരുമാട്ടി",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1171,
    "village_name": "Perumpadappu",
    "village_name_malayalam": "പെരുമ്പടപ്പ്",
    "is_notified": "False",
    "taluka_id": 20
  },
  {
    "id": 1172,
    "village_name": "Perumbalam",
    "village_name_malayalam": "പെരുമ്പളം",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 1173,
    "village_name": "Perumbavoor",
    "village_name_malayalam": "പെരുമ്പാവൂർ",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 1174,
    "village_name": "Perumpazhuthoor",
    "village_name_malayalam": "പെരുമ്പഴുത്തൂർ",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 1175,
    "village_name": "Perumpetty",
    "village_name_malayalam": "പെരുമ്പെട്ടി",
    "is_notified": "False",
    "taluka_id": 45
  },
  {
    "id": 1176,
    "village_name": "Perumkadavila",
    "village_name_malayalam": "പെരുംകടവിള",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 1177,
    "village_name": "Perumkulam",
    "village_name_malayalam": "പെരുംകുളം",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1178,
    "village_name": "Perumbaikkadu",
    "village_name_malayalam": "പെരുമ്പായിക്കാട്",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 1179,
    "village_name": "Perumpilavu",
    "village_name_malayalam": "പെരുമ്പിലാവ്",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 1180,
    "village_name": "Perunad",
    "village_name_malayalam": "പെരുനാട്",
    "is_notified": "False",
    "taluka_id": 42
  },
  {
    "id": 1181,
    "village_name": "Peringara",
    "village_name_malayalam": "പെരിങ്ങര",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 1182,
    "village_name": "Peroor",
    "village_name_malayalam": "പേരൂർ",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 1183,
    "village_name": "Peroorkada",
    "village_name_malayalam": "പേരൂർക്കട",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1184,
    "village_name": "Peruvallur",
    "village_name_malayalam": "പെരുവള്ളൂർ",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 1185,
    "village_name": "Peruvanthanam",
    "village_name_malayalam": "പെരുവന്താനം",
    "is_notified": "False",
    "taluka_id": 38
  },
  {
    "id": 1186,
    "village_name": "Peruvayal",
    "village_name_malayalam": "പെരുവയൽ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 1187,
    "village_name": "Peruvembu",
    "village_name_malayalam": "പെരുവെമ്പ്",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1188,
    "village_name": "Pettah",
    "village_name_malayalam": "പേട്ട",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1189,
    "village_name": "Pidavoor",
    "village_name_malayalam": "പിടവൂർ",
    "is_notified": "False",
    "taluka_id": 76
  },
  {
    "id": 1190,
    "village_name": "Pilakkad",
    "village_name_malayalam": "പിലാക്കാട്",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1191,
    "village_name": "Pilicode",
    "village_name_malayalam": "പിലിക്കോട്",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1192,
    "village_name": "Pinarayi",
    "village_name_malayalam": "പിണറായി",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1193,
    "village_name": "Pindimana",
    "village_name_malayalam": "പിണ്ടിമന",
    "is_notified": "False",
    "taluka_id": 73
  },
  {
    "id": 1194,
    "village_name": "Piravom",
    "village_name_malayalam": "പിറവം",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 1195,
    "village_name": "Piravanthoor",
    "village_name_malayalam": "പിറവന്തൂർ",
    "is_notified": "False",
    "taluka_id": 76
  },
  {
    "id": 1196,
    "village_name": "Piriyari",
    "village_name_malayalam": "പിരിയാരി",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1197,
    "village_name": "Piyayiri",
    "village_name_malayalam": "പിയായിരി",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1198,
    "village_name": "Polpully",
    "village_name_malayalam": "പൊൽപ്പുള്ളി",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1199,
    "village_name": "Ponmala",
    "village_name_malayalam": "പൊന്മള",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1200,
    "village_name": "Ponmundam",
    "village_name_malayalam": "പൊന്മുണ്ടം",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1201,
    "village_name": "Ponnani Nagaram",
    "village_name_malayalam": "പൊന്നാനി നഗരം",
    "is_notified": "False",
    "taluka_id": 20
  },
  {
    "id": 1202,
    "village_name": "Poonithura",
    "village_name_malayalam": "പൂണിത്തുറ",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 1203,
    "village_name": "Pooyappally",
    "village_name_malayalam": "പൂയപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 1204,
    "village_name": "Porathisseri",
    "village_name_malayalam": "പൊറത്തിശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1205,
    "village_name": "Porkulam",
    "village_name_malayalam": "പോർക്കുളം",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 1206,
    "village_name": "Porunnanore",
    "village_name_malayalam": "പൊരുന്നാനൂർ",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 1207,
    "village_name": "Porur",
    "village_name_malayalam": "പോരൂർ",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 1208,
    "village_name": "Poruvazhy",
    "village_name_malayalam": "പോരുവഴി",
    "is_notified": "False",
    "taluka_id": 75
  },
  {
    "id": 1209,
    "village_name": "Potta",
    "village_name_malayalam": "പോട്ട",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1210,
    "village_name": "Pothanikkad",
    "village_name_malayalam": "പോത്താനിക്കാട്",
    "is_notified": "False",
    "taluka_id": 73
  },
  {
    "id": 1211,
    "village_name": "Pottasseri 1",
    "village_name_malayalam": "പൊറ്റശ്ശേരി 1",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 1212,
    "village_name": "Pottasseri 2",
    "village_name_malayalam": "പൊറ്റശ്ശേരി 2",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 1213,
    "village_name": "Pottore",
    "village_name_malayalam": "പോട്ടോറെ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1214,
    "village_name": "Poyya",
    "village_name_malayalam": "പൊയ്യ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1215,
    "village_name": "Pozhuthana",
    "village_name_malayalam": "പൊഴുതന",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 1216,
    "village_name": "Pramadom",
    "village_name_malayalam": "പ്രമാടം",
    "is_notified": "False",
    "taluka_id": 55
  },
  {
    "id": 1217,
    "village_name": "Puthiyangadi",
    "village_name_malayalam": "പുതിയങ്ങാടി",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 1218,
    "village_name": "Puthukkai",
    "village_name_malayalam": "പുതുക്കൈ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1219,
    "village_name": "Pudunagaram",
    "village_name_malayalam": "പുതുനഗരം",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1220,
    "village_name": "Puthuppady",
    "village_name_malayalam": "പുതുപ്പാടി",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 1221,
    "village_name": "Puthuppally",
    "village_name_malayalam": "പുതുപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 1222,
    "village_name": "Puthupariyaram II",
    "village_name_malayalam": "പുതുപരിയാരം II",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1223,
    "village_name": "Puthuppariyaram-I",
    "village_name_malayalam": "പുതുപ്പരിയാരം-ഐ",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1224,
    "village_name": "Puthupariyaram II",
    "village_name_malayalam": "പുതുപരിയാരം II",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1225,
    "village_name": "Pudur",
    "village_name_malayalam": "പുദൂർ",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 1226,
    "village_name": "Pudussery East",
    "village_name_malayalam": "പുതുശ്ശേരി ഈസ്റ്റ്",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1227,
    "village_name": "Puthussery West",
    "village_name_malayalam": "പുതുശ്ശേരി വെസ്റ്റ്",
    "is_notified": "False",
    "taluka_id": 13
  },
  {
    "id": 1228,
    "village_name": "Puthuvype",
    "village_name_malayalam": "പുതുവൈപ്പ്",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 1229,
    "village_name": "Pookode",
    "village_name_malayalam": "പൂക്കോട്",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1230,
    "village_name": "Pookkottur",
    "village_name_malayalam": "പൂക്കോട്ടൂർ",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 1231,
    "village_name": "Puzhakkattiri",
    "village_name_malayalam": "പുഴക്കാട്ടിരി",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 1232,
    "village_name": "Poolakkode",
    "village_name_malayalam": "പൂളക്കോട്",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 1233,
    "village_name": "Pulakode",
    "village_name_malayalam": "പുലക്കോട്",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1234,
    "village_name": "Pulamanthole",
    "village_name_malayalam": "പുലാമന്തോൾ",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 1235,
    "village_name": "Pulimath",
    "village_name_malayalam": "പുളിമാത്ത്",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 1236,
    "village_name": "Pulingom",
    "village_name_malayalam": "പുളിങ്ങോം",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 1237,
    "village_name": "Pulinkunnu",
    "village_name_malayalam": "പുളിങ്കുന്ന്",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 1238,
    "village_name": "Puliyannoor",
    "village_name_malayalam": "പുലിയന്നൂർ",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1239,
    "village_name": "Puliyur",
    "village_name_malayalam": "പുലിയൂർ",
    "is_notified": "False",
    "taluka_id": 14
  },
  {
    "id": 1240,
    "village_name": "Pullampara",
    "village_name_malayalam": "പുല്ലമ്പാറ",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1241,
    "village_name": "Pullazhi",
    "village_name_malayalam": "പുല്ലഴി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1242,
    "village_name": "Pullippadam",
    "village_name_malayalam": "പുള്ളിപ്പാടം",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 1243,
    "village_name": "Pullu",
    "village_name_malayalam": "പുല്ലു",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1244,
    "village_name": "Pullur",
    "village_name_malayalam": "പുല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1245,
    "village_name": "Pullur",
    "village_name_malayalam": "പുല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1246,
    "village_name": "Pullutt",
    "village_name_malayalam": "പുല്ലൂട്ട്",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1247,
    "village_name": "Pulpally",
    "village_name_malayalam": "പുൽപ്പള്ളി",
    "is_notified": "True",
    "taluka_id": 29
  },
  {
    "id": 1248,
    "village_name": "Pulpatta",
    "village_name_malayalam": "പുൽപ്പറ്റ",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 1249,
    "village_name": "Poomangalam",
    "village_name_malayalam": "പൂമംഗലം",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1250,
    "village_name": "Punalur",
    "village_name_malayalam": "പുനലൂർ",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 1251,
    "village_name": "Poonjar Nadubhagam",
    "village_name_malayalam": "പൂഞ്ഞാർ നടുഭാഗം",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1252,
    "village_name": "Poonjar Thekkekkara",
    "village_name_malayalam": "പൂഞ്ഞാർ തെക്കേക്കര",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1253,
    "village_name": "Poonjar",
    "village_name_malayalam": "പൂഞ്ഞാർ",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1254,
    "village_name": "Punkunnam",
    "village_name_malayalam": "പൂങ്കുന്നം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1255,
    "village_name": "Punnala",
    "village_name_malayalam": "പുന്നല",
    "is_notified": "False",
    "taluka_id": 76
  },
  {
    "id": 1256,
    "village_name": "Punnayur",
    "village_name_malayalam": "പുന്നയൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1257,
    "village_name": "Punnayurkulam-Kadikkad",
    "village_name_malayalam": "പുന്നയൂർക്കുളം-കടിക്കാട്",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1258,
    "village_name": "Pooppara",
    "village_name_malayalam": "പൂപ്പാറ",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 1259,
    "village_name": "Purakkadi",
    "village_name_malayalam": "പുറക്കാടി",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 1260,
    "village_name": "Purakkad",
    "village_name_malayalam": "പുറക്കാട്",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 1261,
    "village_name": "Puramattom",
    "village_name_malayalam": "പുറമറ്റം",
    "is_notified": "False",
    "taluka_id": 45
  },
  {
    "id": 1262,
    "village_name": "Purameri",
    "village_name_malayalam": "പുറമേരി",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1263,
    "village_name": "Puranattukara",
    "village_name_malayalam": "പുറനാട്ടുകര",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1264,
    "village_name": "Purappuzha",
    "village_name_malayalam": "പുറപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 1265,
    "village_name": "Purathur",
    "village_name_malayalam": "പുറത്തൂർ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1266,
    "village_name": "Poothadi",
    "village_name_malayalam": "പൂതാടി",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 1267,
    "village_name": "Poothakulam",
    "village_name_malayalam": "പൂതക്കുളം",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 1268,
    "village_name": "Puthur",
    "village_name_malayalam": "പുത്തൂർ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 1269,
    "village_name": "Puthenchira",
    "village_name_malayalam": "പുത്തൻചിറ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1270,
    "village_name": "Puthencruz",
    "village_name_malayalam": "പുത്തൻകുരിശ്",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 1271,
    "village_name": "Puthenvelikkara",
    "village_name_malayalam": "പുത്തൻവേലിക്കര",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 1272,
    "village_name": "Puthige",
    "village_name_malayalam": "പുത്തിഗെ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1273,
    "village_name": "Puthur",
    "village_name_malayalam": "പുത്തൂർ",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1274,
    "village_name": "Puthoor",
    "village_name_malayalam": "പുത്തൂർ",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 1275,
    "village_name": "Puthur",
    "village_name_malayalam": "പുത്തൂർ",
    "is_notified": "True",
    "taluka_id": 2
  },
  {
    "id": 1276,
    "village_name": "Puthur",
    "village_name_malayalam": "പുത്തൂർ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 1277,
    "village_name": "Puthuruthy",
    "village_name_malayalam": "പുതുരുത്തി",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1278,
    "village_name": "Puducode",
    "village_name_malayalam": "പുതുക്കോട്",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1279,
    "village_name": "Puthuppally",
    "village_name_malayalam": "പുതുപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 1280,
    "village_name": "Poovarani",
    "village_name_malayalam": "പൂവരണി",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1281,
    "village_name": "Puzhakkal",
    "village_name_malayalam": "പുഴക്കൽ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1282,
    "village_name": "Puzhathi",
    "village_name_malayalam": "പുഴാതി",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 1283,
    "village_name": "Rajakkad",
    "village_name_malayalam": "രാജാക്കാട്",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 1284,
    "village_name": "Rajakumary",
    "village_name_malayalam": "രാജകുമാരി",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 1285,
    "village_name": "Ramamangalam",
    "village_name_malayalam": "രാമമംഗലം",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 1286,
    "village_name": "Ramanattukara",
    "village_name_malayalam": "രാമനാട്ടുകര",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 1287,
    "village_name": "Ramankary",
    "village_name_malayalam": "രാമങ്കരി",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 1288,
    "village_name": "Ramanthali",
    "village_name_malayalam": "രാമന്തളി",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 1289,
    "village_name": "Ramapuram",
    "village_name_malayalam": "രാമപുരം",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1290,
    "village_name": "Rameshwaram",
    "village_name_malayalam": "രാമേശ്വരം",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 1291,
    "village_name": "Ranni",
    "village_name_malayalam": "റാന്നി",
    "is_notified": "True",
    "taluka_id": 42
  },
  {
    "id": 1292,
    "village_name": "Raroth",
    "village_name_malayalam": "രാരോത്ത്",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 1293,
    "village_name": "Rayamangalam",
    "village_name_malayalam": "രായമംഗലം",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 1294,
    "village_name": "Shakthikulangara",
    "village_name_malayalam": "ശക്തികുളങ്ങര",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 1295,
    "village_name": "Santhanpara",
    "village_name_malayalam": "ശാന്തൻപാറ",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 1296,
    "village_name": "Sasthamangalam",
    "village_name_malayalam": "ശാസ്തമംഗലം",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1297,
    "village_name": "Sasthamkotta",
    "village_name_malayalam": "ശാസ്താംകോട്ട",
    "is_notified": "False",
    "taluka_id": 75
  },
  {
    "id": 1298,
    "village_name": "Shiribagilu",
    "village_name_malayalam": "ഷിരിബാഗിലു",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 1299,
    "village_name": "Shiriya",
    "village_name_malayalam": "ഷിറിയ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1300,
    "village_name": "Sholayur",
    "village_name_malayalam": "ഷോളയൂർ",
    "is_notified": "True",
    "taluka_id": 8
  },
  {
    "id": 1301,
    "village_name": "Shornur 1",
    "village_name_malayalam": "ഷൊർണൂർ 1",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 1302,
    "village_name": "Shoranur 2",
    "village_name_malayalam": "ഷൊർണൂർ 2",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 1303,
    "village_name": "Sivapuram",
    "village_name_malayalam": "ശിവപുരം",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1304,
    "village_name": "Sivapuram",
    "village_name_malayalam": "ശിവപുരം",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 1305,
    "village_name": "Sreekrishnapuram 1",
    "village_name_malayalam": "ശ്രീകൃഷ്ണപുരം 1",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 1306,
    "village_name": "Sreekrishnapuram 2",
    "village_name_malayalam": "ശ്രീകൃഷ്ണപുരം 2",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 1307,
    "village_name": "Sreekandapuram",
    "village_name_malayalam": "ശ്രീകണ്ഠപുരം",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 1308,
    "village_name": "Sulthanbathery",
    "village_name_malayalam": "സുൽത്താൻബത്തേരി",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 1309,
    "village_name": "Sooranad North",
    "village_name_malayalam": "ശൂരനാട് വടക്ക്",
    "is_notified": "False",
    "taluka_id": 75
  },
  {
    "id": 1310,
    "village_name": "Sooranad South",
    "village_name_malayalam": "ശൂരനാട് സൗത്ത്",
    "is_notified": "False",
    "taluka_id": 75
  },
  {
    "id": 1311,
    "village_name": "Thalangara",
    "village_name_malayalam": "തളങ്കര",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 1312,
    "village_name": "Thalayazham",
    "village_name_malayalam": "തലയാഴം",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 1313,
    "village_name": "Thalakala",
    "village_name_malayalam": "തലക്കല",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1314,
    "village_name": "Tharur-1",
    "village_name_malayalam": "തരൂർ-1",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1315,
    "village_name": "Tharur-2",
    "village_name_malayalam": "തരൂർ-2",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1316,
    "village_name": "Thekkumkara",
    "village_name_malayalam": "തെക്കുംകര",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1317,
    "village_name": "Thachampara",
    "village_name_malayalam": "തച്ചമ്പാറ",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 1318,
    "village_name": "Thachanattukara 1",
    "village_name_malayalam": "തച്ചനാട്ടുകര 1",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 1319,
    "village_name": "Thachanattukara 2",
    "village_name_malayalam": "തച്ചനാട്ടുകര 2",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 1320,
    "village_name": "Thykkattussery",
    "village_name_malayalam": "തൈക്കാട്ടുശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 1321,
    "village_name": "Thakazhy",
    "village_name_malayalam": "തകഴി",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 1322,
    "village_name": "Thalakkad",
    "village_name_malayalam": "തലക്കാട്",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1323,
    "village_name": "Thalakkulathur",
    "village_name_malayalam": "തലക്കുളത്തൂർ",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 1324,
    "village_name": "Thalappalam",
    "village_name_malayalam": "തലപ്പലം",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1325,
    "village_name": "Thalassery",
    "village_name_malayalam": "തലശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1326,
    "village_name": "Thalassery",
    "village_name_malayalam": "തലശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1327,
    "village_name": "Thalavady",
    "village_name_malayalam": "തലവടി",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 1328,
    "village_name": "Thalavoor",
    "village_name_malayalam": "തലവൂർ",
    "is_notified": "False",
    "taluka_id": 76
  },
  {
    "id": 1329,
    "village_name": "Thalikkulam",
    "village_name_malayalam": "തളിക്കുളം",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1330,
    "village_name": "Taliparamba",
    "village_name_malayalam": "തളിപ്പറമ്പ്",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 1331,
    "village_name": "Thamarakkulam",
    "village_name_malayalam": "താമരക്കുളം",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 1332,
    "village_name": "Tanalur",
    "village_name_malayalam": "താനാളൂർ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1333,
    "village_name": "Thangaloor",
    "village_name_malayalam": "തങ്കളൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1334,
    "village_name": "Thanniyam",
    "village_name_malayalam": "താന്നിയം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1335,
    "village_name": "Thankamony",
    "village_name_malayalam": "തങ്കമണി",
    "is_notified": "False",
    "taluka_id": 59
  },
  {
    "id": 1336,
    "village_name": "Thanneermukkom North",
    "village_name_malayalam": "തണ്ണീർമുക്കം നോർത്ത്",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 1337,
    "village_name": "Thanneermukkom South",
    "village_name_malayalam": "തണ്ണീർമുക്കം സൗത്ത്",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 1338,
    "village_name": "Thannithode",
    "village_name_malayalam": "തണ്ണിത്തോട്",
    "is_notified": "True",
    "taluka_id": 55
  },
  {
    "id": 1339,
    "village_name": "Tanur",
    "village_name_malayalam": "താനൂർ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1340,
    "village_name": "Thariode",
    "village_name_malayalam": "തരിയോട്",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 1341,
    "village_name": "Thattamangalam",
    "village_name_malayalam": "തട്ടമംഗലം",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1342,
    "village_name": "Thavanur",
    "village_name_malayalam": "തവനൂർ",
    "is_notified": "False",
    "taluka_id": 20
  },
  {
    "id": 1343,
    "village_name": "Thavikkad",
    "village_name_malayalam": "തവിക്കാട്",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1344,
    "village_name": "Thavinhal",
    "village_name_malayalam": "തവിഞ്ഞാൽ",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 1345,
    "village_name": "Thayyur",
    "village_name_malayalam": "തയ്യൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 1346,
    "village_name": "Thazhakara",
    "village_name_malayalam": "തഴക്കര",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 1347,
    "village_name": "Thazhekode",
    "village_name_malayalam": "താഴെക്കോട്",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 1348,
    "village_name": "Thazhava",
    "village_name_malayalam": "തഴവ",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 1349,
    "village_name": "Thazhekkad",
    "village_name_malayalam": "താഴെക്കാട്",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1350,
    "village_name": "Thazhekkode",
    "village_name_malayalam": "താഴെക്കോട്",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 1351,
    "village_name": "Thazhuthala",
    "village_name_malayalam": "തഴുത്തല",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 1352,
    "village_name": "Thekkada",
    "village_name_malayalam": "തേക്കട",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1353,
    "village_name": "Thekkedesam",
    "village_name_malayalam": "തെക്കേദേശം",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1354,
    "village_name": "Thekkekkara",
    "village_name_malayalam": "തെക്കേക്കര",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 1355,
    "village_name": "Thekkil",
    "village_name_malayalam": "തെക്കിൽ",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 1356,
    "village_name": "Theekoy",
    "village_name_malayalam": "തീക്കോയി",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1357,
    "village_name": "Thekkumbhagam",
    "village_name_malayalam": "തെക്കുംഭാഗം",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 1358,
    "village_name": "Thekkumbhagam",
    "village_name_malayalam": "തെക്കുംഭാഗം",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 1359,
    "village_name": "Thekkumbhagam",
    "village_name_malayalam": "തെക്കുംഭാഗം",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 1360,
    "village_name": "Thekkumkara",
    "village_name_malayalam": "തെക്കുംകര",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1361,
    "village_name": "Thelliyoor",
    "village_name_malayalam": "തെള്ളിയൂർ",
    "is_notified": "False",
    "taluka_id": 45
  },
  {
    "id": 1362,
    "village_name": "Tenhippalam",
    "village_name_malayalam": "തേഞ്ഞിപ്പാലം",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 1363,
    "village_name": "Thenkara",
    "village_name_malayalam": "തെങ്കര",
    "is_notified": "False",
    "taluka_id": 8
  },
  {
    "id": 1364,
    "village_name": "Thenkurissi-I",
    "village_name_malayalam": "തേങ്കുറിശ്ശി-ഐ",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1365,
    "village_name": "Thenkurissi-II",
    "village_name_malayalam": "തേങ്കുറിശ്ശി-രണ്ടാം",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1366,
    "village_name": "Thennala",
    "village_name_malayalam": "തെന്നല",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 1367,
    "village_name": "Thennoor",
    "village_name_malayalam": "തെന്നൂർ",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1368,
    "village_name": "Thevalakkara",
    "village_name_malayalam": "തേവലക്കര",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 1369,
    "village_name": "Thichur",
    "village_name_malayalam": "തിച്ചൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1370,
    "village_name": "Thikkodi",
    "village_name_malayalam": "തിക്കോടി",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 1371,
    "village_name": "Thimiri",
    "village_name_malayalam": "തിമിരി",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 1372,
    "village_name": "Thimiri",
    "village_name_malayalam": "തിമിരി",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1373,
    "village_name": "Thinkalkarikkom",
    "village_name_malayalam": "തിങ്കൾകാരിക്കോം",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 1374,
    "village_name": "Thinoor",
    "village_name_malayalam": "തിനൂർ",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1375,
    "village_name": "Thirumala",
    "village_name_malayalam": "തിരുമല",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1376,
    "village_name": "Thirumarady",
    "village_name_malayalam": "തിരുമാറാടി",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 1377,
    "village_name": "Thirumittakode 2",
    "village_name_malayalam": "തിരുമിറ്റക്കോട് 2",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 1378,
    "village_name": "Thirumittakkode 1",
    "village_name_malayalam": "തിരുമിറ്റക്കോട് 1",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 1379,
    "village_name": "Thirumukkulam",
    "village_name_malayalam": "തിരുമുക്കുളം",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1380,
    "village_name": "Thirunelly",
    "village_name_malayalam": "തിരുനെല്ലി",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 1381,
    "village_name": "Thirunavaya",
    "village_name_malayalam": "തിരുനാവായ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1382,
    "village_name": "Thirupuram",
    "village_name_malayalam": "തിരുപുറം",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 1383,
    "village_name": "Thiruvali",
    "village_name_malayalam": "തിരുവാലി",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 1384,
    "village_name": "Thiruvallam",
    "village_name_malayalam": "തിരുവല്ലം",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1385,
    "village_name": "Thiruvalloor",
    "village_name_malayalam": "തിരുവള്ളൂർ",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1386,
    "village_name": "Thiruvampady",
    "village_name_malayalam": "തിരുവമ്പാടി",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 1387,
    "village_name": "Thiruvaniyoor",
    "village_name_malayalam": "തിരുവാണിയൂർ",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 1388,
    "village_name": "Thiruvankulam",
    "village_name_malayalam": "തിരുവാങ്കുളം",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 1389,
    "village_name": "Thiruvarppu",
    "village_name_malayalam": "തിരുവാർപ്പ്",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 1390,
    "village_name": "Thiruvazhiyode",
    "village_name_malayalam": "തിരുവാഴിയോട്",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1391,
    "village_name": "Thiruvegappura",
    "village_name_malayalam": "തിരുവേഗപ്പുറ",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 1392,
    "village_name": "Thiruvilwamala",
    "village_name_malayalam": "തിരുവില്വാമല",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1393,
    "village_name": "Thodiyoor",
    "village_name_malayalam": "തൊടിയൂർ",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 1394,
    "village_name": "Tholambra",
    "village_name_malayalam": "തോലമ്പ്ര",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1395,
    "village_name": "Tholicode",
    "village_name_malayalam": "തൊളിക്കോട്",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1396,
    "village_name": "Tholur Chalakkal Group",
    "village_name_malayalam": "തോളൂർ ചാലക്കൽ ഗ്രൂപ്പ്",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1397,
    "village_name": "Thomattuchal",
    "village_name_malayalam": "തോമാട്ടുചാൽ",
    "is_notified": "False",
    "taluka_id": 29
  },
  {
    "id": 1398,
    "village_name": "Thondernad",
    "village_name_malayalam": "തൊണ്ടർനാട്",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 1399,
    "village_name": "Thonnurkara",
    "village_name_malayalam": "തോന്നൂർക്കര",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1400,
    "village_name": "Thoppumpady",
    "village_name_malayalam": "തോപ്പുംപടി",
    "is_notified": "False",
    "taluka_id": 68
  },
  {
    "id": 1401,
    "village_name": "Thoravu",
    "village_name_malayalam": "തോറവ്",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1402,
    "village_name": "Thottackkadu",
    "village_name_malayalam": "തോട്ടക്കാട്",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 1403,
    "village_name": "Thottapuzhasserry",
    "village_name_malayalam": "തോട്ടപ്പുഴശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 1404,
    "village_name": "Thottippal",
    "village_name_malayalam": "തൊട്ടിപ്പാൾ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1405,
    "village_name": "Thrikkariyoor",
    "village_name_malayalam": "തൃക്കാരിയൂർ",
    "is_notified": "False",
    "taluka_id": 73
  },
  {
    "id": 1406,
    "village_name": "Thrikkadavoor",
    "village_name_malayalam": "തൃക്കടവൂർ",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 1407,
    "village_name": "Thrikkaipetta",
    "village_name_malayalam": "തൃക്കൈപ്പറ്റ",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 1408,
    "village_name": "Thrikkakara North",
    "village_name_malayalam": "തൃക്കാക്കര നോർത്ത്",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 1409,
    "village_name": "Thrikkalangode",
    "village_name_malayalam": "തൃക്കലങ്ങോട്",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 1410,
    "village_name": "Thrikkandiyoor",
    "village_name_malayalam": "തൃക്കണ്ടിയൂർ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1411,
    "village_name": "North Trikkaripur",
    "village_name_malayalam": "നോർത്ത് തൃക്കരിപ്പൂർ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1412,
    "village_name": "South Trikkaripur",
    "village_name_malayalam": "തെക്കൻ തൃക്കരിപ്പൂർ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1413,
    "village_name": "Thrikkaruva",
    "village_name_malayalam": "തൃക്കരുവ",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 1414,
    "village_name": "Thrikkovilvattom",
    "village_name_malayalam": "തൃക്കോവിൽവട്ടം",
    "is_notified": "False",
    "taluka_id": 4
  },
  {
    "id": 1415,
    "village_name": "Thrikkunnappuzha",
    "village_name_malayalam": "തൃക്കുന്നപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 1416,
    "village_name": "Trikkur",
    "village_name_malayalam": "തൃക്കൂർ",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1417,
    "village_name": "Thrikkodithanam",
    "village_name_malayalam": "തൃക്കൊടിത്താനം",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 1418,
    "village_name": "Thripperumthura",
    "village_name_malayalam": "തൃപ്പെരുംതുറ",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 1419,
    "village_name": "Triprangode",
    "village_name_malayalam": "തൃപ്രങ്ങോട്",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1420,
    "village_name": "Triprangottur",
    "village_name_malayalam": "തൃപ്രങ്ങോട്ടൂർ",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1421,
    "village_name": "Thrissilery",
    "village_name_malayalam": "തൃശ്ശിലേരി",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 1422,
    "village_name": "Thrissur",
    "village_name_malayalam": "തൃശൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1423,
    "village_name": "Thrithala",
    "village_name_malayalam": "തൃത്താല",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 1424,
    "village_name": "Tuneri",
    "village_name_malayalam": "തൂണേരി",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1425,
    "village_name": "Thuravoor",
    "village_name_malayalam": "തുറവൂർ",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 1426,
    "village_name": "Thurayur",
    "village_name_malayalam": "തുറയൂർ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 1427,
    "village_name": "Thuvvur",
    "village_name_malayalam": "തുവ്വൂർ",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 1428,
    "village_name": "Thycaud",
    "village_name_malayalam": "തൈക്കാട്",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1429,
    "village_name": "Thillenkeri",
    "village_name_malayalam": "തില്ലങ്കേരി",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 1430,
    "village_name": "Thirumeni",
    "village_name_malayalam": "തിരുമേനി",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 1431,
    "village_name": "Tirur",
    "village_name_malayalam": "തിരൂർ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1432,
    "village_name": "Tirurangadi",
    "village_name_malayalam": "തിരൂരങ്ങാടി",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 1433,
    "village_name": "Thiruvalla",
    "village_name_malayalam": "തിരുവല്ല",
    "is_notified": "False",
    "taluka_id": 74
  },
  {
    "id": 1434,
    "village_name": "Thiruvanvandoor",
    "village_name_malayalam": "തിരുവൻവണ്ടൂർ",
    "is_notified": "False",
    "taluka_id": 14
  },
  {
    "id": 1435,
    "village_name": "Thodupuzha",
    "village_name_malayalam": "തൊടുപുഴ",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 1436,
    "village_name": "Thrikkadeeri 2",
    "village_name_malayalam": "തൃക്കടീരി 2",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 1437,
    "village_name": "Tumboli",
    "village_name_malayalam": "തുംബോലി",
    "is_notified": "False",
    "taluka_id": 22
  },
  {
    "id": 1438,
    "village_name": "Thuravoor South",
    "village_name_malayalam": "തുറവൂർ സൗത്ത്",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 1439,
    "village_name": "Ubrangala",
    "village_name_malayalam": "ഉബ്രംഗല",
    "is_notified": "False",
    "taluka_id": 3
  },
  {
    "id": 1440,
    "village_name": "Udinur",
    "village_name_malayalam": "ഉദിനൂർ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1441,
    "village_name": "Udyavar",
    "village_name_malayalam": "ഉദ്യാവർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1442,
    "village_name": "Udma",
    "village_name_malayalam": "ഉദമ",
    "is_notified": "False",
    "taluka_id": 10
  },
  {
    "id": 1443,
    "village_name": "Udumbanchola",
    "village_name_malayalam": "ഉടുമ്പൻചോല",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 1444,
    "village_name": "Udumbannoor",
    "village_name_malayalam": "ഉടുമ്പന്നൂർ",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 1445,
    "village_name": "Ujarulwar",
    "village_name_malayalam": "ഉജാരുൾവാർ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1446,
    "village_name": "Uliyazhathura",
    "village_name_malayalam": "ഉളിയഴത്തുറ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1447,
    "village_name": "Ulliyeri",
    "village_name_malayalam": "ഉള്ളിയേരി",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 1448,
    "village_name": "Ulloor",
    "village_name_malayalam": "ഉള്ളൂർ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1449,
    "village_name": "Ummannur",
    "village_name_malayalam": "ഉമ്മന്നൂർ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 1450,
    "village_name": "Unnikulam",
    "village_name_malayalam": "ഉണ്ണികുളം",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 1451,
    "village_name": "Uppala",
    "village_name_malayalam": "ഉപ്പള",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1452,
    "village_name": "Upputhara",
    "village_name_malayalam": "ഉപ്പുതറ",
    "is_notified": "False",
    "taluka_id": 38
  },
  {
    "id": 1453,
    "village_name": "Upputhode",
    "village_name_malayalam": "ഉപ്പുതോട്",
    "is_notified": "False",
    "taluka_id": 59
  },
  {
    "id": 1454,
    "village_name": "Oorakam",
    "village_name_malayalam": "ഊരകം",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 1455,
    "village_name": "Oorakam",
    "village_name_malayalam": "ഊരകം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1456,
    "village_name": "Urangattiri",
    "village_name_malayalam": "ഊർങ്ങാട്ടിരി",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 1457,
    "village_name": "Uzhamalakkal",
    "village_name_malayalam": "ഉഴമലക്കൽ",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1458,
    "village_name": "Uzhavoor",
    "village_name_malayalam": "ഉഴവൂർ",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1459,
    "village_name": "Vatakara",
    "village_name_malayalam": "വടകര",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1460,
    "village_name": "Vadakarappathi",
    "village_name_malayalam": "വടകരപ്പതി",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1461,
    "village_name": "Vadakkancheri",
    "village_name_malayalam": "വടക്കാഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1462,
    "village_name": "Wadakkanchery",
    "village_name_malayalam": "വടക്കാഞ്ചേരി",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1463,
    "village_name": "Vadakkenchery-1",
    "village_name_malayalam": "വടക്കഞ്ചേരി-1",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1464,
    "village_name": "Vadakkenchery-2",
    "village_name_malayalam": "വടക്കഞ്ചേരി-2",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1465,
    "village_name": "Vadakkangara",
    "village_name_malayalam": "വടക്കാങ്ങര",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 1466,
    "village_name": "Vadakkekara",
    "village_name_malayalam": "വടക്കേക്കര",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 1467,
    "village_name": "Vadakkekad",
    "village_name_malayalam": "വടക്കേക്കാട്",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1468,
    "village_name": "Vadakkemuri",
    "village_name_malayalam": "വടക്കേമുറി",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 1469,
    "village_name": "Vadakkethara",
    "village_name_malayalam": "വടക്കേത്തറ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1470,
    "village_name": "Vadakkumbhagom",
    "village_name_malayalam": "വടക്കുംഭാഗം",
    "is_notified": "False",
    "taluka_id": 27
  },
  {
    "id": 1471,
    "village_name": "Vadakkumbhagam",
    "village_name_malayalam": "വടക്കുംഭാഗം",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1472,
    "village_name": "Vadakkumkara",
    "village_name_malayalam": "വടക്കുംകര",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1473,
    "village_name": "Vadakkummuri",
    "village_name_malayalam": "വടക്കുംമുറി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1474,
    "village_name": "Vadakumthala",
    "village_name_malayalam": "വടക്കുംതല",
    "is_notified": "False",
    "taluka_id": 5
  },
  {
    "id": 1475,
    "village_name": "Vadama",
    "village_name_malayalam": "വടമ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1476,
    "village_name": "Vadanappilly",
    "village_name_malayalam": "വാടാനപ്പിള്ളി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1477,
    "village_name": "Vadasserikara",
    "village_name_malayalam": "വടശ്ശേരിക്കര",
    "is_notified": "False",
    "taluka_id": 42
  },
  {
    "id": 1478,
    "village_name": "Vadavannur",
    "village_name_malayalam": "വടവന്നൂർ",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1479,
    "village_name": "Vadavukode",
    "village_name_malayalam": "വടവുകോട്",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 1480,
    "village_name": "Vadayar",
    "village_name_malayalam": "വടയാർ",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 1481,
    "village_name": "Vagamon",
    "village_name_malayalam": "വാഗമൺ",
    "is_notified": "False",
    "taluka_id": 38
  },
  {
    "id": 1482,
    "village_name": "Vaikom",
    "village_name_malayalam": "വൈക്കം",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 1483,
    "village_name": "Veiloor",
    "village_name_malayalam": "വെയിലൂർ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1484,
    "village_name": "Vakathanam",
    "village_name_malayalam": "വാകത്താനം",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 1485,
    "village_name": "Vakkam",
    "village_name_malayalam": "വക്കം",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 1486,
    "village_name": "Valad",
    "village_name_malayalam": "വലാദ്",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 1487,
    "village_name": "Valakom",
    "village_name_malayalam": "വാളകം",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 1488,
    "village_name": "Valakkode",
    "village_name_malayalam": "വാളക്കോട്",
    "is_notified": "False",
    "taluka_id": 25
  },
  {
    "id": 1489,
    "village_name": "Valakom",
    "village_name_malayalam": "വാളകം",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 1490,
    "village_name": "Valambur",
    "village_name_malayalam": "വലമ്പൂർ",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 1491,
    "village_name": "Valapattanam",
    "village_name_malayalam": "വളപട്ടണം",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 1492,
    "village_name": "Valappad",
    "village_name_malayalam": "വലപ്പാട്",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1493,
    "village_name": "Valavannur",
    "village_name_malayalam": "വളവന്നൂർ",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1494,
    "village_name": "Valayam",
    "village_name_malayalam": "വളയം",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1495,
    "village_name": "Valayanad",
    "village_name_malayalam": "വളയനാട്",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 1496,
    "village_name": "Valiyannur",
    "village_name_malayalam": "വലിയന്നൂർ",
    "is_notified": "False",
    "taluka_id": 40
  },
  {
    "id": 1497,
    "village_name": "Valiyavallampathy",
    "village_name_malayalam": "വലിയവള്ളമ്പതി",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1498,
    "village_name": "Vallachira",
    "village_name_malayalam": "വല്ലച്ചിറ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1499,
    "village_name": "Vallanghi",
    "village_name_malayalam": "വല്ലങ്ങി",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1500,
    "village_name": "Vallapuzha",
    "village_name_malayalam": "വല്ലപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 1501,
    "village_name": "Vallichira",
    "village_name_malayalam": "വള്ളിച്ചിറ",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1502,
    "village_name": "Vallicode",
    "village_name_malayalam": "വള്ളിക്കോട്",
    "is_notified": "False",
    "taluka_id": 55
  },
  {
    "id": 1503,
    "village_name": "V.Kottayam",
    "village_name_malayalam": "വി.കോട്ടയം",
    "is_notified": "False",
    "taluka_id": 55
  },
  {
    "id": 1504,
    "village_name": "Vallikunnam",
    "village_name_malayalam": "വള്ളികുന്നം",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 1505,
    "village_name": "Vallikunnu",
    "village_name_malayalam": "വള്ളിക്കുന്ന്",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 1506,
    "village_name": "Vallivattom",
    "village_name_malayalam": "വള്ളിവട്ടം",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1507,
    "village_name": "Vamanapuram",
    "village_name_malayalam": "വാമനപുരം",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1508,
    "village_name": "Vanchiyoor",
    "village_name_malayalam": "വഞ്ചിയൂർ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1509,
    "village_name": "Vandenmedu",
    "village_name_malayalam": "വണ്ടൻമേട്",
    "is_notified": "False",
    "taluka_id": 33
  },
  {
    "id": 1510,
    "village_name": "Vandazhi 1",
    "village_name_malayalam": "വണ്ടാഴി 1",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1511,
    "village_name": "Vandazhi 2",
    "village_name_malayalam": "വണ്ടാഴി 2",
    "is_notified": "False",
    "taluka_id": 23
  },
  {
    "id": 1512,
    "village_name": "Vandithavalam",
    "village_name_malayalam": "വണ്ടിത്താവളം",
    "is_notified": "False",
    "taluka_id": 56
  },
  {
    "id": 1513,
    "village_name": "Vanimel",
    "village_name_malayalam": "വാണിമേൽ",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1514,
    "village_name": "Vaniyamkulam 1",
    "village_name_malayalam": "വാണിയംകുളം 1",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 1515,
    "village_name": "Vaniyamkulam 2",
    "village_name_malayalam": "വാണിയംകുളം 2",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 1516,
    "village_name": "Venmanad",
    "village_name_malayalam": "വെൺമനാട്",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1517,
    "village_name": "Vannappuram",
    "village_name_malayalam": "വണ്ണപ്പുറം",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 1518,
    "village_name": "Varandarapilly",
    "village_name_malayalam": "വരന്തരപ്പിള്ളി",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1519,
    "village_name": "Varappetty",
    "village_name_malayalam": "വാരപ്പെട്ടി",
    "is_notified": "False",
    "taluka_id": 73
  },
  {
    "id": 1520,
    "village_name": "Varappuzha",
    "village_name_malayalam": "വരാപ്പുഴ",
    "is_notified": "False",
    "taluka_id": 19
  },
  {
    "id": 1521,
    "village_name": "Varavoor",
    "village_name_malayalam": "വരവൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1522,
    "village_name": "Varkala",
    "village_name_malayalam": "വർക്കല",
    "is_notified": "False",
    "taluka_id": 58
  },
  {
    "id": 1523,
    "village_name": "Vattamkulam",
    "village_name_malayalam": "വട്ടംകുളം",
    "is_notified": "False",
    "taluka_id": 20
  },
  {
    "id": 1524,
    "village_name": "Vattappara",
    "village_name_malayalam": "വട്ടപ്പാറ",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1525,
    "village_name": "Vattavada",
    "village_name_malayalam": "വട്ടവട",
    "is_notified": "False",
    "taluka_id": 37
  },
  {
    "id": 1526,
    "village_name": "Vathikudy",
    "village_name_malayalam": "വാത്തിക്കുടി",
    "is_notified": "False",
    "taluka_id": 59
  },
  {
    "id": 1527,
    "village_name": "Vattiyoorkavu",
    "village_name_malayalam": "വട്ടിയൂർക്കാവ്",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1528,
    "village_name": "Vavad",
    "village_name_malayalam": "വാവാട്",
    "is_notified": "False",
    "taluka_id": 72
  },
  {
    "id": 1529,
    "village_name": "Vayakkara",
    "village_name_malayalam": "വയക്കര",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 1530,
    "village_name": "Vayalar East",
    "village_name_malayalam": "വയലാർ ഈസ്റ്റ്",
    "is_notified": "False",
    "taluka_id": 54
  },
  {
    "id": 1531,
    "village_name": "Vylathur",
    "village_name_malayalam": "വൈലത്തൂർ",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1532,
    "village_name": "Vayathur",
    "village_name_malayalam": "വയത്തൂർ",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 1533,
    "village_name": "Vazhakkad",
    "village_name_malayalam": "വാഴക്കാട്",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 1534,
    "village_name": "Vazhakkala",
    "village_name_malayalam": "വാഴക്കാല",
    "is_notified": "False",
    "taluka_id": 30
  },
  {
    "id": 1535,
    "village_name": "Vazhakulam",
    "village_name_malayalam": "വാഴക്കുളം",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 1536,
    "village_name": "Vazhappally Kizhakku",
    "village_name_malayalam": "വാഴപ്പള്ളി കിഴക്ക്",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 1537,
    "village_name": "Vazhappally Padinjaru",
    "village_name_malayalam": "വാഴപ്പള്ളി പടിഞ്ഞാറു",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 1538,
    "village_name": "Vazhayoor",
    "village_name_malayalam": "വാഴയൂർ",
    "is_notified": "False",
    "taluka_id": 67
  },
  {
    "id": 1539,
    "village_name": "Vazhichal",
    "village_name_malayalam": "വാഴിച്ചാൽ",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 1540,
    "village_name": "Vazhikkadavu",
    "village_name_malayalam": "വഴിക്കടവ്",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 1541,
    "village_name": "Vazhoor",
    "village_name_malayalam": "വാഴൂർ",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 1542,
    "village_name": "Vechoor",
    "village_name_malayalam": "വെച്ചൂർ",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 1543,
    "village_name": "Veeranakavu",
    "village_name_malayalam": "വീരണകാവ്",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 1544,
    "village_name": "Veeyapuram",
    "village_name_malayalam": "വീയപുരം",
    "is_notified": "False",
    "taluka_id": 51
  },
  {
    "id": 1545,
    "village_name": "Vekkalam",
    "village_name_malayalam": "വെക്കളം",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1546,
    "village_name": "Velom",
    "village_name_malayalam": "വെലോം",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1547,
    "village_name": "Vilamana",
    "village_name_malayalam": "വിലമന",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 1548,
    "village_name": "Velappaya",
    "village_name_malayalam": "വേലപ്പായ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1549,
    "village_name": "Velinalloor",
    "village_name_malayalam": "വെളിനല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 1550,
    "village_name": "Veliyam",
    "village_name_malayalam": "വെളിയം",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 1551,
    "village_name": "Veliyanadu",
    "village_name_malayalam": "വെളിയനാട്",
    "is_notified": "False",
    "taluka_id": 65
  },
  {
    "id": 1552,
    "village_name": "Veliyancode",
    "village_name_malayalam": "വെളിയങ്കോട്",
    "is_notified": "False",
    "taluka_id": 20
  },
  {
    "id": 1553,
    "village_name": "Veliyannoor",
    "village_name_malayalam": "വെളിയന്നൂർ",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1554,
    "village_name": "Vellad",
    "village_name_malayalam": "വെള്ളാട്",
    "is_notified": "False",
    "taluka_id": 16
  },
  {
    "id": 1555,
    "village_name": "Vellalloor",
    "village_name_malayalam": "വെള്ളല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 18
  },
  {
    "id": 1556,
    "village_name": "Vellamunda",
    "village_name_malayalam": "വെള്ളമുണ്ട",
    "is_notified": "False",
    "taluka_id": 46
  },
  {
    "id": 1557,
    "village_name": "Vellanad",
    "village_name_malayalam": "വെള്ളനാട്",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1558,
    "village_name": "Vellanikkara",
    "village_name_malayalam": "വെള്ളാനിക്കര",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1559,
    "village_name": "Vellarada",
    "village_name_malayalam": "വെള്ളറട",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 1560,
    "village_name": "Vellarakkad",
    "village_name_malayalam": "വെള്ളറക്കാട്",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 1561,
    "village_name": "Vellarikundu",
    "village_name_malayalam": "വെള്ളരിക്കുണ്ട്",
    "is_notified": "False",
    "taluka_id": 60
  },
  {
    "id": 1562,
    "village_name": "Vellarimala",
    "village_name_malayalam": "വെള്ളരിമല",
    "is_notified": "True",
    "taluka_id": 1
  },
  {
    "id": 1563,
    "village_name": "Vellarvalli",
    "village_name_malayalam": "വെള്ളാർവള്ളി",
    "is_notified": "False",
    "taluka_id": 48
  },
  {
    "id": 1564,
    "village_name": "Vellarvalli",
    "village_name_malayalam": "വെള്ളാർവള്ളി",
    "is_notified": "False",
    "taluka_id": 71
  },
  {
    "id": 1565,
    "village_name": "Vellattanjur",
    "village_name_malayalam": "വെള്ളാട്ടഞ്ഞൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 1566,
    "village_name": "Vellathooval",
    "village_name_malayalam": "വെള്ളത്തൂവൽ",
    "is_notified": "False",
    "taluka_id": 37
  },
  {
    "id": 1567,
    "village_name": "Vellavoor",
    "village_name_malayalam": "വെള്ളാവൂർ",
    "is_notified": "False",
    "taluka_id": 66
  },
  {
    "id": 1568,
    "village_name": "Vellayur",
    "village_name_malayalam": "വെള്ളയൂർ",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 1569,
    "village_name": "Vellikulangara",
    "village_name_malayalam": "വെള്ളിക്കുളങ്ങര",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1570,
    "village_name": "Vellilappally",
    "village_name_malayalam": "വെള്ളിലാപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 62
  },
  {
    "id": 1571,
    "village_name": "Vellinezhi",
    "village_name_malayalam": "വെള്ളിനേഴി",
    "is_notified": "False",
    "taluka_id": 28
  },
  {
    "id": 1572,
    "village_name": "Velliyamattam",
    "village_name_malayalam": "വെള്ളിയാമറ്റം",
    "is_notified": "False",
    "taluka_id": 17
  },
  {
    "id": 1573,
    "village_name": "Vellora",
    "village_name_malayalam": "വെല്ലോറ",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 1574,
    "village_name": "Velookkara",
    "village_name_malayalam": "വേലൂക്കര",
    "is_notified": "False",
    "taluka_id": 15
  },
  {
    "id": 1575,
    "village_name": "Vellur",
    "village_name_malayalam": "വെള്ളൂർ",
    "is_notified": "False",
    "taluka_id": 21
  },
  {
    "id": 1576,
    "village_name": "Vellor",
    "village_name_malayalam": "വെല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 69
  },
  {
    "id": 1577,
    "village_name": "Velloorkunnam",
    "village_name_malayalam": "വെള്ളൂർക്കുന്നം",
    "is_notified": "False",
    "taluka_id": 47
  },
  {
    "id": 1578,
    "village_name": "Veloor",
    "village_name_malayalam": "വേളൂർ",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 1579,
    "village_name": "Velur",
    "village_name_malayalam": "വേളൂർ",
    "is_notified": "False",
    "taluka_id": 12
  },
  {
    "id": 1580,
    "village_name": "Veluthur",
    "village_name_malayalam": "വെളുത്തൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1581,
    "village_name": "Vembayam",
    "village_name_malayalam": "വെമ്പായം",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1582,
    "village_name": "Venganellur",
    "village_name_malayalam": "വെങ്ങാനെല്ലൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1583,
    "village_name": "Veganoor",
    "village_name_malayalam": "വേഗനൂർ",
    "is_notified": "False",
    "taluka_id": 41
  },
  {
    "id": 1584,
    "village_name": "Vengappally",
    "village_name_malayalam": "വെങ്ങപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 1
  },
  {
    "id": 1585,
    "village_name": "Vengara",
    "village_name_malayalam": "വേങ്ങര",
    "is_notified": "False",
    "taluka_id": 53
  },
  {
    "id": 1586,
    "village_name": "Vengeri",
    "village_name_malayalam": "വേങ്ങേരി",
    "is_notified": "False",
    "taluka_id": 61
  },
  {
    "id": 1587,
    "village_name": "Venginissery",
    "village_name_malayalam": "വെങ്ങിണിശ്ശേരി",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1588,
    "village_name": "Vengola",
    "village_name_malayalam": "വെങ്ങോല",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 1589,
    "village_name": "Vengoor",
    "village_name_malayalam": "വേങ്ങൂർ",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 1590,
    "village_name": "Vengoor west",
    "village_name_malayalam": "വേങ്ങൂർ പടിഞ്ഞാറ്",
    "is_notified": "False",
    "taluka_id": 9
  },
  {
    "id": 1591,
    "village_name": "Venkidangu",
    "village_name_malayalam": "വെങ്കിടങ്ങ്",
    "is_notified": "False",
    "taluka_id": 24
  },
  {
    "id": 1592,
    "village_name": "Venmony",
    "village_name_malayalam": "വെൻമണി",
    "is_notified": "False",
    "taluka_id": 14
  },
  {
    "id": 1593,
    "village_name": "Vennur",
    "village_name_malayalam": "വെണ്ണൂർ",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1594,
    "village_name": "Vettom",
    "village_name_malayalam": "വെട്ടം",
    "is_notified": "False",
    "taluka_id": 36
  },
  {
    "id": 1595,
    "village_name": "Vettathur",
    "village_name_malayalam": "വെട്ടത്തൂർ",
    "is_notified": "False",
    "taluka_id": 26
  },
  {
    "id": 1596,
    "village_name": "Vettikkattiri",
    "village_name_malayalam": "വെട്ടിക്കാട്ടിരി",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 1597,
    "village_name": "Vettikkavala",
    "village_name_malayalam": "വെട്ടിക്കവല",
    "is_notified": "False",
    "taluka_id": 64
  },
  {
    "id": 1598,
    "village_name": "Vettilippara",
    "village_name_malayalam": "വെട്ടിലിപ്പാറ",
    "is_notified": "False",
    "taluka_id": 35
  },
  {
    "id": 1599,
    "village_name": "Vettiyar",
    "village_name_malayalam": "വെട്ടിയാർ",
    "is_notified": "False",
    "taluka_id": 63
  },
  {
    "id": 1600,
    "village_name": "Vijayapuram",
    "village_name_malayalam": "വിജയപുരം",
    "is_notified": "False",
    "taluka_id": 6
  },
  {
    "id": 1601,
    "village_name": "Vilakudy",
    "village_name_malayalam": "വിളക്കുടി",
    "is_notified": "False",
    "taluka_id": 76
  },
  {
    "id": 1602,
    "village_name": "Vilangad",
    "village_name_malayalam": "വിലങ്ങാട്",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1603,
    "village_name": "Vilappil",
    "village_name_malayalam": "വിളപ്പിൽ",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 1604,
    "village_name": "Vilavoorkal",
    "village_name_malayalam": "വിളവൂർക്കൽ",
    "is_notified": "False",
    "taluka_id": 31
  },
  {
    "id": 1605,
    "village_name": "Vilayur",
    "village_name_malayalam": "വിളയൂർ",
    "is_notified": "False",
    "taluka_id": 34
  },
  {
    "id": 1606,
    "village_name": "Villiappally",
    "village_name_malayalam": "വില്ല്യാപ്പള്ളി",
    "is_notified": "False",
    "taluka_id": 57
  },
  {
    "id": 1607,
    "village_name": "Vilvattom",
    "village_name_malayalam": "വില്വട്ടം",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1608,
    "village_name": "Viruppakka",
    "village_name_malayalam": "വിരുപ്പാക്ക",
    "is_notified": "False",
    "taluka_id": 49
  },
  {
    "id": 1609,
    "village_name": "Vithura",
    "village_name_malayalam": "വിതുര",
    "is_notified": "False",
    "taluka_id": 32
  },
  {
    "id": 1610,
    "village_name": "Viyyur",
    "village_name_malayalam": "വിയ്യൂർ",
    "is_notified": "False",
    "taluka_id": 52
  },
  {
    "id": 1611,
    "village_name": "Viyyur",
    "village_name_malayalam": "വിയ്യൂർ",
    "is_notified": "False",
    "taluka_id": 2
  },
  {
    "id": 1612,
    "village_name": "Vizhinjam",
    "village_name_malayalam": "വിഴിഞ്ഞം",
    "is_notified": "False",
    "taluka_id": 39
  },
  {
    "id": 1613,
    "village_name": "Vorkady",
    "village_name_malayalam": "വോർക്കടി",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1614,
    "village_name": "Wandoor",
    "village_name_malayalam": "വണ്ടൂർ",
    "is_notified": "False",
    "taluka_id": 11
  },
  {
    "id": 1615,
    "village_name": "West Kallada",
    "village_name_malayalam": "പടിഞ്ഞാറ് കല്ലട",
    "is_notified": "False",
    "taluka_id": 75
  },
  {
    "id": 1616,
    "village_name": "Yednad",
    "village_name_malayalam": "യെഡ്നാട്",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1617,
    "village_name": "Enmakaje",
    "village_name_malayalam": "എൻമകജെ",
    "is_notified": "False",
    "taluka_id": 44
  },
  {
    "id": 1618,
    "village_name": "Kannan Devan Hills",
    "village_name_malayalam": "കണ്ണൻ ദേവൻ കുന്നുകൾ",
    "is_notified": "True",
    "taluka_id": 37
  },
  {
    "id": 1619,
    "village_name": "Pothundy",
    "village_name_malayalam": "പോത്തുണ്ടി",
    "is_notified": "True",
    "taluka_id": 56
  },
  {
    "id": 1620,
    "village_name": "Puthur",
    "village_name_malayalam": "പുത്തൂർ",
    "is_notified": "True",
    "taluka_id": 56
  },
  {
    "id": 1621,
    "village_name": "Seethathode",
    "village_name_malayalam": "സീതത്തോട്",
    "is_notified": "True",
    "taluka_id": 55
  },
  {
    "id": 1622,
    "village_name": "Athirappilly",
    "village_name_malayalam": "അതിരപ്പള്ളി",
    "is_notified": "True",
    "taluka_id": 77
  },
  {
    "id": 1623,
    "village_name": "Thrikkur",
    "village_name_malayalam": "തൃക്കൂര്",
    "is_notified": "True",
    "taluka_id": 77
  },
  {
    "id": 1624,
    "village_name": "Mupliyam",
    "village_name_malayalam": "മുപ്ലിയം",
    "is_notified": "True",
    "taluka_id": 77
  },
  {
    "id": 1625,
    "village_name": "Pothukal",
    "village_name_malayalam": "പോത്തുങ്കൽ",
    "is_notified": "True",
    "taluka_id": 77
  },
  {
    "id": 1626,
    "village_name": "Chembanoda",
    "village_name_malayalam": "ചെമ്പനോട",
    "is_notified": "True",
    "taluka_id": 77
  },
  {
    "id": 1627,
    "village_name": "Chundale",
    "village_name_malayalam": "ചുണ്ടലി",
    "is_notified": "True",
    "taluka_id": 77
  },
  {
    "id": 1628,
    "village_name": "Thenmala",
    "village_name_malayalam": "തെന്മല",
    "is_notified": "True",
    "taluka_id": 78
  },
  {
    "id": 1629,
    "village_name": "Ayyampuzha",
    "village_name_malayalam": "അയ്യമ്പഴ",
    "is_notified": "True",
    "taluka_id": 78
  },
  {
    "id": 1630,
    "village_name": "Pothukal",
    "village_name_malayalam": "പോത്തുങ്കൽ",
    "is_notified": "True",
    "taluka_id": 78
  },
  {
    "id": 1631,
    "village_name": "Puthuseri Central",
    "village_name_malayalam": "പുതുശ്ശേരി സെൻട്രൽ",
    "is_notified": "True",
    "taluka_id": 78
  },
  {
    "id": 1632,
    "village_name": "Puthuseri East",
    "village_name_malayalam": "പുതുശ്ശേരി ",
    "is_notified": "True",
    "taluka_id": 78
  },
  {
    "id": 1633,
    "village_name": "Thachampara",
    "village_name_malayalam": "തച്ചംപാറ",
    "is_notified": "True",
    "taluka_id": 78
  },
  {
    "id": 1634,
    "village_name": "Aryankavu",
    "village_name_malayalam": "ആര്യങ്കാവ്",
    "is_notified": "True",
    "taluka_id": 78
  },
  {
    "id": 1635,
    "village_name": "Muthedam",
    "village_name_malayalam": "മൂത്തേടം",
    "is_notified": "True",
    "taluka_id": 11
  },
],
    };

  },
  mounted() {
    this.mapData = this.storage;
    this.initMap();
  },
  beforeMount() {
    this.getanimalData();
    this.getDivisionData();
    this.getconflicttypeData();
    this.getcroptypeData();
    // this.getscenarioData();
  },
  created() {
    // Check for edit mode via URL param
    this.reportId = this.$route.params.id;

    if (this.reportId) {
      this.isEditMode = true;
      // Mark as already saved so Submit/Save Changes buttons appear immediately
      this.isSaved = true;
      this.hasChanges = false;
      this.loadExistingReport();
    }
    // else → new report, nothing to load
  },
  computed: {
    today() {
      const now = new Date();
      const pad = (n) => n.toString().padStart(2, '0');
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    },

    isCropDamageSelected() {
      return this.ConflictType.includes("66a0a27355c32d4f84bae66c");
    },
    isPropertyDamageSelected() {
      return this.ConflictType.includes("66a0a2eb55c32d4f84bae66f");
    },
    isHumanInjurySelected() {
      return this.ConflictType.includes("66a89372178e6931b4c1753f");
    },
    isHumanDeathSelected() {
      return this.ConflictType.includes("66a89379178e6931b4c17543");
    },
    isAnimalInjurySelected() {
      return this.ConflictType.includes("66a89360178e6931b4c17537");
    },
    isAnimalDeathSelected() {
      return this.ConflictType.includes("66a89368178e6931b4c1753b");
    },
    isLivestockDepredationSelected() {
      return this.ConflictType.includes("66a89381178e6931b4c17547");
    },
    selectedDistrictName() {
    const dist = this.districts.find(d => d["District ID"] === this.selectedDistrict);
    return dist ? dist["District Name"] : '';
  },
  selectedAnimalTypeName() {
    const animal = this.animalTypes.find(a => a._id === this.animaltype);
    return animal ? animal.name : '';
  },
  },
  watch: {
    nopeopleinjured(newCount) {
      const count = Math.max(0, parseInt(newCount, 10) || 0);
      if (count > this.injuredPeople.length) {
        for (let i = this.injuredPeople.length; i < count; i++) {
          this.injuredPeople.push({ name: "", age: "", gender: "", injuryType: "", hospitalized: "", isTribe: "", community: "", forestLocation: "", rfName: "" });
        }
      } else if (count < this.injuredPeople.length) {
        this.injuredPeople.splice(count);
      }
    },
    nopeopledied(newCount) {
      const count = Math.max(0, parseInt(newCount, 10) || 0);
      if (count > this.peopleDead.length) {
        for (let i = this.peopleDead.length; i < count; i++) {
          this.peopleDead.push({ name: "", age: "", gender: "", isTribe: "", community: "", forestLocation: "", rfName: "" });
        }
      } else if (count < this.peopleDead.length) {
        this.peopleDead.splice(count);
      }
    },
    anyDamage(val) {
      if (val === "No") {
        this.ConflictType = [];
        this.cropTypedetails = [{ cropId: "", count: "", unit: "" }];
        this.propertyTypedetails = [{ propertyType: "", damageDetail: "" }];
        this.nopeopleinjured = 0;
        this.injuredPeople = [];
        this.nopeopledied = 0;
        this.peopleDead = [];
        this.animalInjuryDetails = { injuredNumber: "", typeOfInjury: "" };
        this.animalDeathDetails = { numberOfDied: "" };
        this.animalDeathDetailsList = [{ species: "", gender: "", causeOfDeath: "" }];
        this.livestockanimal = [{ injuryOrDeath: "", typeOfAnimal: "", numberOfAnimals: "" }];
        this.cropTitle = "";
        this.propertyTitle = "";
        this.humanInjuryTitle = "";
        this.humanDeathTitle = "";
        this.animalInjuryTitle = "";
        this.animalDeathTitle = "";
        this.livestockTitle = "";
      }
    },
    lattitude(newVal) {
      if (this.locationTimer) clearTimeout(this.locationTimer);
      if (newVal && newVal.length > 5) {
        this.locationTimer = setTimeout(() => {
          this.updateLocationFromCoordinates();
        }, 1000);
      }
    },
    longitude(newVal) {
      if (this.locationTimer) clearTimeout(this.locationTimer);
      if (newVal && newVal.length > 5) {
        this.locationTimer = setTimeout(() => {
          this.updateLocationFromCoordinates();
        }, 1000);
      }
    },
    rangename(newVal, oldVal) {
      if (this.responseRange === oldVal || !this.responseRange) {
        this.responseRange = newVal;
      }
    },
    sectionStation(newVal, oldVal) {
      if (this.responseSection === oldVal || !this.responseSection) {
        this.responseSection = newVal;
      }
      if (this.responseStation === oldVal || !this.responseStation) {
        this.responseStation = newVal;
      }
    }
  },
  methods: {
    formatDate(isoString) {
      if (!isoString) return '';
      const date = new Date(isoString);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replace(/\//g, '-');
    },
    formatTime(timeStr) {
      if (!timeStr) return '—';
      const [hourStr, minuteStr] = timeStr.split(':');
      const hour = parseInt(hourStr, 10);
      const minute = minuteStr || '00';
      if (isNaN(hour)) return timeStr;
      const period = hour >= 12 ? 'PM' : 'AM';
      const hour12 = hour % 12 || 12;
      return `${String(hour12).padStart(2, '0')}:${minute} ${period}`;
    },
    getConflictTypeName(id) {
    const type = this.ConflictTypes.find(t => t._id === id);
    return type ? type.name : id;
  },
  markAsDirty() {
      if (this.isEditMode) {
        this.hasUnsavedChanges = true;
      }
      // If report is already saved, any new change should show the "Save Changes" button
      if (this.isSaved) {
        this.hasChanges = true;
      }
    },
  
  resetChangesFlag() {
    this.hasChanges = false;
  },
  getCropName(id) {
    const crop = this.Typeofcrops.find(c => c._id === id);
    return crop ? crop.name : '';
  },
    onLocalBodyTypeChange() {
      if (this.localBodyType === 'Panchayat') {
        if (this.selectedDistrict) {
          this.filteredAssemblies = this.assemblies.filter(
            a => a.districtId == this.selectedDistrict
          );
          this.filteredConstituencies = this.constituencies.filter(
            c => c.districtId == this.selectedDistrict
          );
          this.filteredPanchayats = this.panchayats.filter(
            p => p.districtId == this.selectedDistrict
          );
        } else {
          this.filteredAssemblies = [];
          this.filteredConstituencies = [];
          this.filteredPanchayats = [];
        }
      } else {
        this.filteredAssemblies = this.assemblies;
        this.filteredConstituencies = this.constituencies;
        this.filteredPanchayats = [];
      }
      this.selectedAssembly = "";
      this.selectedConstituency = "";
      this.selectedPanchayat = "";
      this.markAsDirty();
    },
    onDistrictChange() {
      if (this.localBodyType === 'Panchayat') {
        this.filteredAssemblies = this.assemblies.filter(
          a => a.districtId == this.selectedDistrict
        );
        this.filteredConstituencies = this.constituencies.filter(
          c => c.districtId == this.selectedDistrict
        );
        this.filteredPanchayats = this.panchayats.filter(
          p => p.districtId == this.selectedDistrict
        );
      } else {
        this.filteredAssemblies = this.assemblies;
        this.filteredConstituencies = this.constituencies;
        this.filteredPanchayats = [];
      }
      this.selectedAssembly = "";
      this.selectedConstituency = "";
      this.selectedPanchayat = "";
    },
    dmsToDecimal(dms) {
      if (!dms) return NaN;
      if (typeof dms === "number") return dms;
      const str = dms.toString().trim();
      if (/^-?\d+(\.\d+)?$/.test(str)) {
        return parseFloat(str);
      }
      const dmsRegex = /([NSEW])?\s*(\d{1,3})[°\s]+(\d{1,2})['\s]+(\d{1,2}(?:\.\d+)?)["]?\s*([NSEW])?/i;
      const match = str.match(dmsRegex);
      if (match) {
        const dir1 = match[1];
        const degrees = parseFloat(match[2]);
        const minutes = parseFloat(match[3]);
        const seconds = parseFloat(match[4]);
        const dir2 = match[5];
        const direction = (dir1 || dir2 || "N").toUpperCase();
        let decimal = degrees + minutes / 60 + seconds / 3600;
        if (direction === "S" || direction === "W") {
          decimal = -decimal;
        }
        return decimal;
      }
      return parseFloat(str);
    },
    addCropDetail() {
      this.cropTypedetails.push({ cropId: "", count: "", unit: "" });
      this.markAsDirty();
    },
    removeCropDetail(index) {
      this.cropTypedetails.splice(index, 1);
      this.markAsDirty();
    },
    addPropertyDetail() {
      this.propertyTypedetails.push({ propertyType: "", damageDetail: "" });
      this.markAsDirty();
    },
    removePropertyDetail(index) {
      this.propertyTypedetails.splice(index, 1);
      this.markAsDirty();
    },
    addInjuredPerson() {
      this.injuredPeople.push({ name: "", age: "", gender: "", injuryType: "", hospitalized: "", isTribe: "", community: "", forestLocation: "", rfName: "" });
      this.markAsDirty();
    },
    removeInjuredPerson(index) {
      this.injuredPeople.splice(index, 1);
      this.markAsDirty();
    },
    addDeadPerson() {
      this.peopleDead.push({ name: "", age: "", gender: "", isTribe: "", community: "", forestLocation: "", rfName: "" });
      this.markAsDirty();
    },
    removeDeadPerson(index) {
      this.peopleDead.splice(index, 1);
      this.markAsDirty();
    },
    addLivestockDetail() {
      this.livestockanimal.push({ injuryOrDeath: "", typeOfAnimal: "", numberOfAnimals: "" });
      this.markAsDirty();
    },
    removeLivestockDetail(index) {
      this.livestockanimal.splice(index, 1);
      this.markAsDirty();
    },
    addAnimalDeathDetail() {
      this.animalDeathDetailsList.push({ species: "", gender: "", causeOfDeath: "" });
      this.markAsDirty();
    },
    removeAnimalDeathDetail(index) {
      this.animalDeathDetailsList.splice(index, 1);
      this.markAsDirty();
    },
    uploadDoc(event) {
      this.docs1 = event.target.files || event.dataTransfer.files;

      if (this.docs.length < 10) {
        for (let i = 0; i < this.docs1.length; i++) {
          if (this.fileArray.includes(this.docs1[i].name)) {
            this.msg = "Duplicate File";
            this.showSnackBar = true;
          } else {
            const urls = URL.createObjectURL(this.docs1[i]);
            this.displayImage.push(urls);
            this.docs.push(this.docs1[i]);
            console.log("file", this.docs1[i]);
            console.log("haii img", this.docs);
          }
          this.fileArray.push(this.docs1[i].name);
          this.checkbox = false;
          // this.checkbox1 = false;
          this.checkbox3 = false;
          // this.checkbox2 = false;
          this.docs1[i].sizeCopy = this.docs1[i].size + "Bytes";
          if (this.docs1[i].size >= 1024) {
            this.byte = this.docs1[i].size;
            this.kb = this.byte / 1024;
            if (this.kb >= 1024) {
              this.mb = (this.byte / 1048576).toFixed(2);
              if (this.mb >= 1024) {
                this.gb = (this.byte / 1073741824).toFixed(2);
                this.docs1[i].sizeCopy = this.gb + "GB";
              } else {
                this.docs1[i].sizeCopy = this.mb + "MB";
              }
            } else {
              this.docs1[i].sizeCopy = this.kb.toFixed(2) + "KB";
            }
          }
        }
        // this.addToArray();
      } else {
        this.msg = "Maximum 10 can be uploaded";
        this.showSnackBar = true;
      }
    },
    removePrivate(i) {
      this.fileArray = this.fileArray.filter((x) => this.docs[i].name != x);
      this.docs.splice(i, 1);
    },
    panCardUpload(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.panCardImages.push(e.target.result);
        };
        reader.readAsDataURL(files[i]);
      }
      console.log("images", this.panCardImages);
    },
    removeImage(index) {
      this.displayImage.splice(index, 1);
      this.docs.splice(index, 1);
      this.fileArray.splice(index, 1);
    },

    initMap() {
      this.map3 = new google.maps.Map(document.getElementById("mapp"), {
        center: { lat: 10.8505, lng: 76.2711 },
        zoom: 7,
      });
      this.geocoder = new google.maps.Geocoder();
    },
    plotLocation() {
      if (this.locationname) {
        this.locationLoading = true;
        this.geocoder.geocode(
          { address: this.locationname },
          (results, status) => {
            this.locationLoading = false;
            if (status === "OK" && results.length > 0) {
              const location = results[0].geometry.location;
              if (this.isInsideKerala(location.lat(), location.lng())) {
                this.addMarker(location);
                this.map3.setCenter(location);
                this.lattitude = location.lat();
                this.longitude = location.lng();
                this.prevLocation = location;

                // Get district from address_components using helper
                const addressComponents = results[0].address_components;
                const districtName = this.getDistrict(addressComponents);

                // Find the district ID from the districts array
                if (districtName) {
                  const foundDistrict = this.districts.find(
                    d =>
                      d["District Name"].toLowerCase() === districtName.toLowerCase()
                  );
                  if (foundDistrict) {
                    this.selectedDistrict = foundDistrict["District ID"];
                    this.onDistrictChange(); // To update dependent dropdowns
                  }
                }
              } else {
                this.msg = "The location must be inside Kerala.";
                this.showSnackBar = true;
              }
            } else {
              this.msg = "Location not found or Geocode failed: " + status;
              this.showSnackBar = true;
            }
          }
        );
      }
    },

    addMarker(location) {
      // Clear existing marker if any
      if (this.marker) {
        this.marker.setMap(null); // Remove the existing marker from the map
      }

      // Create a new marker
      this.marker = new google.maps.Marker({
        position: location,
        map: this.map3,
        draggable: true, // Make the marker draggable
      });

      // Add event listener for drag end
      google.maps.event.addListener(this.marker, "dragend", (event) => {
        const draggedLocation = event.latLng; // Get the new location
        this.currentLatitude = draggedLocation.lat(); // Update latitude
        this.currentLongitude = draggedLocation.lng(); // Update longitude

        // Fetch district and location name for the new position
        this.fetchDistrict(draggedLocation);
      });
    },

    isInsideKerala(lat, lng) {
      const bounds = this.keralaBounds;
      return (
        lat >= bounds.south &&
        lat <= bounds.north &&
        lng >= bounds.west &&
        lng <= bounds.east
      );
    },
    fetchDistrict(location) {
      // Use the geocoder to fetch district for the new location
      this.locationLoading = true;
      this.geocoder.geocode(
        { location: location },
        (results, status) => {
          this.locationLoading = false;
          if (status === "OK" && results.length > 0) {
            const addressComponents = results[0].address_components;
            const district = this.getDistrict(addressComponents);
            const locationName = results[0].formatted_address; // Get the location name

            // Update the variables with the new values
            this.reportdistrict = district; // Update the district variable
            this.locationname = locationName; // Update the location name variable
            this.lattitude = location.lat(); // Update latitude
            this.longitude = location.lng(); // Update longitude

            if (district) {
              const foundDistrict = this.districts.find(
                (d) =>
                  d["District Name"].toLowerCase() === district.toLowerCase()
              );
              if (foundDistrict) {
                this.selectedDistrict = foundDistrict["District ID"];
                this.onDistrictChange(); // To update dependent dropdowns
              }
            }
          } else {
            this.msg = "Failed to fetch address details for this location: " + status;
            this.showSnackBar = true;
            console.error("Geocode failed: " + status);
          }
        }
      );
    },
    openSavePreview() {
      if (!this.validateBeforeSave()) return;
      this.previewSource = 'save';
      this.showPreview = true;
    },
    openSaveChangesPreview() {
      if (!this.validateBeforeSave()) return;
      this.previewSource = 'saveChanges';
      this.showPreview = true;
    },
    openViewPreview() {
      this.previewSource = 'view';
      this.showPreview = true;
    },
    async handleSaveChanges() {
    if (!this.reportId) {
      this.msg = "No report ID available";
      this.showSnackBar = true;
      return;
    }

    if (!this.validateBeforeSave()) return;

    this.appLoading = true;
    this.saving = true;

    const selectedDistrictObj = this.districts.find(
    district => district["District ID"] === this.selectedDistrict
  );

  const payload = {
    loggedWithACase: true,
    anyDamage: this.anyDamage,
    userthreatlevel: this.threatlevel,
    userremarks: this.remarks,
    informerDetails: this.informerDetails,
    assembly: this.selectedAssembly,
    constituency: this.selectedConstituency,
    localBodyType: this.localBodyType,
    panchayat: this.localBodyType === 'Panchayat' ? this.selectedPanchayat : "",
    municipality: this.localBodyType === 'Municipality' ? this.selectedPanchayat : "",
    corporation: this.localBodyType === 'Corporation' ? this.selectedPanchayat : "",
    isInlocation: false,
    locationname: this.locationname,
    animalId: this.animaltype,
    animalCount: this.animalCount,
    lat: this.lattitude,
    lon: this.longitude,
    incidentDate: this.incidentDate,
    incidentTime: this.incidentTime,
    division: this.divisionname,
    range: this.rangename,
    section_station: this.sectionStation,
    village: this.village,
    taluk: this.taluk,
    district: selectedDistrictObj ? selectedDistrictObj["District Name"] : "",
    proceduresCompleted24hrs: this.proceduresCompleted24hrs,
    ...(this.proceduresCompleted24hrs === "No" && { reason24hrs: this.reason24hrs }),
    conflictTypeId: this.ConflictType,

    // Response team fields
    rrt: this.rrt || "",
    responseRange: this.responseRange || "",
    responseSection: this.responseSection || "",
    responseStation: this.responseStation || "",
    whoResponded: this.whoResponded || "",
    resourceDeployed: this.resourceDeployed || "",
    staffDeployedCount: this.staffDeployedCount ? Number(this.staffDeployedCount) : 0,

    // Conditional sections
    ...(this.isCropDamageSelected && this.cropTypedetails?.length && {
      cropDamageDetails: this.cropTypedetails.map(item => ({
        cropId: item.cropId || "",
        count: item.count || "",
        unit: item.unit || "",
        title: this.cropTitle || ""
      }))
    }),

    ...(this.isPropertyDamageSelected && this.propertyTypedetails?.length && {
      propertyDamageDetails: this.propertyTypedetails.map(item => ({
        propertyType: item.propertyType || "",
        damageDetail: item.damageDetail || "",
        title: this.propertyTitle || ""
      }))
    }),

    ...(this.isHumanInjurySelected && this.injuredPeople?.length && {
      humanInjuryDetails: {
        title: this.humanInjuryTitle || "",
        injuredNumber: Number(this.nopeopleinjured) || this.injuredPeople.length,
        personDetails: this.injuredPeople.map(p => ({
          name: p.name || "",
          age: p.age ? Number(p.age) : 0,
          gender: p.gender || "",
          typeOfInjury: p.injuryType || "",
          isHospitalized: p.hospitalized === "Yes",
          tribeStatus: p.isTribe || "",
          community: p.isTribe === "Yes" ? (p.community || "") : "",
          forestLocation: p.forestLocation || "",
          rfName: p.forestLocation === "Inside" ? (p.rfName || "") : ""
        }))
      }
    }),

    ...(this.isHumanDeathSelected && this.peopleDead?.length && {
      humanDeathDetails: {
        title: this.humanDeathTitle || "",
        numberOfDied: Number(this.nopeopledied) || this.peopleDead.length,
        personDetails: this.peopleDead.map(p => ({
          name: p.name || "",
          age: p.age ? Number(p.age) : 0,
          gender: p.gender || "",
          tribeStatus: p.isTribe || "",
          community: p.isTribe === "Yes" ? (p.community || "") : "",
          forestLocation: p.forestLocation || "",
          rfName: p.forestLocation === "Inside" ? (p.rfName || "") : ""
        }))
      }
    }),

    ...(this.isAnimalInjurySelected && this.animalInjuryDetails && {
      animalInjuryDetails: {
        ...this.animalInjuryDetails,
        title: this.animalInjuryTitle || ""
      }
    }),

    ...(this.isAnimalDeathSelected && this.animalDeathDetailsList?.length && {
      animalDeathDetails: {
        title: this.animalDeathTitle || "",
        numberOfDied: this.animalDeathDetailsList.length,
        animalDeathDetailsList: this.animalDeathDetailsList.map(animal => ({
          species: animal.species || "",
          gender: animal.gender || "",
          causeOfDeath: animal.causeOfDeath || ""
        }))
      }
    }),

    ...(this.isLivestockDepredationSelected && this.livestockanimal?.length && {
      livestockDepredationDetails: this.livestockanimal.map(item => ({
        injuryOrDeath: item.injuryOrDeath || "",
        typeOfAnimal: item.typeOfAnimal || "",
        numberOfAnimals: item.numberOfAnimals || "",
        title: this.livestockTitle || ""
      }))
    })
  };

    try {
      const res = await axios.post(`/deoc_daily_rescue_report/edit/${this.reportId}`, payload, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        }
      });

      if (res.data.status === true) {
        this.hasChanges = false;
        // Optional: update snapshot
        // this.originalFormSnapshot = JSON.parse(JSON.stringify(this.getFormDataObject()));

        this.msg = "Changes saved successfully";
        this.showSnackBar = true;
        this.showPreview = false;
      } else {
        this.msg = res.data.msg || "Failed to save changes";
        this.showSnackBar = true;
      }
    } catch (err) {
      this.msg = "Error saving changes";
      this.showSnackBar = true;
      console.error(err);
    } finally {
    this.saving = false;
    this.appLoading = false;
  }
  },
  async loadExistingReport() {
      if (!this.reportId) return;

      this.appLoading = true;

      try {
        const response = await axios.get(`/deoc_daily_rescue_report/view/${this.reportId}`, {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          }
        });

        if (response.data.status !== true || !response.data.data) {
          this.msg = response.data.msg || "Report not found";
          this.showSnackBar = true;
          this.$router.push({ path: '/officers/daily-reporting-rescue' });
          return;
        }

        const report = response.data.data;

        // ── Basic fields
        this.locationname         = report.locationname || '';
        this.divisionname         = report.division || report.divisionname || '';
        this.rangename            = report.range || report.rangename || '';
        this.sectionStation       = report.section_station || report.sectionStation || '';
        this.localBodyType        = report.localBodyType || '';
        this.selectedPanchayat    = (this.localBodyType === 'Municipality' ? report.municipality : (this.localBodyType === 'Corporation' ? report.corporation : report.panchayat)) || '';
        this.selectedAssembly     = report.assembly || '';
        this.selectedConstituency = report.constituency || '';
        this.lattitude            = report.lat || report.latitude || '';
        this.longitude            = report.lon || report.longitude || '';
        this.village              = report.village || '';
        this.taluk                = report.taluk || '';
        this.incidentDate         = report.incidentDate ? report.incidentDate.split('T')[0] : '';
        this.incidentTime         = report.incidentTime || '';
        this.animaltype           = report.animalId?._id || report.animaltype || '';
        this.animalCount          = report.animalCount || '';
        this.threatlevel          = report.userthreatlevel || report.threatlevel || '';
        this.anyDamage            = report.anyDamage || 'No';
        this.ConflictType         = report.conflictTypeId.map(item => item._id) || [];
        this.proceduresCompleted24hrs = report.proceduresCompleted24hrs || '';
        this.reason24hrs          = report.reason24hrs || '';
        this.remarks              = report.userremarks || report.remarks || '';
        this.informerDetails      = report.informerDetails || '';
        this.rrt                  = report.rrt || '';
        this.responseSection      = report.responseSection || '';
        this.responseStation      = report.responseStation || '';
        this.responseRange        = report.responseRange || '';
        this.whoResponded         = report.whoResponded || '';
        this.resourceDeployed     = report.resourceDeployed || '';
        this.staffDeployedCount   = report.staffDeployedCount || '';

        // ── District: API returns plain string e.g. "Kottayam"
        // Match it to the local districts list to get the numeric District ID
        if (report.district) {
          const foundDistrict = this.districts.find(
            d => d["District Name"].toLowerCase() === report.district.toLowerCase()
          );
          if (foundDistrict) {
            this.selectedDistrict = foundDistrict["District ID"];
            // Populate filtered dropdowns without clearing selections
            if (this.localBodyType === 'Panchayat') {
              this.filteredAssemblies = this.assemblies.filter(a => a.districtId == foundDistrict["District ID"]);
              this.filteredConstituencies = this.constituencies.filter(c => c.districtId == foundDistrict["District ID"]);
              this.filteredPanchayats = this.panchayats.filter(p => p.districtId == foundDistrict["District ID"]);
            } else {
              this.filteredAssemblies = this.assemblies;
              this.filteredConstituencies = this.constituencies;
              this.filteredPanchayats = [];
            }
          } else {
            this.selectedDistrict = report.district;
          }
        }

        // ── Crop Damage Details
        if (report.cropDamageDetails?.length) {
          this.cropTypedetails = report.cropDamageDetails.map(d => ({
            cropId: d.cropId?._id || d.cropId || '',
            count: d.count || '',
            unit: d.unit || 'Acre',
          }));
          this.cropTitle = report.cropDamageDetails[0]?.title || '';
        }

        // ── Property Damage Details
        if (report.propertyDamageDetails?.length) {
          this.propertyTypedetails = report.propertyDamageDetails.map(d => ({
            propertyType: d.propertyType || '',
            damageDetail: d.damageDetail || '',
          }));
          this.propertyTitle = report.propertyDamageDetails[0]?.title || '';
        }

        // ── Human Injury Details
        // API shape: { injuredNumber, title, personDetails: [{ name, age, gender, typeOfInjury, isHospitalized, tribeStatus, community, forestLocation, rfName }] }
        if (report.humanInjuryDetails?.personDetails?.length) {
          const hi = report.humanInjuryDetails;
          this.nopeopleinjured = hi.injuredNumber || hi.personDetails.length;
          this.humanInjuryTitle = hi.title || '';
          this.injuredPeople = hi.personDetails.map(p => ({
            name: p.name || '',
            age: p.age || '',
            gender: p.gender || '',
            injuryType: p.typeOfInjury || '',
            hospitalized: p.isHospitalized === true ? 'Yes' : p.isHospitalized === false ? 'No' : '',
            isTribe: p.tribeStatus || '',
            community: p.community || '',
            forestLocation: p.forestLocation || '',
            rfName: p.rfName || '',
          }));
        }

        // ── Human Death Details
        // API shape: { numberOfDied, title, personDetails: [{ name, age, gender, tribeStatus, community, forestLocation, rfName }] }
        if (report.humanDeathDetails?.personDetails?.length) {
          const hd = report.humanDeathDetails;
          this.nopeopledied = hd.numberOfDied || hd.personDetails.length;
          this.humanDeathTitle = hd.title || '';
          this.peopleDead = hd.personDetails.map(p => ({
            name: p.name || '',
            age: p.age || '',
            gender: p.gender || '',
            isTribe: p.tribeStatus || '',
            community: p.community || '',
            forestLocation: p.forestLocation || '',
            rfName: p.rfName || '',
          }));
        }

        // ── Animal Injury Details
        // API shape: { injuredNumber, typeOfInjury, title }
        if (report.animalInjuryDetails) {
          this.animalInjuryDetails = {
            injuredNumber: report.animalInjuryDetails.injuredNumber || '',
            typeOfInjury: report.animalInjuryDetails.typeOfInjury || '',
          };
          this.animalInjuryTitle = report.animalInjuryDetails.title || '';
        }

        // ── Animal Death Details
        // API shape: { numberOfDied, title, animalDeathDetailsList: [{ species, gender, causeOfDeath }] }
        if (report.animalDeathDetails?.animalDeathDetailsList?.length) {
          const ad = report.animalDeathDetails;
          this.animalDeathTitle = ad.title || '';
          this.animalDeathDetailsList = ad.animalDeathDetailsList.map(a => ({
            species: a.species || '',
            gender: a.gender || '',
            causeOfDeath: a.causeOfDeath || '',
          }));
        }

        // ── Livestock Depredation Details
        // API shape: [{ numberOfAnimals, injuryOrDeath, typeOfAnimal, title }]
        if (report.livestockDepredationDetails?.length) {
          this.livestockanimal = report.livestockDepredationDetails.map(d => ({
            injuryOrDeath: d.injuryOrDeath || '',
            typeOfAnimal: d.typeOfAnimal || '',
            numberOfAnimals: d.numberOfAnimals || '',
          }));
          this.livestockTitle = report.livestockDepredationDetails[0]?.title || '';
        }

        this.hasUnsavedChanges = false;
        this.isSubmitted = report.isFinalSubmit || report.isSubmitted || false;

      } catch (err) {
        console.error("Failed to load report:", err);
        this.msg = "Error loading existing report";
        this.showSnackBar = true;
      } finally {
        this.appLoading = false;
      }
    },
    async saveReport() {          // or rename to saveOrUpdateReport()
      // Your existing validation
      if (!this.validateBeforeSave?.()) return;   // if you have validation

      this.appLoading = true;

      const payload = this.buildPayload();   // ← your existing data preparation logic

      try {
        let response;

        if (this.isEditMode && this.reportId) {
          // UPDATE
          response = await axios.put(
            `/deoc_daily_rescue_report/edit/${this.reportId}`,   // or `/deoc_daily_rescue_report/${this.reportId}`
            payload,
            {
              headers: {
                "x-auth-token": localStorage.getItem("token"),
                "Content-Type": "application/json"
              }
            }
          );
        } else {
          // CREATE (your original code)
          response = await axios.post(
            "/deoc_daily_rescue_report/add",
            payload,
            {
              headers: {
                "x-auth-token": localStorage.getItem("token"),
                "Content-Type": "application/json"
              }
            }
          );

          // After successful create → set id for future updates
          if (response.data.status === true && response.data.data?._id) {
            this.reportId = response.data.data._id;
            this.isEditMode = true;
          }
        }

        if (response.data.status === true) {
          this.msg = this.isEditMode ? "Report updated successfully" : "Report created successfully";
          this.showSnackBar = true;
          this.hasUnsavedChanges = false;

          // Optional: reload data or redirect
          // await this.loadExistingReport();   // to refresh latest state
        } else {
          this.msg = response.data.msg || "Save failed";
          this.showSnackBar = true;
        }
      } catch (err) {
        console.error(err);
        this.msg = "Error saving report";
        this.showSnackBar = true;
      } finally {
        this.appLoading = false;
      }
    },
    updateLocationFromCoordinates() {
      const lat = this.dmsToDecimal(this.lattitude);
      const lng = this.dmsToDecimal(this.longitude);

      if (!isNaN(lat) && !isNaN(lng)) {
        if (this.isInsideKerala(lat, lng)) {
          const location = new google.maps.LatLng(lat, lng);
          this.map3.setCenter(location);
          this.addMarker(location);
          this.fetchDistrict(location);
        } else {
          this.msg = "The location must be inside Kerala.";
          this.showSnackBar = true;
        }
      } else {
        if (this.lattitude || this.longitude) {
          this.msg = "Please enter valid coordinates.";
          this.showSnackBar = true;
        }
      }
    },
    reverseGeocode(location) {
      this.geocoder.geocode({ location: location }, (results, status) => {
        if (status === "OK" && results[0]) {
          const address = results[0].formatted_address;
          this.locationname = address;
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });
    },
    resetMap() {
      // Clear the marker from the map
      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }

      // Clear the fields
      this.lattitude = "";
      this.longitude = "";
      this.locationname = "";
      this.reportdistrict = "";
      this.panCardImages = [];
    },
    toggleSublist(index) {
      this.checkboxItems[index].sublistVisible =
        !this.checkboxItems[index].sublistVisible;
    },
    addMarkers(projects) {
      const infowindow = new google.maps.InfoWindow();

      projects.forEach((project) => {
        project.allLocations.forEach((location) => {
          const lat = location.location[1];
          const lon = location.location[0];
          const locationLatLng = new google.maps.LatLng(lat, lon);

          const marker = new google.maps.Marker({
            position: locationLatLng,
            map: this.map3,
            title: location.place,
            id: project._id,
            icon: project.icon
              ? {
                  url: `https://wtiadmin.in/file/get/${project.icon}`,
                  scaledSize: new google.maps.Size(40, 40),
                }
              : null,
          });
          this.onMarker.push(marker);
          this.newMarker.push({
            id: project._id,
            position: locationLatLng,
          });

          marker.addListener("click", () => {
            const description = project.description
              ? project.description
              : "No description available";
            let content = `
          <div style="max-width: 300px; max-height: 250px; overflow-y: auto;">
            <h3 style="font-size: 16px; justify-content: space-between;">${location.place}</h3>
            <p>${description}</p>
        `;

            if (project.url) {
              content += `<a href="${project.url}" target="_blank">Learn more</a>`;
            }

            content += `</div>`;

            infowindow.setContent(content);
            infowindow.open(this.map3, marker);
          });
        });
      });
    },
    clearMarkers(checkboxId) {
      const isMainCategory = this.checkboxItems.some(
        (item) => item._id === checkboxId
      );
      const isSubCategory = this.checkboxItems.some(
        (item) =>
          item.projects &&
          item.projects.some((subItem) => subItem._id === checkboxId)
      );

      if (isMainCategory || isSubCategory) {
        var Marker = this.newMarker.filter((x) => x.id == checkboxId);
        for (let j = 0; j < Marker.length; j++) {
          for (let i = 0; i < this.onMarker.length; i++) {
            if (this.onMarker[i].id == Marker[j].id) {
              this.onMarker[i].setMap(null);
              this.onMarker.splice(i, 1);
              break;
            }
          }
        }
      }
    },
    clearAllMarkers() {
      for (let i = 0; i < this.onMarker.length; i++) {
        this.onMarker[i].setMap(null);
      }
      this.onMarker = [];
      this.newMarker = [];
    },
    validateForm() {
      let missingFields = [];

      if (!this.locationname) missingFields.push("Location Name");
      if (!this.animaltype) missingFields.push("Type Of Animal");
    //   if (!this.situation) missingFields.push("Situation");
      if (!this.threatlevel) missingFields.push("Threat Level");
      if (!this.remarks) missingFields.push("Remarks");    
      if (this.panCardImages.length === 0)
        missingFields.push("Upload At least one image");

      if (missingFields.length > 0) {
        this.msg =
          "Please fill in the following fields: " + missingFields.join(", ");
        this.showSnackBar = true;
        return false;
      }
      return true;
    },
    getDistrict(addressComponents) {
      for (let component of addressComponents) {
        if (
          component.types.includes("administrative_area_level_2") ||
          component.types.includes("administrative_area_level_3")
        ) {
          return component.long_name.replace(/ district/i, "").trim();
        }
      }
      return null;
    },
    getDivisionData(page = 1) {
      if (this.divisionLoading) return;
      this.divisionLoading = true;
      if (page === 1) {
        this.appLoading = true;
      }
      axios({
        method: "GET",
        url: "/platform/division/getlistdropdown",
        params: {
          count: 50,
          page: page,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            if (page === 1) {
              this.divisionList = response.data.data;
              this.divisionTotalPages = response.data.pages;
              this.divisionPage = 1;
              const matchingDivision = this.divisionList.find(
                (div) => div._id === this.logindivisionid
              );
              if (matchingDivision) {
                this.divisionname = matchingDivision.divisionName;
                this.getRangeData();
              }
            } else {
              this.divisionList.push(...response.data.data);
              this.divisionPage = page;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
          this.divisionLoading = false;
          this.appLoading = false;
        })
        .catch((err) => {
          this.divisionLoading = false;
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    onDivisionIntersect(entries, observer, isIntersecting) {
      if (
        isIntersecting &&
        this.divisionPage < this.divisionTotalPages &&
        !this.divisionLoading
      ) {
        this.getDivisionData(this.divisionPage + 1);
      }
    },
    getRangeData() {
      this.appLoading = true;
      const selectedDivision = this.divisionList.find((div) => div.divisionName === this.divisionname || div._id === this.divisionname);
      const divisionIdToSend = selectedDivision ? selectedDivision._id : this.divisionname;
      axios({
        method: "POST",
        url: "/platform/range/getlistdropdown",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          division: divisionIdToSend,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.rangeList = response.data.data;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    async handleFinalSubmit() {
    if (!this.reportId) {
      this.msg = "No report ID found. Please save first.";
      this.showSnackBar = true;
      return;
    }

    this.submitting = true;
    this.appLoading = true;

    try {
      const res = await axios.post(
        `/deoc_daily_rescue_report/submit/${this.reportId}`,
        {},
        {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          }
        }
      );

      if (res.data.status === true) {
        this.msg = "Report submitted successfully!";
        this.showSnackBar = true;
        // Don't set isSaved to false here, as it causes the button to disappear before redirect
        this.hasChanges = false;

        // Redirect back to the daily reports list
        this.$nextTick(() => {
          this.$router.push({ path: '/officers/daily-report-rescue' });
        });
      } else {
        this.msg = res.data.msg || "Failed to submit report";
        this.showSnackBar = true;
      }
    } catch (err) {
      console.error(err);
      this.msg = "Error submitting report";
      this.showSnackBar = true;
    } finally {
    this.submitting = false;
    this.appLoading = false;
  }
  },
async handleSave() {
  if (!this.validateBeforeSave()) return;

  this.saving = true;

  const selectedDistrictObj = this.districts.find(
    district => district["District ID"] === this.selectedDistrict
  );

  const payload = {
    loggedWithACase: true,
    anyDamage: this.anyDamage,
    userthreatlevel: this.threatlevel,
    userremarks: this.remarks,
    informerDetails: this.informerDetails,
    assembly: this.selectedAssembly,
    constituency: this.selectedConstituency,
    panchayat: this.localBodyType === 'Panchayat' ? this.selectedPanchayat : "",
    municipality: this.localBodyType === 'Municipality' ? this.selectedPanchayat : "",
    corporation: this.localBodyType === 'Corporation' ? this.selectedPanchayat : "",
    localBodyType: this.localBodyType,
    isInlocation: false,
    locationname: this.locationname,
    animalId: this.animaltype,
    animalCount: this.animalCount,
    lat: this.lattitude,
    lon: this.longitude,
    incidentDate: this.incidentDate,
    incidentTime: this.incidentTime,
    division: this.divisionname,
    range: this.rangename,
    section_station: this.sectionStation,
    village: this.village,
    taluk: this.taluk,
    district: selectedDistrictObj ? selectedDistrictObj["District Name"] : "",
    proceduresCompleted24hrs: this.proceduresCompleted24hrs,
    ...(this.proceduresCompleted24hrs === "No" && { reason24hrs: this.reason24hrs }),
    conflictTypeId: this.ConflictType,

    // Response team fields
    rrt: this.rrt || "",
    responseRange: this.responseRange || "",
    responseSection: this.responseSection || "",
    responseStation: this.responseStation || "",
    whoResponded: this.whoResponded || "",
    resourceDeployed: this.resourceDeployed || "",
    staffDeployedCount: this.staffDeployedCount ? Number(this.staffDeployedCount) : 0,

    // Conditional sections
    ...(this.isCropDamageSelected && this.cropTypedetails?.length && {
      cropDamageDetails: this.cropTypedetails.map(item => ({
        cropId: item.cropId || "",
        count: item.count || "",
        unit: item.unit || "",
        title: this.cropTitle || ""
      }))
    }),

    ...(this.isPropertyDamageSelected && this.propertyTypedetails?.length && {
      propertyDamageDetails: this.propertyTypedetails.map(item => ({
        propertyType: item.propertyType || "",
        damageDetail: item.damageDetail || "",
        title: this.propertyTitle || ""
      }))
    }),

    ...(this.isHumanInjurySelected && this.injuredPeople?.length && {
      humanInjuryDetails: {
        title: this.humanInjuryTitle || "",
        injuredNumber: Number(this.nopeopleinjured) || this.injuredPeople.length,
        personDetails: this.injuredPeople.map(p => ({
          name: p.name || "",
          age: p.age ? Number(p.age) : 0,
          gender: p.gender || "",
          typeOfInjury: p.injuryType || "",
          isHospitalized: p.hospitalized === "Yes",
          tribeStatus: p.isTribe || "",
          community: p.isTribe === "Yes" ? (p.community || "") : "",
          forestLocation: p.forestLocation || "",
          rfName: p.forestLocation === "Inside" ? (p.rfName || "") : ""
        }))
      }
    }),

    ...(this.isHumanDeathSelected && this.peopleDead?.length && {
      humanDeathDetails: {
        title: this.humanDeathTitle || "",
        numberOfDied: Number(this.nopeopledied) || this.peopleDead.length,
        personDetails: this.peopleDead.map(p => ({
          name: p.name || "",
          age: p.age ? Number(p.age) : 0,
          gender: p.gender || "",
          tribeStatus: p.isTribe || "",
          community: p.isTribe === "Yes" ? (p.community || "") : "",
          forestLocation: p.forestLocation || "",
          rfName: p.forestLocation === "Inside" ? (p.rfName || "") : ""
        }))
      }
    }),

    ...(this.isAnimalInjurySelected && this.animalInjuryDetails && {
      animalInjuryDetails: {
        ...this.animalInjuryDetails,
        title: this.animalInjuryTitle || ""
      }
    }),

    ...(this.isAnimalDeathSelected && this.animalDeathDetailsList?.length && {
      animalDeathDetails: {
        title: this.animalDeathTitle || "",
        numberOfDied: this.animalDeathDetailsList.length,
        animalDeathDetailsList: this.animalDeathDetailsList.map(animal => ({
          species: animal.species || "",
          gender: animal.gender || "",
          causeOfDeath: animal.causeOfDeath || ""
        }))
      }
    }),

    ...(this.isLivestockDepredationSelected && this.livestockanimal?.length && {
      livestockDepredationDetails: this.livestockanimal.map(item => ({
        injuryOrDeath: item.injuryOrDeath || "",
        typeOfAnimal: item.typeOfAnimal || "",
        numberOfAnimals: item.numberOfAnimals || "",
        title: this.livestockTitle || ""
      }))
    })
  };

  this.appLoading = true;
  this.saving = true;

  try {
    let response;

    if (this.isEditMode && this.reportId) {
      // ── EDIT MODE: update the existing report
      response = await axios.post(
        `/deoc_daily_rescue_report/edit/${this.reportId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": localStorage.getItem("token"),
          }
        }
      );
    } else {
      // ── NEW MODE: create a fresh report
      response = await axios.post(
        "/deoc_daily_rescue_report/add",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": localStorage.getItem("token"),
          }
        }
      );
    }

    if (response.data.status === true) {
      if (!this.isEditMode) {
        // Store the new ID returned after creation
        this.reportId = response.data.id || response.data.data?._id;
        if (!this.reportId) {
          throw new Error("Report was saved but no ID was returned");
        }
        this.isEditMode = true;
      }
      this.isSaved = true;
      this.hasChanges = false;
      this.msg = this.isEditMode
        ? "Changes saved successfully! You can now submit."
        : "Report saved successfully! You can now review and click SUBMIT.";
      this.showSnackBar = true;
      this.showPreview = false;
    } else {
      this.msg = response.data.msg || "Failed to save report";
      this.showSnackBar = true;
    }
  } catch (err) {
    console.error("Error saving report:", err);
    this.msg = err.response?.data?.msg || "Error while saving report. Please try again.";
    this.showSnackBar = true;
  } finally {
  this.saving = false;
  this.appLoading = false;
}
},
  validateBeforeSave() {
let missingFields = [];
      if (!this.locationname) missingFields.push("Location Name");
      if (!this.localBodyType) missingFields.push("Choose Local Body");
      if (!this.selectedDistrict) missingFields.push("District");
      if (!this.selectedPanchayat) missingFields.push(this.localBodyType);
      if (!this.selectedAssembly) missingFields.push("Assembly");
      if (!this.selectedConstituency) missingFields.push("Constituency");
      if (!this.lattitude) missingFields.push("Latitude");
      if (!this.longitude) missingFields.push("Longitude");
      if (!this.incidentDate) missingFields.push("Incident Date");
      if (!this.incidentTime) missingFields.push("Incident Time");
      if (!this.divisionname) missingFields.push("Division Name");
      if (!this.rangename) missingFields.push("Range Name");
      if (!this.sectionStation) missingFields.push("Section/Station");
      if (!this.village) missingFields.push("Village");
      if (!this.animaltype) missingFields.push("Type Of Animal");
      if (!this.animalCount) missingFields.push("Number of animals involved");
      if (!this.threatlevel) missingFields.push("Threat Level");
      if (!this.remarks) missingFields.push("Remarks");
      if (!this.proceduresCompleted24hrs) missingFields.push("Whether Procedures Completed in 24hrs");
      if (this.proceduresCompleted24hrs === "No" && !this.reason24hrs) missingFields.push("Reason for not completing in 24hrs");

      if (missingFields.length > 0) {
        this.msg = "Please fill in the following fields: " + missingFields.join(", ");
        this.showSnackBar = true;
        return;
      }

      if (parseInt(this.animalCount) < 1) {
        this.msg = "Number of animals involved should be greater than or equal to 1";
        this.showSnackBar = true;
        return;
      }
    return true;
  },
    handleSubmit() {
      // Collect all required fields
      let missingFields = [];
      if (!this.locationname) missingFields.push("Location Name");
      if (!this.localBodyType) missingFields.push("Choose Local Body");
      if (!this.selectedDistrict) missingFields.push("District");
      if (!this.selectedPanchayat) missingFields.push(this.localBodyType);
      if (!this.selectedAssembly) missingFields.push("Assembly");
      if (!this.selectedConstituency) missingFields.push("Constituency");
      if (!this.lattitude) missingFields.push("Latitude");
      if (!this.longitude) missingFields.push("Longitude");
      if (!this.incidentDate) missingFields.push("Incident Date");
      if (!this.incidentTime) missingFields.push("Incident Time");
      if (!this.divisionname) missingFields.push("Division Name");
      if (!this.rangename) missingFields.push("Range Name");
      if (!this.sectionStation) missingFields.push("Section/Station");
      if (!this.village) missingFields.push("Village");
      if (!this.animaltype) missingFields.push("Type Of Animal");
      if (!this.animalCount) missingFields.push("Number of animals involved");
      if (!this.threatlevel) missingFields.push("Threat Level");
      if (!this.remarks) missingFields.push("Remarks");
      if (!this.proceduresCompleted24hrs) missingFields.push("Whether Procedures Completed in 24hrs");
      if (this.proceduresCompleted24hrs === "No" && !this.reason24hrs) missingFields.push("Reason for not completing in 24hrs");

      if (missingFields.length > 0) {
        this.msg = "Please fill in the following fields: " + missingFields.join(", ");
        this.showSnackBar = true;
        return;
      }

      if (parseInt(this.animalCount) < 1) {
        this.msg = "Number of animals involved should be greater than or equal to 1";
        this.showSnackBar = true;
        return;
      }

      // Build the plain object
      const selectedDistrictObj = this.districts.find(
        district => district["District ID"] === this.selectedDistrict
      );

      const data = {
        loggedWithACase: true,
        anyDamage: this.anyDamage,
        userthreatlevel: this.threatlevel,
        userremarks: this.remarks,
        informerDetails: this.informerDetails,
        assembly: this.selectedAssembly,
        constituency: this.selectedConstituency,
        panchayat: this.localBodyType === 'Panchayat' ? this.selectedPanchayat : "",
        municipality: this.localBodyType === 'Municipality' ? this.selectedPanchayat : "",
        corporation: this.localBodyType === 'Corporation' ? this.selectedPanchayat : "",
        localBodyType: this.localBodyType,
        isInlocation: false,
        locationname: this.locationname,
        animalId: this.animaltype,
        animalCount: this.animalCount,
        lat: this.lattitude,
        lon: this.longitude,
        incidentDate: this.incidentDate,
        incidentTime: this.incidentTime,
        division: this.divisionname,
        range: this.rangename,
        section_station: this.sectionStation,
        village: this.village,
        taluk: this.taluk,
        taluk: this.taluk,
        district: selectedDistrictObj ? selectedDistrictObj["District Name"] : "",
        proceduresCompleted24hrs: this.proceduresCompleted24hrs,
        conflictTypeId: this.ConflictType,
        rrt: this.rrt,
        responseRange: this.responseRange,
        responseSection: this.responseSection,
        responseStation: this.responseStation,
        whoResponded: this.whoResponded,
        resourceDeployed: this.resourceDeployed,
        staffDeployedCount: this.staffDeployedCount,
      };

      // Only add reason24hrs if proceduresCompleted24hrs is "No"
      if (this.proceduresCompleted24hrs === "No") {
        data.reason24hrs = this.reason24hrs;
      }

      // Attach conflict-type specific details
      if (this.isCropDamageSelected && this.cropTypedetails.length) {
        data.cropDamageDetails = this.cropTypedetails.map(item => ({...item, title: this.cropTitle}));
      }
      if (this.isPropertyDamageSelected && this.propertyTypedetails.length) {
        data.propertyDamageDetails = this.propertyTypedetails.map(item => ({...item, title: this.propertyTitle}));
      }
      if (this.isHumanInjurySelected && this.injuredPeople.length) {
        data.humanInjuryDetails = {
          title: this.humanInjuryTitle,
          injuredNumber: this.nopeopleinjured || this.injuredPeople.length,
          personDetails: this.injuredPeople.map((p) => ({
            name: p.name || "",
            age: p.age ? parseInt(p.age, 10) : 0,
            gender: p.gender || "",
            typeOfInjury: p.injuryType || "",
            isHospitalized: p.hospitalized === "Yes" ? true : p.hospitalized === "No" ? false : false,
            tribeStatus: p.isTribe || "",
            community: p.isTribe === "Yes" ? p.community : "",
            forestLocation: p.forestLocation || "",
            rfName: p.forestLocation === "Inside" ? p.rfName : "",
          }))
        };
      }
      if (this.isHumanDeathSelected && this.peopleDead.length) {
        data.humanDeathDetails = {
          title: this.humanDeathTitle,
          numberOfDied: this.nopeopledied || this.peopleDead.length,
          personDetails: this.peopleDead.map((p) => ({
            name: p.name || "",
            age: p.age ? parseInt(p.age, 10) : 0,
            gender: p.gender || "",
            tribeStatus: p.isTribe || "",
            community: p.isTribe === "Yes" ? p.community : "",
            forestLocation: p.forestLocation || "",
            rfName: p.forestLocation === "Inside" ? p.rfName : "",
          }))
        };
      }
      if (
        this.isAnimalInjurySelected &&
        (this.animalInjuryDetails.injuredNumber || this.animalInjuryDetails.typeOfInjury)
      ) {
        data.animalInjuryDetails = { ...this.animalInjuryDetails, title: this.animalInjuryTitle };
      }
      if (this.isAnimalDeathSelected && this.animalDeathDetailsList.length) {
        data.animalDeathDetails = {
          title: this.animalDeathTitle,
          numberOfDied: this.animalDeathDetailsList.length,
          animalDeathDetailsList: this.animalDeathDetailsList
        };
      }
      if (this.isLivestockDepredationSelected && this.livestockanimal.length) {
        data.livestockDepredationDetails = this.livestockanimal.map(item => ({...item, title: this.livestockTitle}));
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/deoc_daily_rescue_report/add",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
        data: JSON.stringify(data),
      })
        .then((response) => {
          if (response.data.status == true) {
            this.msg = "Daily Report Added successfully!";
            this.showSnackBar = true;
            this.appLoading = false;
            this.threatlevel = "";
            this.locationname = "";
            this.animaltype = "";
            this.lattitude = "";
            this.longitude = "";
            this.time = "";
            this.displayImage = "";
            if (this.marker) {
              this.marker.setMap(null);
              this.marker = null;
            }
            window.location.reload();
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getcroptypeData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/crop/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.Typeofcrops = response.data.data;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getanimalData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/animal/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.animalTypes = response.data.data;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getconflicttypeData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/conflicttype/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.ConflictTypes = response.data.data;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    // getscenarioData() {
    //   this.appLoading = true;
    //   axios({
    //     method: "GET",
    //     url: "/scenario/list",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       if (response.data.status == true) {
    //         {
    //           this.situations = response.data.data;
    //           this.appLoading = false;
    //         }
    //       } else {
    //         this.msg = response.data.msg;
    //         this.showSnackBar = true;
    //         this.appLoading = false;
    //       }
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },
  },
};
</script>

<style>
#mapp {
  height: 577px !important;
  width: 100%;
}

.uploaded-image {
  position: relative;
  display: inline-block;
  margin-right: 10px;
}

.uploaded-image img {
  max-width: 100%;
  max-height: 200px;
}

.uploaded-image v-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(255, 255, 255, 0.8);
}

.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
